var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _g2, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _g3, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _g4, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingPagerevisedillustration1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 555,
    viewBox: "0 0 1440 555",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f_811_11692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.829 465.752V508.898H387.389V520.455H383.659V537.406H363.109V549.863H361.28V537.406H357.255V553H355.427V537.406H342.436V508.898H335.725V465.752H329.972V387.163H401.874V465.752H397.829Z",
    fill: "url(#paint0_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M348.983 534.203H346.132V528.939H348.983V534.203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M356.019 534.203H353.168V528.939H356.019V534.203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M363.051 534.203H360.2V528.939H363.051V534.203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M370.091 534.203H367.24V528.939H370.091V534.203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M348.983 525.436H346.132V520.172H348.983V525.436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M356.019 525.436H353.168V520.172H356.019V525.436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M363.051 525.436H360.2V520.172H363.051V525.436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M370.091 525.436H367.24V520.172H370.091V525.436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M348.983 516.669H346.132V511.405H348.983V516.669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M356.019 516.669H353.168V511.405H356.019V516.669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M378.072 534.203H375.221V528.939H378.072V534.203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.283 470.082H301.424V379.929H361.283V470.082Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.403 473.18H307.306V458.165H355.403V473.18Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.923 468.195H296.784V467.141H365.923V468.195Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M306.132 464.113H304.681V458.557H306.132V464.113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M311.134 464.113H309.683V458.557H311.134V464.113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M316.132 464.113H314.681V458.557H316.132V464.113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M321.13 464.113H319.679V458.557H321.13V464.113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M326.131 464.113H324.681V458.557H326.131V464.113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M331.129 464.113H329.679V458.557H331.129V464.113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M336.131 464.113H334.68V458.557H336.131V464.113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M341.129 464.113H339.678V458.557H341.129V464.113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M346.13 464.113H344.68V458.557H346.13V464.113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M351.129 464.113H349.678V458.557H351.129V464.113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M356.126 464.113H354.676V458.557H356.126V464.113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M306.132 456.378H304.681V450.821H306.132V456.378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M311.134 456.378H309.683V450.821H311.134V456.378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M316.132 456.378H314.681V450.822H316.132V456.378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M321.13 456.378H319.679V450.821H321.13V456.378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M326.131 456.378H324.681V450.821H326.131V456.378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M331.129 456.378H329.679V450.822H331.129V456.378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M336.131 456.378H334.68V450.821H336.131V456.378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M341.129 456.378H339.678V450.821H341.129V456.378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M346.13 456.378H344.68V450.821H346.13V456.378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M351.129 456.378H349.678V450.821H351.129V456.378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M356.126 456.378H354.676V450.821H356.126V456.378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M306.132 448.642H304.681V443.086H306.132V448.642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M311.134 448.642H309.683V443.086H311.134V448.642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M316.132 448.642H314.681V443.086H316.132V448.642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M321.13 448.642H319.679V443.086H321.13V448.642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M326.131 448.642H324.681V443.086H326.131V448.642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M331.129 448.642H329.679V443.086H331.129V448.642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M336.131 448.642H334.68V443.086H336.131V448.642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M341.129 448.642H339.678V443.086H341.129V448.642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M346.13 448.642H344.68V443.086H346.13V448.642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M351.129 448.642H349.678V443.086H351.129V448.642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M356.126 448.642H354.676V443.086H356.126V448.642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M321.13 440.907H319.679V435.351H321.13V440.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M326.131 440.907H324.681V435.351H326.131V440.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M331.129 440.907H329.679V435.351H331.129V440.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M336.131 440.907H334.68V435.351H336.131V440.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M341.129 440.907H339.678V435.351H341.129V440.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M346.13 440.907H344.68V435.351H346.13V440.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M351.129 440.907H349.678V435.351H351.129V440.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M356.126 440.907H354.676V435.351H356.126V440.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M326.131 432.742H324.681V427.186H326.131V432.742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M331.129 432.742H329.679V427.186H331.129V432.742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M336.131 432.742H334.68V427.186H336.131V432.742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M341.129 432.742H339.678V427.186H341.129V432.742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M346.13 432.742H344.68V427.186H346.13V432.742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M351.129 432.742H349.678V427.186H351.129V432.742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M356.126 432.742H354.676V427.186H356.126V432.742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.362 440.384V479.552H784.982V490.044H788.777V505.432H809.681V505.414H811.541V505.432H815.636V519.588H817.496V505.432H830.711V479.552H837.538V440.384H843.39V369.042H770.247V440.384H774.362Z",
    fill: "url(#paint1_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M824.052 502.524H826.952V497.745H824.052V502.524Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M816.89 502.524H819.79V497.745H816.89V502.524Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M809.739 502.524H812.64V497.745H809.739V502.524Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M802.578 502.524H805.478V497.745H802.578V502.524Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M824.052 494.565H826.952V489.787H824.052V494.565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M816.89 494.565H819.79V489.787H816.89V494.565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M809.739 494.565H812.64V489.787H809.739V494.565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M802.578 494.565H805.478V489.787H802.578V494.565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M824.052 486.607H826.952V481.828H824.052V486.607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M816.89 486.607H819.79V481.828H816.89V486.607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M794.46 502.524H797.36V497.745H794.46V502.524Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446.07 358.756H-6.02478V342.333H1446.07V358.756Z",
    fill: "#69ABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446.07 360.455H-7V347.996H1446.07V360.455Z",
    fill: "#003940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1446.07 359.323H-3.09912V349.129H1446.07V359.323Z",
    fill: "#003940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.498 354.737H336.09V353.379H371.498V354.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.29 354.737H267.882V353.379H303.29V354.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.703 354.737H404.294V353.379H439.703V354.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.915 354.737H472.506V353.379H507.915V354.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.87 354.737H131.462V353.379H166.87V354.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.082 354.737H199.674V353.379H235.082V354.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6655 354.737H63.2576V353.379H98.6655V354.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4564 354.737H-3.22864V353.379H30.4564V354.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.751 354.737H745.339V353.379H780.751V354.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.234 354.737H813.551V353.379H847.234V354.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.075 354.737H880.391V353.379H914.075V354.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.588 354.737H938.904V353.379H972.588V354.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031.1 354.737H997.417V353.379H1031.1V354.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1089.61 354.737H1055.93V353.379H1089.61V354.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.13 354.737H1114.44V353.379H1148.13V354.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.64 354.737H1172.96V353.379H1206.64V354.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1265.15 354.737H1231.47V353.379H1265.15V354.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1323.67 354.737H1289.98V353.379H1323.67V354.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1382.18 354.737H1348.5V353.379H1382.18V354.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440.69 354.737H1407.01V353.379H1440.69V354.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.122 354.737H540.714V353.379H576.122V354.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.331 354.737H608.922V353.379H644.331V354.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.539 354.737H677.134V353.379H712.539V354.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.142 525.201L250.515 529.698L255.955 543.665L257.908 529.935L254.142 525.201Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.116 524.175L257.907 520.94L282.18 514.706L263.626 524.175H255.116Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.104 516.284L251.771 521.097L254.213 524.175L248.285 524.806L226.104 516.284Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.049 523.309H253.375V484.841H255.049V523.309Z",
    fill: "#003940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.908 524.174C257.908 523.886 257.806 523.611 257.618 523.361C257.057 522.61 255.744 522.083 254.212 522.083C252.17 522.083 250.515 523.019 250.515 524.174C250.515 525.329 252.17 526.266 254.212 526.266C256.253 526.266 257.908 525.33 257.908 524.174Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.053 454.023L802.423 458.521L807.869 472.488L809.818 458.757L806.053 454.023Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.029 452.997L809.815 449.762L834.088 443.528L815.535 452.997H807.029Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.012 445.107L803.679 449.92L806.117 452.997L800.189 453.629L778.012 445.107Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.955 452.132H805.28V413.664H806.955V452.132Z",
    fill: "#003940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.818 452.997C809.818 452.708 809.717 452.433 809.53 452.183C808.967 451.433 807.654 450.906 806.12 450.906C804.077 450.906 802.423 451.842 802.423 452.997C802.423 454.152 804.077 455.088 806.12 455.088C808.163 455.088 809.818 454.152 809.818 452.997Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.745 477.744L519.957 481.201L524.138 491.935L525.64 481.383L522.745 477.744Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.496 476.955L525.64 474.469L544.296 469.677L530.035 476.955H523.496Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.195 470.891L520.922 474.59L522.799 476.955L518.243 477.441L501.195 470.891Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.441 476.29H522.155V446.725H523.441V476.29Z",
    fill: "#003940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.64 476.955C525.64 476.733 525.561 476.521 525.417 476.329C524.985 475.753 523.975 475.348 522.799 475.348C521.229 475.348 519.957 476.067 519.957 476.955C519.957 477.842 521.229 478.562 522.799 478.562C524.367 478.562 525.64 477.843 525.64 476.955Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.546 490.472H233.715V386.275H271.546V490.472Z",
    fill: "url(#paint2_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.362 497.941H239.894V454.155H265.362V497.941Z",
    fill: "url(#paint3_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.693 502.68H245.566V478.392H259.693V502.68Z",
    fill: "url(#paint4_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.441 490.199H247.814V506.751H251.287H254.729H257.441V490.199Z",
    fill: "url(#paint5_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.993 497.407H250.949V513.959H251.326H251.699H251.993V497.407Z",
    fill: "url(#paint6_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.309 503.129H253.265V519.681H253.641H254.015H254.309V503.129Z",
    fill: "url(#paint7_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.555 490.738H232.705V489.629H272.555V490.738Z",
    fill: "url(#paint8_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.292 498.475H238.964V497.407H266.292V498.475Z",
    fill: "url(#paint9_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.286 503.129H244.538V502.309H260.286V503.129Z",
    fill: "url(#paint10_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M243.421 496.165H242.237V491.576H243.421V496.165Z",
    fill: "url(#paint11_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M246.697 496.165H245.513V491.576H246.697V496.165Z",
    fill: "url(#paint12_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M249.974 496.165H248.789V491.576H249.974V496.165Z",
    fill: "url(#paint13_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M253.249 496.165H252.065V491.576H253.249V496.165Z",
    fill: "url(#paint14_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M256.526 496.165H255.341V491.576H256.526V496.165Z",
    fill: "url(#paint15_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M259.802 496.165H258.617V491.576H259.802V496.165Z",
    fill: "url(#paint16_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M263.078 496.165H261.893V491.576H263.078V496.165Z",
    fill: "url(#paint17_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.894 486.317H237.033V480.873H239.894V486.317Z",
    fill: "url(#paint18_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M245.558 486.317H242.698V480.873H245.558V486.317Z",
    fill: "url(#paint19_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.227 486.317H248.366V480.873H251.227V486.317Z",
    fill: "url(#paint20_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.891 486.317H254.031V480.873H256.891V486.317Z",
    fill: "url(#paint21_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.561 486.317H259.699V480.873H262.561V486.317Z",
    fill: "url(#paint22_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.224 486.317H265.364V480.873H268.224V486.317Z",
    fill: "url(#paint23_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.894 477.832H237.033V472.389H239.894V477.832Z",
    fill: "url(#paint24_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.558 477.832H242.698V472.389H245.558V477.832Z",
    fill: "url(#paint25_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.227 477.832H248.366V472.389H251.227V477.832Z",
    fill: "url(#paint26_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M256.891 477.832H254.031V472.389H256.891V477.832Z",
    fill: "url(#paint27_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.561 477.832H259.699V472.389H262.561V477.832Z",
    fill: "url(#paint28_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.224 477.832H265.364V472.389H268.224V477.832Z",
    fill: "url(#paint29_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.894 469.347H237.033V463.903H239.894V469.347Z",
    fill: "url(#paint30_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.558 469.347H242.698V463.903H245.558V469.347Z",
    fill: "url(#paint31_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.227 469.347H248.366V463.903H251.227V469.347Z",
    fill: "url(#paint32_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.891 469.347H254.031V463.903H256.891V469.347Z",
    fill: "url(#paint33_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M262.561 469.347H259.699V463.903H262.561V469.347Z",
    fill: "url(#paint34_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M268.224 469.347H265.364V463.903H268.224V469.347Z",
    fill: "url(#paint35_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M239.894 460.862H237.033V455.419H239.894V460.862Z",
    fill: "url(#paint36_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.558 460.862H242.698V455.419H245.558V460.862Z",
    fill: "url(#paint37_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.227 460.862H248.366V455.419H251.227V460.862Z",
    fill: "url(#paint38_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.891 460.862H254.031V455.419H256.891V460.862Z",
    fill: "url(#paint39_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.561 460.862H259.699V455.419H262.561V460.862Z",
    fill: "url(#paint40_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.224 460.862H265.364V455.419H268.224V460.862Z",
    fill: "url(#paint41_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.894 452.377H237.033V446.933H239.894V452.377Z",
    fill: "url(#paint42_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M245.558 452.377H242.698V446.933H245.558V452.377Z",
    fill: "url(#paint43_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.227 452.377H248.366V446.933H251.227V452.377Z",
    fill: "url(#paint44_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M256.891 452.377H254.031V446.933H256.891V452.377Z",
    fill: "url(#paint45_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.561 452.377H259.699V446.933H262.561V452.377Z",
    fill: "url(#paint46_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.224 452.377H265.364V446.933H268.224V452.377Z",
    fill: "url(#paint47_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.894 443.892H237.033V438.449H239.894V443.892Z",
    fill: "url(#paint48_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.558 443.892H242.698V438.449H245.558V443.892Z",
    fill: "url(#paint49_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.227 443.892H248.366V438.449H251.227V443.892Z",
    fill: "url(#paint50_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.891 443.892H254.031V438.449H256.891V443.892Z",
    fill: "url(#paint51_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.561 443.892H259.699V438.449H262.561V443.892Z",
    fill: "url(#paint52_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M268.224 443.892H265.364V438.449H268.224V443.892Z",
    fill: "url(#paint53_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.894 435.408H237.033V429.964H239.894V435.408Z",
    fill: "url(#paint54_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M245.558 435.408H242.698V429.964H245.558V435.408Z",
    fill: "url(#paint55_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M251.227 435.408H248.366V429.964H251.227V435.408Z",
    fill: "url(#paint56_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.891 435.408H254.031V429.964H256.891V435.408Z",
    fill: "url(#paint57_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.561 435.408H259.699V429.964H262.561V435.408Z",
    fill: "url(#paint58_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.224 435.408H265.364V429.964H268.224V435.408Z",
    fill: "url(#paint59_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.894 426.923H237.033V421.479H239.894V426.923Z",
    fill: "url(#paint60_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.558 426.923H242.698V421.479H245.558V426.923Z",
    fill: "url(#paint61_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.227 426.923H248.366V421.479H251.227V426.923Z",
    fill: "url(#paint62_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.891 426.923H254.031V421.479H256.891V426.923Z",
    fill: "url(#paint63_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M262.561 426.923H259.699V421.479H262.561V426.923Z",
    fill: "url(#paint64_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.224 426.923H265.364V421.479H268.224V426.923Z",
    fill: "url(#paint65_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.894 418.438H237.033V412.994H239.894V418.438Z",
    fill: "url(#paint66_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M245.558 418.438H242.698V412.994H245.558V418.438Z",
    fill: "url(#paint67_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.227 418.438H248.366V412.994H251.227V418.438Z",
    fill: "url(#paint68_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.891 418.438H254.031V412.994H256.891V418.438Z",
    fill: "url(#paint69_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.561 418.438H259.699V412.994H262.561V418.438Z",
    fill: "url(#paint70_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.224 418.438H265.364V412.994H268.224V418.438Z",
    fill: "url(#paint71_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.894 409.953H237.033V404.509H239.894V409.953Z",
    fill: "url(#paint72_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.558 409.953H242.698V404.509H245.558V409.953Z",
    fill: "url(#paint73_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.227 409.953H248.366V404.509H251.227V409.953Z",
    fill: "url(#paint74_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M256.891 409.953H254.031V404.509H256.891V409.953Z",
    fill: "url(#paint75_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.561 409.953H259.699V404.509H262.561V409.953Z",
    fill: "url(#paint76_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M268.224 409.953H265.364V404.509H268.224V409.953Z",
    fill: "url(#paint77_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M239.894 401.468H237.033V396.025H239.894V401.468Z",
    fill: "url(#paint78_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.558 401.468H242.698V396.025H245.558V401.468Z",
    fill: "url(#paint79_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M251.227 401.468H248.366V396.025H251.227V401.468Z",
    fill: "url(#paint80_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.891 401.468H254.031V396.025H256.891V401.468Z",
    fill: "url(#paint81_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.561 401.468H259.699V396.025H262.561V401.468Z",
    fill: "url(#paint82_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.224 401.468H265.364V396.025H268.224V401.468Z",
    fill: "url(#paint83_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.654 486.508H123.839V398.731H184.654V486.508Z",
    fill: "url(#paint84_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.385 488.018H122.113V485.537H186.385V488.018Z",
    fill: "url(#paint85_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.611 491.193H125.885V479.4H182.611V491.193Z",
    fill: "url(#paint86_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.691 496.018H130.228V483.134H152.691V496.018Z",
    fill: "url(#paint87_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.227 492.387H130.228V499.169H139.55L143.227 492.387Z",
    fill: "url(#paint88_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.726 504.799H135.466V489.691H136.726V504.799Z",
    fill: "url(#paint89_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.227 505.582C137.227 505.15 136.72 504.799 136.095 504.799C135.47 504.799 134.963 505.15 134.963 505.582C134.963 506.014 135.469 506.366 136.095 506.366C136.72 506.365 137.227 506.014 137.227 505.582Z",
    fill: "url(#paint90_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.262 392.05H621.694L613.387 521.105L688.262 510.35V392.05Z",
    fill: "url(#paint91_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.236 393.649H38.8466V380.56H834.236V393.649Z",
    fill: "url(#paint92_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.037 383.767H471.817L485.54 432.569H507.037V383.767Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.436 381.866H10.3101V361.226H845.436V381.866Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.174 474.075V495.7H466.865V503.933H460.815V510.849H458.692V522.705H458.143V510.849H456.019V503.933H449.969V495.7H438.747V474.075H436.414V434.813H419.014V390.056H436.414H453.815H480.42V474.075H478.174Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.168 449.233H488.43V448.545H490.907V384.498H540.691V448.545H543.168V449.233Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.558 433.28H245.025V379.929H293.558V433.28Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.717 405.946H154.25V379.929H237.717V405.946Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.311 464.072H198.988V400.183H217.311V464.072Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.985 481.115H203.034V446.371H203.985V481.115Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.078 478.481H206.127V443.737H207.078V478.481Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.602 468.024H200.401V459.462H211.602V468.024Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.334 423.73H234.446V379.93H266.334V423.73Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.783 425.458H290.579V379.929H318.783V425.458Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.932 427.188H88.5675V379.93H120.932V427.188Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.53 440.032H99.0397V379.929H163.53V440.032Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.195 442.337H95.2759V440.031H165.195V442.337Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.235 448.594H101.893V436.409H130.235V448.594Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.251 448.594H139.492V441.184H144.251V448.594Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.248 448.594H149.012V441.184H154.248V448.594Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.748 398.207H70.9565V379.929H104.748V398.207Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1956 405.946H58.1948V379.929H74.1956V405.946Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1943 389.068H38.8466V379.929H66.1943V389.068Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.382 400.183H355.404V379.93H692.382V400.183Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.474 456.248C663.352 456.248 661.612 455.119 661.44 453.682L656.698 453.789C656.71 454.11 656.717 454.432 656.717 454.755C656.717 458.839 655.698 462.815 653.746 466.544L657.708 467.554C658.331 466.559 659.759 465.864 661.424 465.864C663.661 465.864 665.474 467.119 665.474 468.666C665.474 470.213 663.661 471.468 661.424 471.468C659.188 471.468 657.375 470.213 657.375 468.666C657.375 468.38 657.437 468.105 657.552 467.845L653.591 466.836C651.335 471.025 647.892 474.896 643.384 478.25L646.485 480.259C647.211 479.779 648.195 479.483 649.28 479.483C651.517 479.483 653.33 480.738 653.33 482.285C653.33 483.833 651.517 485.087 649.28 485.087C647.045 485.087 645.231 483.833 645.231 482.285C645.231 481.6 645.587 480.973 646.177 480.486L643.077 478.475C642.757 478.708 642.433 478.94 642.103 479.168C637.408 482.416 631.943 484.937 625.993 486.65L627.698 489.523C628.085 489.438 628.497 489.392 628.924 489.392C631.16 489.392 632.974 490.647 632.974 492.194C632.974 493.741 631.16 494.996 628.924 494.996C626.688 494.996 624.875 493.741 624.875 492.194C624.875 491.052 625.862 490.071 627.278 489.634L625.576 486.767C620.253 488.26 614.548 489.109 608.665 489.256L608.85 493.184C608.892 493.183 608.935 493.182 608.978 493.182C611.214 493.182 613.027 494.436 613.027 495.984C613.027 497.531 611.214 498.786 608.978 498.786C606.742 498.786 604.929 497.531 604.929 495.984C604.929 494.572 606.438 493.405 608.401 493.21L608.215 489.266C607.751 489.275 607.286 489.28 606.819 489.28C601.155 489.28 595.635 488.631 590.436 487.384L588.803 490.59C590.276 491.009 591.312 492.012 591.312 493.182C591.312 494.729 589.5 495.984 587.264 495.984C585.027 495.984 583.213 494.729 583.213 493.182C583.213 491.634 585.026 490.38 587.264 490.38C587.65 490.38 588.024 490.418 588.378 490.488L590.011 487.282C583.706 485.726 577.884 483.286 572.864 480.055L569.905 482.24C570.567 482.738 570.972 483.404 570.972 484.134C570.972 485.682 569.158 486.936 566.922 486.936C564.686 486.936 562.872 485.682 562.872 484.134C562.872 482.587 564.685 481.332 566.922 481.332C567.941 481.332 568.871 481.594 569.582 482.023L572.537 479.842C572.2 479.621 571.866 479.396 571.536 479.168C567.36 476.279 564.017 472.968 561.587 469.373L557.823 470.576C557.959 470.856 558.034 471.156 558.034 471.468C558.034 473.016 556.221 474.27 553.985 474.27C551.748 474.27 549.936 473.016 549.936 471.468C549.936 469.921 551.748 468.667 553.985 468.667C555.61 468.667 557.012 469.33 557.657 470.287L561.395 469.092C558.711 465.027 557.191 460.608 556.951 456.032L552.124 456.141C552.065 457.652 550.277 458.865 548.078 458.865C545.842 458.865 544.028 457.61 544.028 456.063C544.028 454.516 545.842 453.261 548.078 453.261C550.201 453.261 551.941 454.392 552.112 455.83L556.937 455.721C556.925 455.399 556.918 455.077 556.918 454.755C556.918 450.67 557.937 446.695 559.889 442.965L555.927 441.956C555.304 442.95 553.876 443.645 552.211 443.645C549.974 443.645 548.161 442.391 548.161 440.843C548.161 439.296 549.974 438.042 552.211 438.042C554.446 438.042 556.261 439.296 556.261 440.843C556.261 441.129 556.199 441.405 556.083 441.664L560.045 442.674C562.302 438.485 565.743 434.614 570.252 431.26L567.152 429.251C566.425 429.731 565.44 430.027 564.355 430.027C562.119 430.027 560.306 428.772 560.306 427.225C560.306 425.678 562.119 424.423 564.355 424.423C566.592 424.423 568.406 425.678 568.406 427.225C568.406 427.91 568.049 428.537 567.46 429.024L570.56 431.034C570.88 430.801 571.203 430.57 571.533 430.342C574.694 428.154 578.206 426.297 581.98 424.793L557.562 393.651H553.18V392.761H551.033V390.993H662.598V392.761H660.452V393.651H656.07L631.652 424.793C634.905 426.089 637.963 427.648 640.77 429.455L644.726 426.533C643.877 426.019 643.34 425.265 643.34 424.423C643.34 422.875 645.153 421.621 647.389 421.621C649.625 421.621 651.439 422.875 651.439 424.423C651.439 425.97 649.626 427.224 647.389 427.224C646.531 427.224 645.737 427.04 645.083 426.725L641.098 429.667C641.435 429.888 641.769 430.112 642.099 430.341C646.275 433.23 649.618 436.541 652.049 440.135L656.456 438.728C656.376 438.508 656.333 438.278 656.333 438.042C656.333 436.494 658.146 435.24 660.382 435.24C662.619 435.24 664.432 436.494 664.432 438.042C664.432 439.589 662.619 440.843 660.382 440.843C658.647 440.843 657.167 440.088 656.591 439.027L652.239 440.418C654.923 444.483 656.444 448.902 656.682 453.478L661.426 453.371C661.485 451.859 663.273 450.645 665.473 450.645C667.709 450.645 669.52 451.9 669.52 453.447C669.52 454.994 667.71 456.248 665.474 456.248ZM655.367 454.754C655.367 454.442 655.36 454.129 655.348 453.818L641.377 454.132C641.385 454.339 641.388 454.547 641.388 454.754C641.388 457.603 640.663 460.337 639.337 462.873L652.477 466.221C654.376 462.593 655.367 458.727 655.367 454.754ZM640.702 454.148L609.536 454.849C609.525 454.989 609.493 455.126 609.44 455.257L638.702 462.712C640.002 460.226 640.712 457.547 640.712 454.754C640.713 454.551 640.71 454.349 640.702 454.148ZM572.933 455.36L604.099 454.66C604.109 454.519 604.142 454.382 604.195 454.251L574.933 446.796C573.633 449.282 572.923 451.961 572.923 454.754C572.922 454.957 572.925 455.159 572.933 455.36ZM608.951 455.924L631.692 470.669C634.641 468.463 636.987 465.866 638.546 463.003L609.285 455.549C609.195 455.683 609.083 455.809 608.951 455.924ZM608.643 456.152C608.467 456.262 608.27 456.356 608.057 456.432L619.901 476.39C624.267 475.121 628.171 473.237 631.385 470.897L608.643 456.152ZM607.641 456.55C607.477 456.586 607.306 456.611 607.131 456.625L608.144 478.189C612.139 478.082 615.959 477.495 619.486 476.508L607.641 456.55ZM606.681 456.636C606.491 456.629 606.305 456.609 606.128 456.577L595.762 476.926C599.229 477.756 602.948 478.209 606.817 478.209C607.111 478.209 607.403 478.206 607.694 478.201L606.681 456.636ZM605.703 456.473C605.496 456.409 605.302 456.327 605.126 456.23L583.817 471.965C587.118 474.079 591.026 475.745 595.338 476.822L605.703 456.473ZM604.799 456.018C604.665 455.915 604.548 455.803 604.449 455.682L576.142 464.724C577.949 467.375 580.452 469.757 583.49 471.753L604.799 456.018ZM604.259 455.4C604.187 455.264 604.138 455.12 604.113 454.971L572.95 455.672C573.124 458.788 574.179 461.752 575.951 464.443L604.259 455.4ZM604.349 453.96C604.422 453.851 604.509 453.748 604.611 453.653L604.425 453.416L581.943 438.84C578.994 441.046 576.648 443.643 575.089 446.505L604.349 453.96ZM603.744 452.548L589.63 434.547C586.903 435.662 584.418 437.032 582.249 438.612L603.744 452.548ZM605.279 453.2C605.374 453.155 605.475 453.114 605.578 453.077L593.734 433.119C592.593 433.451 591.484 433.825 590.41 434.237L605.279 453.2ZM605.994 452.958C606.158 452.922 606.329 452.897 606.505 452.883L605.491 431.32C601.497 431.426 597.677 432.013 594.15 433.001L605.994 452.958ZM606.817 431.3C606.524 431.3 606.232 431.303 605.941 431.308L606.954 452.873C607.144 452.879 607.33 452.9 607.507 452.932L617.873 432.582C614.406 431.752 610.687 431.3 606.817 431.3ZM607.932 453.036C608.081 453.082 608.223 453.137 608.356 453.2L623.224 434.237C621.653 433.633 620.007 433.113 618.296 432.686L607.932 453.036ZM610.433 451.856L629.817 437.542C628.045 436.407 626.097 435.401 624.006 434.547L610.433 451.856ZM609.586 452.938L609.026 453.653C609.083 453.708 609.138 453.766 609.187 453.826L637.493 444.785C635.686 442.133 633.183 439.752 630.146 437.755L609.586 452.938ZM609.376 454.108C609.448 454.245 609.497 454.388 609.522 454.537L640.685 453.836C640.511 450.719 639.455 447.756 637.684 445.065L609.376 454.108ZM593.478 432.687L588.157 423.722C586.535 424.189 584.951 424.718 583.408 425.306L590.089 433.827C591.183 433.406 592.314 433.024 593.478 432.687ZM593.894 432.569C597.493 431.561 601.391 430.962 605.47 430.853L605.016 421.184C599.296 421.327 593.75 422.153 588.574 423.605L593.894 432.569ZM605.919 430.842C606.218 430.836 606.517 430.834 606.817 430.834C610.765 430.834 614.56 431.295 618.097 432.143L622.752 423.005C617.695 421.793 612.326 421.162 606.818 421.162C606.366 421.162 605.916 421.166 605.466 421.175L605.919 430.842ZM618.521 432.246C620.265 432.681 621.944 433.212 623.546 433.827L630.227 425.306C627.963 424.442 625.607 423.707 623.176 423.107L618.521 432.246ZM652.322 466.513L639.18 463.165C637.589 466.086 635.195 468.737 632.184 470.988L642.397 477.61C646.781 474.349 650.127 470.586 652.322 466.513ZM641.146 478.508C641.466 478.287 641.78 478.063 642.089 477.837L631.878 471.215C628.597 473.605 624.614 475.527 620.158 476.821L625.478 485.786C631.266 484.12 636.58 481.668 641.146 478.508ZM625.061 485.904L619.74 476.939C616.141 477.947 612.242 478.546 608.165 478.655L608.619 488.325C614.339 488.181 619.884 487.355 625.061 485.904ZM606.817 488.347C607.269 488.347 607.72 488.343 608.17 488.335L607.716 478.667C607.417 478.673 607.118 478.675 606.817 478.675C602.87 478.675 599.075 478.214 595.538 477.366L590.883 486.504C595.939 487.716 601.308 488.347 606.817 488.347ZM590.458 486.402L595.114 477.263C590.714 476.164 586.725 474.464 583.357 472.307L573.786 479.374C578.667 482.516 584.329 484.887 590.458 486.402ZM572.488 478.508C572.807 478.729 573.132 478.946 573.458 479.161L583.028 472.094C579.929 470.057 577.373 467.627 575.529 464.92L562.811 468.982C565.174 472.478 568.427 475.698 572.488 478.508ZM562.622 468.7L575.339 464.638C573.531 461.891 572.454 458.868 572.276 455.686L558.302 456.001C558.534 460.45 560.013 464.747 562.622 468.7ZM558.268 454.754C558.268 455.066 558.275 455.379 558.287 455.69L572.258 455.376C572.25 455.169 572.247 454.962 572.247 454.754C572.247 451.905 572.972 449.171 574.298 446.635L561.158 443.287C559.259 446.915 558.268 450.782 558.268 454.754ZM561.312 442.995L574.454 446.343C576.046 443.422 578.44 440.771 581.451 438.521L571.237 431.898C566.854 435.159 563.508 438.922 561.312 442.995ZM572.488 431C572.169 431.221 571.855 431.445 571.546 431.671L581.757 438.292C583.976 436.677 586.517 435.275 589.308 434.136L582.625 425.612C578.963 427.073 575.557 428.877 572.488 431ZM655.048 393.649H558.587L582.764 424.485C584.349 423.88 585.977 423.337 587.644 422.857L585.939 419.984C585.552 420.069 585.14 420.115 584.712 420.115C582.475 420.115 580.663 418.86 580.663 417.313C580.663 415.766 582.475 414.511 584.712 414.511C586.948 414.511 588.762 415.766 588.762 417.313C588.762 418.455 587.775 419.436 586.359 419.873L588.061 422.74C593.384 421.247 599.089 420.397 604.972 420.25L604.834 417.312C602.641 417.277 600.878 416.037 600.878 414.511C600.878 412.964 602.692 411.71 604.929 411.71C607.166 411.71 608.978 412.964 608.978 414.511C608.978 415.976 607.354 417.177 605.284 417.302L605.422 420.241C605.886 420.231 606.352 420.227 606.818 420.227C612.483 420.227 618.002 420.876 623.201 422.122L624.657 419.265C623.279 418.818 622.324 417.85 622.324 416.727C622.324 415.18 624.137 413.925 626.373 413.925C628.609 413.925 630.422 415.18 630.422 416.727C630.422 418.275 628.609 419.529 626.373 419.529C625.919 419.529 625.482 419.476 625.075 419.381L623.626 422.225C626.124 422.842 628.545 423.597 630.871 424.484L655.048 393.649ZM631.01 425.613L624.328 434.136C626.47 435.01 628.464 436.04 630.279 437.202L639.85 430.134C637.128 428.383 634.162 426.871 631.01 425.613ZM641.146 431C640.828 430.779 640.503 430.562 640.176 430.348L630.607 437.414C633.706 439.451 636.261 441.881 638.105 444.588L650.823 440.526C648.46 437.031 645.208 433.81 641.146 431ZM651.013 440.808L638.296 444.87C640.104 447.617 641.181 450.641 641.359 453.822L655.333 453.507C655.101 449.058 653.622 444.761 651.013 440.808Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.285 432.686H675.249V379.929H727.285V432.686Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.703 412.175H719.667V380.227H771.703V412.175Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.06 416.866H517.869V390.056H547.06V416.866Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.076 482.857H701.271V379.93H738.076V482.857Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.677 379.93H750.131V440.032H786.936L798.677 379.93Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.936 393.649H777.418V379.929H819.936V393.649Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.071 506.738L726.017 510.523L730.598 522.273L732.239 510.722L729.071 506.738Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.895 505.876L732.239 503.154L752.661 497.909L737.048 505.876H729.895Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.48 499.237L727.074 503.286L729.131 505.876L724.141 506.407L705.48 499.237Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.835 505.148H728.428V472.784H729.835V505.148Z",
    fill: "#003940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.239 505.876C732.239 505.633 732.152 505.401 731.998 505.191C731.523 504.559 730.418 504.116 729.132 504.116C727.41 504.116 726.017 504.904 726.017 505.876C726.017 506.847 727.41 507.635 729.132 507.635C730.846 507.635 732.239 506.848 732.239 505.876Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.824 504.36H728.558V476.39H729.824V504.36Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1297.89 511.91H1296.32V477.115H1297.89V511.91Z",
    fill: "url(#paint93_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1296.95 514.869L1293.15 519.576L1298.85 534.194L1300.89 519.824L1296.95 514.869Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1297.98 513.796L1300.9 510.41L1326.3 503.885L1306.88 513.796H1297.98Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1267.61 505.537L1294.47 510.574L1297.03 513.795L1290.82 514.456L1267.61 505.537Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300.89 513.795C1300.89 513.493 1300.78 513.205 1300.59 512.943C1300 512.158 1298.63 511.606 1297.03 511.606C1294.88 511.606 1293.15 512.586 1293.15 513.795C1293.15 515.004 1294.88 515.984 1297.03 515.984C1299.16 515.984 1300.89 515.005 1300.89 513.795Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.109 498.358H732.836V470.388H734.109V498.358Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.937 494.497H724.665V466.526H725.937V494.497Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.406 444.89H752.032V435.421H769.406V444.89Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.507 448.264H753.937V442.943H767.507V448.264Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.641 442.116H776.305V438.293H779.641V442.116Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.575 445.604H780.82V438.293H785.575V445.604Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.848 459.639H517.724V361.226H561.848V459.639Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.143 459.056H514.425V458.059H565.143V459.056Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.77 445.232H515.797V444.238H563.77V445.232Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.77 431.844H515.797V430.851H563.77V431.844Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.77 418.457H515.797V417.463H563.77V418.457Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.77 405.069H515.797V404.075H563.77V405.069Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.77 391.681H515.797V390.687H563.77V391.681Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.77 378.294H515.797V377.3H563.77V378.294Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.821 461.775H512.749V459.056H566.821V461.775Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M526.278 454.826H521.694V446.964H526.278V454.826Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.533 454.826H531.949V446.964H536.533V454.826Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.788 454.826H542.204V446.964H546.788V454.826Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.044 454.826H552.459V446.964H557.044V454.826Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.278 441.972H521.694V434.11H526.278V441.972Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M536.533 441.972H531.949V434.11H536.533V441.972Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.788 441.972H542.204V434.11H546.788V441.972Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.044 441.972H552.459V434.11H557.044V441.972Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.278 428.584H521.694V420.723H526.278V428.584Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.533 428.584H531.949V420.723H536.533V428.584Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.788 428.584H542.204V420.723H546.788V428.584Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M557.044 428.584H552.459V420.723H557.044V428.584Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.278 415.197H521.694V407.335H526.278V415.197Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M536.533 415.197H531.949V407.335H536.533V415.197Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M546.788 415.197H542.204V407.335H546.788V415.197Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.044 415.197H552.459V407.335H557.044V415.197Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M526.278 401.809H521.694V393.947H526.278V401.809Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.533 401.809H531.949V393.947H536.533V401.809Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.788 401.809H542.204V393.947H546.788V401.809Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.044 401.809H552.459V393.947H557.044V401.809Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.278 388.421H521.694V380.56H526.278V388.421Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.533 388.421H531.949V380.56H536.533V388.421Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M546.788 388.421H542.204V380.56H546.788V388.421Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.044 388.421H552.459V380.56H557.044V388.421Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.278 375.034H521.694V367.172H526.278V375.034Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M536.533 375.034H531.949V367.172H536.533V375.034Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.788 375.034H542.204V367.172H546.788V375.034Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M557.044 375.034H552.459V367.172H557.044V375.034Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.516 465.527H520.509V460.415H535.516V465.527Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.531 465.672H519.488V464.799H536.531V465.672Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.482 361.226H395.704V454.732L454.482 464.681V361.226Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.286 456.378H393.121V361.226H398.286V456.378Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.979 459.059H407.814V361.226H412.979V459.059Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.672 461.844H422.507V361.226H427.672V461.844Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.369 464.113H437.204V361.226H442.369V464.113Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.062 466.526H451.897V361.226H457.062V466.526Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M406.475 448.393H399.62V441.167H406.475V448.393Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M421.172 448.393H414.317V441.167H421.172V448.393Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.865 448.393H429.01V441.167H435.865V448.393Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M450.561 448.393H443.707V441.167H450.561V448.393Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.475 435.81H399.62V428.584H406.475V435.81Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.172 435.81H414.317V428.584H421.172V435.81Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M435.865 435.81H429.01V428.584H435.865V435.81Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M450.561 435.81H443.707V428.584H450.561V435.81Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M406.475 423.227H399.62V416.001H406.475V423.227Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M421.172 423.227H414.317V416.001H421.172V423.227Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M435.865 423.227H429.01V416.001H435.865V423.227Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.561 423.227H443.707V416.001H450.561V423.227Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M406.475 410.644H399.62V403.418H406.475V410.644Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.172 410.644H414.317V403.418H421.172V410.644Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M435.865 410.644H429.01V403.418H435.865V410.644Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M450.561 410.644H443.707V403.418H450.561V410.644Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M406.475 398.062H399.62V390.836H406.475V398.062Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M421.172 398.062H414.317V390.836H421.172V398.062Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.865 398.062H429.01V390.836H435.865V398.062Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M450.561 398.062H443.707V390.836H450.561V398.062Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.475 385.479H399.62V378.253H406.475V385.479Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.172 385.479H414.317V378.253H421.172V385.479Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M435.865 385.479H429.01V378.253H435.865V385.479Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M450.561 385.479H443.707V378.253H450.561V385.479Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M406.475 372.897H399.62V365.671H406.475V372.897Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.172 372.897H414.317V365.671H421.172V372.897Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M435.865 372.897H429.01V365.671H435.865V372.897Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.561 372.897H443.707V365.671H450.561V372.897Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.03 450.252V449.282H226.633V446.515H251.226V361.226H210.867V442.065V446.515V449.282H209.403V450.252H228.03Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.353 411.512H296.784V361.226H331.353V411.512Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.214 423.039H146.113V361.226H174.214V423.039Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.269 410.16H168.646V361.226H199.269V410.16Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.648 425.52H156.223V418.123H168.648V425.52Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.392 410.966H170.749V409.157H203.392V410.966Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.315 389.172H195.982V361.226H230.315V389.172Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.945 411.902H85.0171V361.226H112.945V411.902Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5256 386.649H60.7852V361.226H97.5256V386.649Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3103 390.803H20.3289V361.226H43.3103V390.803Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1635 370.491H38.8466V361.226H93.1635V370.491Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3604 373.485H-0.478241V361.226H27.3604V373.485Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.225 379.93H112.948V361.226H156.225V379.93Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.306 369.284H239.894V361.226H307.306V369.284Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.827 369.284H359.415V361.226H426.827V369.284Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.683 392.938H279.061L268.225 365.254H304.683V392.938Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.238 433.217H316.525V402.507H317.238V433.217Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.046 422.825H320.094V404.705H321.046V422.825Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.956 419.614H314.993V410.644H327.956V419.614Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.972 420.311H312.803V419.507H329.972V420.311Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.955 387.163H325.069V361.227H366.955V387.163Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.854 415.716H358.943V365.67H385.854V415.716Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.036 406.307H464.042V361.226H507.036V406.307Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.579 377.837H450.56V361.226H499.579V377.837Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.535 367.172H504.658V361.226H536.535V367.172Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.581 377.837H553.754V361.226H605.581V377.837Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.401 361.226H638.891V421.328H574.401V361.226Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.736 421.328H642.655V423.634H572.736V421.328Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.696 417.706H636.037V429.891H607.696V417.706Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.677 422.481H598.436V429.891H593.677V422.481Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.681 422.481H588.917V429.891H583.681V422.481Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.226 361.226H734.27V449.003H683.226V361.226Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.77 448.031H735.722V450.512H681.77V448.031Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.94 441.895H732.555V453.688H684.94V441.895Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.055 445.628H728.91V458.513H710.055V445.628Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.002 454.881H728.913V461.664H721.09L718.002 454.881Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.453 452.186H724.512V467.293H723.453V452.186Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.038 468.076C723.038 467.644 723.46 467.293 723.983 467.293C724.512 467.293 724.934 467.644 724.934 468.076C724.934 468.509 724.512 468.86 723.983 468.86C723.46 468.86 723.038 468.509 723.038 468.076Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.132 397.462H727.286V361.226H750.132V397.462Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.26 415.129H662.209V361.226H688.26V415.129Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.248 361.226H638.548V390.056L669.522 380.56L675.248 361.226Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.678 376.884H742.63V361.226H798.678V376.884Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.533 423.73H777.974V361.226H810.533V423.73Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.857 372.897H802.918V361.227H856.857V372.897Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.019 424.874H776.305V422.825H812.019V424.874Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.165 433.694H805.455V421.098H806.165V433.694Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.41 432.099H800.694V421.995H801.41V432.099Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.591 400.183H808.076V371.546H828.779L822.591 400.183Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.139 419.909H149.012V418.438H151.139V419.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.413 419.909H153.286V418.438H155.413V419.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.139 416.452H149.012V414.98H151.139V416.452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.413 416.452H153.286V414.98H155.413V416.452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.139 413.109H149.012V411.637H151.139V413.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.163 419.909H158.037V418.438H160.163V419.909Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M404.762 450.322H401.334V444.307H404.762V450.322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M404.762 438.817H401.334V432.802H404.762V438.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M404.762 427.313H401.334V421.298H404.762V427.313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M404.762 415.807H401.334V409.792H404.762V415.807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M404.762 404.96H401.334V398.945H404.762V404.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M404.762 393.455H401.334V387.44H404.762V393.455Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M419.458 450.322H416.031V444.307H419.458V450.322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M419.458 438.817H416.031V432.802H419.458V438.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M419.458 427.313H416.031V421.298H419.458V427.313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M419.458 415.807H416.031V409.792H419.458V415.807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M419.458 404.96H416.031V398.945H419.458V404.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M419.458 393.455H416.031V387.44H419.458V393.455Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M434.152 450.322H430.724V444.307H434.152V450.322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M434.152 438.817H430.724V432.802H434.152V438.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M434.152 427.313H430.724V421.298H434.152V427.313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M434.152 415.807H430.724V409.792H434.152V415.807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M434.152 404.96H430.724V398.945H434.152V404.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M434.152 393.455H430.724V387.44H434.152V393.455Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M448.848 450.322H445.421V444.307H448.848V450.322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M448.848 438.817H445.421V432.802H448.848V438.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M448.848 427.313H445.421V421.297H448.848V427.313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M448.848 415.807H445.421V409.792H448.848V415.807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M448.848 404.96H445.421V398.945H448.848V404.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M448.848 393.455H445.421V387.44H448.848V393.455Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M158.036 480.874H156.223V476.048H158.036V480.874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M164.436 480.874H162.623V476.048H164.436V480.874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M171.922 480.874H170.109V476.048H171.922V480.874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M178.318 480.874H176.505V476.048H178.318V480.874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M143.82 480.874H142.006V476.048H143.82V480.874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M150.219 480.874H148.406V476.048H150.219V480.874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M158.036 472.494H156.223V467.669H158.036V472.494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M164.436 472.494H162.623V467.669H164.436V472.494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M171.922 472.494H170.109V467.669H171.922V472.494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M178.318 472.494H176.505V467.669H178.318V472.494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M143.82 472.494H142.006V467.669H143.82V472.494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M150.219 472.494H148.406V467.669H150.219V472.494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M158.036 464.115H156.223V459.29H158.036V464.115Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M164.436 464.115H162.623V459.29H164.436V464.115Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M171.922 464.115H170.109V459.29H171.922V464.115Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M178.318 464.115H176.505V459.29H178.318V464.115Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M143.82 464.115H142.006V459.29H143.82V464.115Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M150.219 464.115H148.406V459.29H150.219V464.115Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M497.464 443.892H494.654V436.409H497.464V443.892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M506.062 443.892H503.252V436.409H506.062V443.892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M514.153 443.892H511.343V436.409H514.153V443.892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M690.398 442.337H688.262V438.128H690.398V442.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M697.084 442.337H694.947V438.128H697.084V442.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M690.398 442.337H688.262V438.128H690.398V442.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M697.084 442.337H694.947V438.128H697.084V442.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M703.401 442.337H701.271V438.128H703.401V442.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M710.083 442.337H707.953V438.128H710.083V442.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M690.398 434.79H688.262V430.581H690.398V434.79Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M697.084 434.79H694.947V430.581H697.084V434.79Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M690.398 434.79H688.262V430.581H690.398V434.79Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M697.084 434.79H694.947V430.581H697.084V434.79Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M703.401 434.79H701.271V430.581H703.401V434.79Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M710.083 434.79H707.953V430.581H710.083V434.79Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M690.398 426.758H688.262V422.549H690.398V426.758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M697.084 426.758H694.947V422.549H697.084V426.758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M690.398 426.758H688.262V422.549H690.398V426.758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M697.084 426.758H694.947V422.549H697.084V426.758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M703.401 426.758H701.271V422.549H703.401V426.758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M710.083 426.758H707.953V422.549H710.083V426.758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M717.393 442.337H715.263V438.128H717.393V442.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M717.393 434.79H715.263V430.581H717.393V434.79Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M724.082 442.337H721.945V438.128H724.082V442.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M523.986 454.826H521.694V448.264H523.986V454.826Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M535.387 454.826H533.095V448.264H535.387V454.826Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M546.786 454.826H544.493V448.264H546.786V454.826Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M558.188 454.826H555.895V448.264H558.188V454.826Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M523.986 441.322H521.694V434.76H523.986V441.322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M535.387 441.322H533.095V434.76H535.387V441.322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M546.786 441.322H544.493V434.76H546.786V441.322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M558.188 441.322H555.895V434.76H558.188V441.322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M523.986 427.481H521.694V420.92H523.986V427.481Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M535.387 427.481H533.095V420.92H535.387V427.481Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M546.786 427.481H544.493V420.92H546.786V427.481Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M558.188 427.481H555.895V420.92H558.188V427.481Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M523.986 413.641H521.694V407.08H523.986V413.641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M535.387 413.641H533.095V407.08H535.387V413.641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M546.786 413.641H544.493V407.08H546.786V413.641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M558.188 413.641H555.895V407.08H558.188V413.641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M523.986 401.07H521.694V394.508H523.986V401.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M535.387 401.07H533.095V394.508H535.387V401.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M546.786 401.07H544.493V394.508H546.786V401.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M523.986 387.048H521.694V380.486H523.986V387.048Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M535.387 387.048H533.095V380.486H535.387V387.048Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M546.786 387.048H544.493V380.486H546.786V387.048Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M558.188 401.07H555.895V394.508H558.188V401.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M783.198 420.138H780.854V416.371H783.198V420.138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M783.198 414.058H780.854V410.291H783.198V414.058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M789.206 420.138H786.862V416.371H789.206V420.138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.007 370.873C240.007 370.658 239.707 370.484 239.337 370.484H234.366C233.996 370.484 233.696 370.658 233.696 370.873C233.696 371.088 233.996 371.262 234.366 371.262H235.79V381.181H237.912V371.262H239.337C239.707 371.262 240.007 371.088 240.007 370.873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M240.006 370.873C240.006 370.658 239.705 370.484 239.336 370.484H236.85V381.182H237.911V371.262H239.336C239.705 371.262 240.006 371.088 240.006 370.873Z",
    fill: "#07453F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.753 370.873C271.753 370.658 271.459 370.484 271.084 370.484H266.114C265.745 370.484 265.444 370.658 265.444 370.873C265.444 371.088 265.745 371.262 266.114 371.262H267.54V381.181H269.664V371.262H271.084C271.459 371.262 271.753 371.088 271.753 370.873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M271.753 370.873C271.753 370.658 271.458 370.484 271.083 370.484H268.598V381.182H269.663V371.262H271.083C271.458 371.262 271.753 371.088 271.753 370.873Z",
    fill: "#07453F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.901 381.182H233.692V380.006H239.901V381.182Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.706 381.182H265.497V380.006H271.706V381.182Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.262 381.63H226.789L235.762 396.699H290.231L281.262 381.63Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.57 381.63H225.102L234.074 396.699H288.545L279.57 381.63Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.728 395.583L247.403 390.001H232.115L235.441 395.583H250.728Z",
    fill: "url(#paint94_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.216 382.745L248.541 388.328H263.83L260.508 382.745H245.216Z",
    fill: "url(#paint95_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.409 388.327L243.086 382.745H227.795L231.121 388.327H246.409Z",
    fill: "url(#paint96_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.536 390L252.858 395.583H268.149L264.82 390H249.536Z",
    fill: "url(#paint97_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.45 382.745L265.772 388.328H281.063L277.741 382.745H262.45Z",
    fill: "url(#paint98_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.77 390L270.092 395.583H285.383L282.054 390H266.77Z",
    fill: "url(#paint99_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.776 380.734H225.102V381.63H281.251L280.776 380.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0174 376.312H62.2405V362.154H71.0174V376.312Z",
    fill: "#C38425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1828 391.808H91.7051L75.2962 405.511H83.932L66.6584 426.147L49.3849 405.511H58.0229L41.6143 391.808H54.1363L33.8411 375.875H66.6584H99.4782L79.1828 391.808Z",
    fill: "#57975A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5218 371.215H82.72V362.154H90.5218V371.215Z",
    fill: "#C38425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.973 382.854H105.247L93.0949 393.003H99.49L86.6975 408.286L73.9044 393.003H80.3017L68.1498 382.854H77.4237L62.3928 371.055H86.6975H111.004L95.973 382.854Z",
    fill: "#64AC65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1822 373.48H17.3805V362.154H25.1822V373.48Z",
    fill: "#C38425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4812 385.033H39.7551L27.6028 395.181H33.9982L21.2054 410.464L8.41262 395.181H14.81L2.65777 385.033H11.9316L-3.09912 373.233H21.2054H45.5119L30.4812 385.033Z",
    fill: "#64AC65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.644 371.884H450.903V361.954H461.644V371.884Z",
    fill: "#C38425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.431 389.258H484.588L466.037 404.75H475.799L456.271 428.08L436.743 404.75H446.509L427.959 389.258H442.114L419.17 371.246H456.271H493.375L470.431 389.258Z",
    fill: "#57975A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.787 369.735H489.371V361.954H497.787V369.735Z",
    fill: "#C38425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.675 383.35H515.769L501.232 395.49H508.883L493.58 413.771L478.277 395.49H485.93L471.393 383.35H482.486L464.506 369.235H493.58H522.655L504.675 383.35Z",
    fill: "#64AC65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1373.91 434.366V397.832H795.604V417.989H834.32V470.149H849.837V478.179H863.854V499.264H865.463V478.179H868.682V499.264H870.291V478.179H873.79V435.32H896.031V454.834L905.444 458.231V467.928H915.54V461.872H933.33V441.123H940.52V456.191H946.676V462.494H954.55V489.42H972.365V521.29H981.867V534.312H988.63V521.29H995.066V534.312H1001.83V521.29H1011.33V489.42H1029.15V462.494H1037.02V456.191H1043.18V441.123H1050.37V461.872H1068.16V467.928H1078.26V458.231L1087.67 454.834V435.32H1109.91V478.179H1113.41V499.264H1115.01V478.179H1118.24V499.264H1119.85V478.179H1133.87V470.149H1152.68L1157.82 468.297V463.85H1181.43L1185.88 462.246V447.174H1195.8V470.397H1214.28V466.32H1243.54V456.501L1248.84 454.587V444.945H1257.66V468.747L1269.64 470.477V476.898H1291.48V490.374H1292.45V476.898H1296.63V503.965H1297.59V476.898H1301.81V449.724H1302.62V425.548H1340.3V434.366H1373.91Z",
    fill: "url(#paint100_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M984.984 478.194H975.917V472.026H984.984V478.194Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.984 466.396H975.917V460.227H984.984V466.396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.984 454.597H975.917V448.429H984.984V454.597Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.984 442.798H975.917V436.63H984.984V442.798Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.984 431.675H975.917V425.507H984.984V431.675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.984 419.877H975.917V413.709H984.984V419.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.36 478.194H1001.29V472.026H1010.36V478.194Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.36 466.396H1001.29V460.227H1010.36V466.396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.36 454.597H1001.29V448.429H1010.36V454.597Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.36 442.798H1001.29V436.63H1010.36V442.798Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.36 431.675H1001.29V425.507H1010.36V431.675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.36 419.877H1001.29V413.709H1010.36V419.877Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1399.26 437.716V369.516H767.323V432.619H767.856V437.716H772.383V432.619H776.915V437.716H781.887V432.619H792.299V430.741H790.714V402.985H824.425V450.319H825.767V453.537H828.271V464.203H829.179V453.537H831.218V462.056H832.112V453.537H836.417V450.319H841.847V402.985H858.14V417.463H868.201V425.242H914.338V418.874H921.818V452.82H917.414V453.68H921.818V455.217H927.411V457.738H973.138V455.217H978.727V453.68H983.15V452.82H978.727V398.291H1014.44V411.877H1020.49V437.673H1018.15V438.235H1050.17V458.464H1052.38V476.077H1063.06V482.782H1068.81V488.414H1070.83V498.068H1071.34V488.414H1073.36V482.782H1079.12V476.077H1090.69V482.782H1096.44V488.414H1098.46V498.068H1098.98V488.414H1101V482.782H1106.75V476.077H1117.43V458.464H1119.64V438.235H1151.66V437.673H1149.32V411.877H1155.36V398.291H1191.08V452.82H1186.66V453.68H1191.08V455.217H1196.67V457.738H1242.4V455.217H1247.99V453.68H1252.4V452.82H1247.99V418.874H1255.47V425.242H1301.61V417.463H1311.67V402.985H1327.96V450.319H1333.39V453.537H1337.69V462.056H1338.59V453.537H1340.63V464.203H1341.54V453.537H1344.04V450.319H1345.39V402.985H1379.1V430.741H1377.51V432.619H1387.92V437.716H1392.9V432.619H1397.43V437.716H1399.26Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.931 453.646C927.946 454.527 926.326 454.527 926.34 453.646C926.326 452.765 927.946 452.765 927.931 453.646Z",
    fill: "url(#paint101_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.78 383.061V361.021H767.323V386.66H781.389V369.053H796.021V383.061H816.308V404.953H839.684V377.232H840.931L843.867 391.304L844.594 394.794H854.688V414.42H853.436V416.197H858.336V423.841H858.935V416.197H862.323V422.459H862.922V416.197H875.914V416.756H886.317V414.607H890.977V404.141H915.403V402.572H911.957V392.433H918.526V436.267H917.308V438.42H919.965V441.174H923.009V448.087H926.696V452.966H927.58V448.087H929.563L930.761 445.357H938.799V441.174H959.818V438.42H962.474V436.267H961.256V407.75H978.848V388.511H993.587V404.612H998.37V413.122H995.227V415.12H1000.76V420.545H1010.11V423.43H1010.71V420.545H1024.49V415.12H1032.24V420.545H1036.22V415.12H1040.21V420.545H1044.59V415.12H1053.75V413.122H1052.36V408.253H1062.87V409.769H1061.25V410.631H1062.87V421.375H1061.25V422.237H1062.87V432.981H1061.25V433.843H1062.87V444.963H1060.11V445.829H1058.71V448.185H1081.49V452.305H1085.81V451.563H1098.33V450.803H1097.47V450.208H1098.12V448.185H1098.84V448.245H1103.16V448.185H1103.97V447.141L1104.62 447.028L1105.28 447.141V448.185H1106.09V448.245H1110.42V448.185H1111.14V450.208H1111.77V450.803H1110.92V451.563H1123.44V452.305H1127.76V448.185H1150.54V445.829H1149.14V444.963H1146.39V433.843H1147.99V432.981H1146.39V422.237H1147.99V421.375H1146.39V410.631H1147.99V409.769H1146.39V408.253H1156.89V413.122H1155.5V415.12H1164.66V420.545H1169.05V415.12H1173.03V420.545H1177.01V415.12H1184.76V420.545H1198.55V423.43H1199.14V420.545H1208.49V415.12H1214.03V413.122H1210.88V404.612H1215.67V388.511H1230.4V407.75H1248V436.267H1246.78V438.42H1249.43V441.174H1270.46V445.357H1278.49L1279.69 448.087H1281.67V452.966H1282.56V448.087H1286.24V441.174H1289.29V438.42H1291.95V436.267H1290.73V392.433H1297.3V402.572H1293.85V404.141H1318.27V414.607H1322.94V416.756H1333.34V416.197H1346.33V422.459H1346.93V416.197H1350.32V423.841H1350.92V416.197H1355.82V414.42H1354.57V394.794H1364.66L1365.38 391.304L1368.33 377.232H1369.56V404.953H1392.95V383.061H1395.78Z",
    fill: "#1F8297"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M935.963 429.843H931.083V369.518H935.963V429.843Z",
    fill: "url(#paint102_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M949.524 429.843H944.645V369.518H949.524V429.843Z",
    fill: "url(#paint103_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1265.41 429.843H1260.54V369.518H1265.41V429.843Z",
    fill: "url(#paint104_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1278.98 429.843H1274.1V369.518H1278.98V429.843Z",
    fill: "url(#paint105_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1091.14 437.004H1078.68V431.968H1091.14V437.004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.14 427.37H1078.68V422.334H1091.14V427.37Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.14 417.736H1078.68V412.7H1091.14V417.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.14 408.102H1078.68V403.066H1091.14V408.102Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.14 399.019H1078.68V393.983H1091.14V399.019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.14 389.385H1078.68V384.349H1091.14V389.385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130.41 437.004H1117.96V431.968H1130.41V437.004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130.41 427.37H1117.96V422.334H1130.41V427.37Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130.41 417.736H1117.96V412.7H1130.41V417.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130.41 408.102H1117.96V403.066H1130.41V408.102Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130.41 399.019H1117.96V393.983H1130.41V399.019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130.41 389.385H1117.96V384.349H1130.41V389.385Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1049.44 365.776C1049.44 365.561 1049.14 365.387 1048.77 365.387H1043.8C1043.43 365.387 1043.13 365.561 1043.13 365.776C1043.13 365.991 1043.43 366.165 1043.8 366.165H1045.22V376.084H1047.34V366.165H1048.77C1049.14 366.165 1049.44 365.991 1049.44 365.776Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M1049.44 365.776C1049.44 365.561 1049.14 365.387 1048.77 365.387H1046.28V376.085H1047.34V366.165H1048.77C1049.14 366.165 1049.44 365.991 1049.44 365.776Z",
    fill: "#07453F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.18 365.776C1081.18 365.561 1080.89 365.387 1080.51 365.387H1075.54C1075.18 365.387 1074.87 365.561 1074.87 365.776C1074.87 365.991 1075.18 366.165 1075.54 366.165H1076.97V376.084H1079.09V366.165H1080.51C1080.89 366.165 1081.18 365.991 1081.18 365.776Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M1081.18 365.776C1081.18 365.561 1080.89 365.387 1080.51 365.387H1078.03V376.085H1079.09V366.165H1080.51C1080.89 366.165 1081.18 365.991 1081.18 365.776Z",
    fill: "#07453F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.33 376.085H1043.12V374.909H1049.33V376.085Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.14 376.085H1074.93V374.909H1081.14V376.085Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090.69 376.533H1036.22L1045.19 391.602H1099.66L1090.69 376.533Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1089 376.533H1034.53L1043.5 391.602H1097.98L1089 376.533Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.16 390.486L1056.83 384.904H1041.55L1044.87 390.486H1060.16Z",
    fill: "url(#paint106_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.65 377.648L1057.97 383.231H1073.26L1069.94 377.648H1054.65Z",
    fill: "url(#paint107_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.84 383.23L1052.52 377.648H1037.23L1040.55 383.23H1055.84Z",
    fill: "url(#paint108_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.97 384.903L1062.29 390.486H1077.58L1074.25 384.903H1058.97Z",
    fill: "url(#paint109_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.88 377.648L1075.2 383.231H1090.49L1087.17 377.648H1071.88Z",
    fill: "url(#paint110_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.2 384.903L1079.52 390.486H1094.81L1091.48 384.903H1076.2Z",
    fill: "url(#paint111_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090.21 375.637H1034.53V376.533H1090.68L1090.21 375.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.987 368.37H978.541V360.562H986.987V368.37Z",
    fill: "#C38425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.897 382.031H1005.02L990.441 394.212H998.117L982.759 412.556L967.407 394.212H975.083L960.502 382.031H971.634L953.589 367.868H982.759H1011.93L993.897 382.031Z",
    fill: "#57975A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.712 368.37H753.266V360.562H761.712V368.37Z",
    fill: "#C38425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.622 382.031H779.747L765.166 394.212H772.842L757.484 412.556L742.132 394.212H749.808L735.226 382.031H746.358L728.314 367.868H757.484H786.66L768.622 382.031Z",
    fill: "#57975A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.65 366.772H1031.93V361.484H1037.65V366.772Z",
    fill: "#C38425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042.33 376.025H1049.86L1039.98 384.275H1045.19L1034.79 396.699L1024.39 384.275H1029.59L1019.71 376.025H1027.25L1015.03 366.432H1034.79H1054.55L1042.33 376.025Z",
    fill: "#57975A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.54 374.613H946.763V360.456H955.54V374.613Z",
    fill: "#C38425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.705 390.109H976.228L959.819 403.812H968.454L951.181 424.448L933.907 403.812H942.545L926.137 390.109H938.659L918.364 374.177H951.181H984.001L963.705 390.109Z",
    fill: "#57975A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M975.044 369.516H967.242V360.455H975.044V369.516Z",
    fill: "#C38425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.495 381.156H989.769L977.617 391.304H984.012L971.22 406.587L958.427 391.304H964.824L952.672 381.156H961.946L946.915 369.356H971.22H995.526L980.495 381.156Z",
    fill: "#64AC65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.705 371.781H901.903V360.455H909.705V371.781Z",
    fill: "#C38425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.004 383.334H924.278L912.125 393.483H918.521L905.728 408.766L892.935 393.483H899.332L887.18 383.334H896.454L881.423 371.534H905.728H930.034L915.004 383.334Z",
    fill: "#64AC65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.43 375.745H1362.21V361.588H1353.43V375.745Z",
    fill: "#C38425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1345.26 391.242H1332.74L1349.15 404.945H1340.51L1357.79 425.581L1375.06 404.945H1366.42L1382.83 391.242H1370.31L1390.6 375.309H1357.79H1324.97L1345.26 391.242Z",
    fill: "#57975A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1333.92 370.649H1341.73V361.588H1333.92V370.649Z",
    fill: "#C38425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.47 382.288H1319.2L1331.35 392.437H1324.96L1337.75 407.719L1350.54 392.437H1344.14L1356.3 382.288H1347.02L1362.05 370.488H1337.75H1313.44L1328.47 382.288Z",
    fill: "#64AC65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.26 372.914H1407.07V361.588H1399.26V372.914Z",
    fill: "#C38425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1393.96 384.467H1384.69L1396.84 394.615H1390.45L1403.24 409.898L1416.03 394.615H1409.64L1421.79 384.467H1412.51L1427.55 372.667H1403.24H1378.93L1393.96 384.467Z",
    fill: "#64AC65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.43 365.507C659.43 365.248 659.03 365.037 658.537 365.037H651.913C651.42 365.037 651.02 365.248 651.02 365.507C651.02 365.766 651.42 365.977 651.913 365.977H653.811V377.957H656.639V365.977H658.537C659.03 365.977 659.43 365.767 659.43 365.507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M659.431 365.507C659.431 365.248 659.031 365.037 658.538 365.037H655.226V377.958H656.64V365.977H658.538C659.031 365.977 659.431 365.767 659.431 365.507Z",
    fill: "#07453F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.741 365.507C701.741 365.248 701.342 365.037 700.849 365.037H694.225C693.732 365.037 693.332 365.248 693.332 365.507C693.332 365.766 693.732 365.977 694.225 365.977H696.123V377.957H698.95V365.977H700.849C701.342 365.977 701.741 365.767 701.741 365.507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M701.742 365.507C701.742 365.248 701.342 365.037 700.85 365.037H697.538V377.958H698.951V365.977H700.85C701.342 365.977 701.742 365.767 701.742 365.507Z",
    fill: "#07453F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.294 377.958H651.02V376.538H659.294V377.958Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.671 377.958H693.397V376.538H701.671V377.958Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.411 378.499H641.824L653.781 396.699H726.368L714.411 378.499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.156 378.499H639.569L651.526 396.699H724.112L712.156 378.499Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.725 395.352L669.293 388.61H648.921L653.354 395.352H673.725Z",
    fill: "url(#paint112_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.372 379.846L670.803 386.589H691.176L686.746 379.846H666.372Z",
    fill: "url(#paint113_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.966 386.588L663.539 379.846H643.162L647.594 386.588H667.966Z",
    fill: "url(#paint114_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.129 388.609L676.559 395.352H696.93L692.5 388.609H672.129Z",
    fill: "url(#paint115_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.336 379.846L693.766 386.589H714.14L709.709 379.846H689.336Z",
    fill: "url(#paint116_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.096 388.609L699.526 395.352H719.898L715.467 388.609H695.096Z",
    fill: "url(#paint117_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.759 377.416H639.569V378.499H714.39L713.759 377.416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.865 364.116C701.865 363.931 701.58 363.78 701.226 363.78H696.485C696.133 363.78 695.846 363.93 695.846 364.116C695.846 364.302 696.132 364.453 696.485 364.453H697.844V373.026H699.867V364.453H701.226C701.579 364.453 701.865 364.302 701.865 364.116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M701.865 364.116C701.865 363.931 701.58 363.78 701.226 363.78H698.856V373.026H699.868V364.453H701.226C701.579 364.453 701.865 364.302 701.865 364.116Z",
    fill: "#07453F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.143 364.116C732.143 363.931 731.857 363.78 731.504 363.78H726.763C726.41 363.78 726.124 363.93 726.124 364.116C726.124 364.302 726.409 364.453 726.763 364.453H728.121V373.026H730.145V364.453H731.503C731.857 364.453 732.143 364.302 732.143 364.116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M732.147 364.116C732.147 363.931 731.86 363.78 731.508 363.78H729.137V373.026H730.149V364.453H731.508C731.861 364.453 732.147 364.302 732.147 364.116Z",
    fill: "#07453F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.767 373.026H695.846V372.011H701.767V373.026Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.098 373.026H726.177V372.011H732.098V373.026Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.213 373.414H689.267L697.823 386.439H749.77L741.213 373.414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.599 373.414H687.652L696.209 386.439H748.156L739.599 373.414Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.092 385.474L708.92 380.65H694.342L697.514 385.474H712.092Z",
    fill: "url(#paint118_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.837 374.378L710.007 379.203H724.587L721.417 374.378H706.837Z",
    fill: "url(#paint119_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.978 379.203L704.811 374.378H690.227L693.399 379.203H707.978Z",
    fill: "url(#paint120_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.958 380.649L714.129 385.475H728.707L725.536 380.649H710.958Z",
    fill: "url(#paint121_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.267 374.378L726.438 379.203H741.017L737.847 374.378H723.267Z",
    fill: "url(#paint122_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.388 380.649L730.56 385.475H745.137L741.967 380.649H727.388Z",
    fill: "url(#paint123_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.746 372.639H687.652V373.414H741.197L740.746 372.639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.425 362.154C330.095 365.549 326.139 368.232 321.295 368.232C320.231 368.232 319.215 368.096 318.266 367.859C315.818 370.807 311.324 372.79 306.17 372.79C300.783 372.79 296.107 370.626 293.746 367.454C291.946 368.686 289.508 369.448 286.815 369.448C281.91 369.448 277.837 366.932 276.976 363.613C276.678 363.652 276.373 363.674 276.059 363.674C275.209 363.674 274.41 363.524 273.705 363.263C273.118 365.839 270.208 367.855 266.552 368.181C264.658 371.929 259.642 374.613 253.733 374.613C247.588 374.613 242.394 371.713 240.691 367.728C239.604 368.052 238.41 368.232 237.157 368.232C232.314 368.232 228.357 365.55 228.027 362.155H330.425V362.154Z",
    fill: "#64AC65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1101.82 362.154C1101.49 365.549 1097.58 368.232 1092.78 368.232C1091.72 368.232 1090.72 368.096 1089.77 367.859C1087.36 370.807 1082.9 372.79 1077.8 372.79C1072.46 372.79 1067.83 370.626 1065.49 367.454C1063.71 368.686 1061.29 369.448 1058.63 369.448C1053.77 369.448 1049.74 366.932 1048.88 363.613C1048.59 363.652 1048.28 363.674 1047.98 363.674C1047.14 363.674 1046.34 363.524 1045.64 363.263C1045.06 365.839 1042.18 367.855 1038.56 368.181C1036.68 371.929 1031.72 374.613 1025.86 374.613C1019.77 374.613 1014.63 371.713 1012.94 367.728C1011.87 368.052 1010.68 368.232 1009.44 368.232C1004.65 368.232 1000.73 365.55 1000.4 362.155H1101.82V362.154Z",
    fill: "#64AC65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.323 362.154C766.899 365.549 761.812 368.232 755.584 368.232C754.216 368.232 752.91 368.096 751.69 367.859C748.542 370.807 742.764 372.79 736.138 372.79C729.211 372.79 723.198 370.626 720.164 367.454C717.851 368.686 714.715 369.448 711.253 369.448C704.947 369.448 699.71 366.932 698.601 363.613C698.219 363.652 697.827 363.674 697.424 363.674C696.33 363.674 695.303 363.524 694.397 363.263C693.642 365.839 689.9 367.855 685.199 368.181C682.765 371.929 676.316 374.613 668.72 374.613C660.817 374.613 654.14 371.713 651.949 367.728C650.552 368.052 649.017 368.232 647.407 368.232C641.179 368.232 636.092 365.55 635.668 362.155H767.323V362.154Z",
    fill: "#64AC65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.881 362.154C468.616 364.543 465.362 366.248 461.539 366.248C461.053 366.248 460.579 366.213 460.115 366.16C458.202 369.484 453.591 371.83 448.199 371.83C442.833 371.83 438.238 369.506 436.309 366.207C434.257 366.045 432.417 365.387 431.04 364.405C431.021 364.407 431.001 364.409 430.982 364.411C430.982 364.439 430.988 364.467 430.988 364.495C430.988 370.395 424.218 375.179 415.868 375.179C409.122 375.179 403.412 372.056 401.466 367.746C399.665 368.673 397.456 369.225 395.059 369.225C391.43 369.225 388.225 367.968 386.243 366.042C385.511 366.172 384.749 366.248 383.96 366.248C380.048 366.248 376.698 364.557 375.285 362.154H469.881Z",
    fill: "#64AC65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.051 362.154C108.223 365.192 103.043 367.534 96.7597 367.534C90.5435 367.534 85.4096 365.242 84.4984 362.252C84.2172 362.276 83.9327 362.296 83.6369 362.296C83.1536 362.296 82.694 362.252 82.2503 362.191C81.2555 363.809 78.251 364.986 74.6965 364.986C73.4545 364.986 72.2848 364.838 71.2392 364.583C70.0502 367.401 65.0653 369.516 59.0922 369.516C54.2065 369.516 49.9915 368.098 47.9637 366.04C46.0804 366.963 43.5082 367.534 40.6662 367.534C36.5427 367.534 32.9894 366.333 31.2901 364.593C30.2558 364.843 29.1018 364.986 27.8779 364.986C24.2987 364.986 21.2783 363.791 20.3061 362.154H109.051Z",
    fill: "#64AC65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.423 362.154C880.65 366.127 875.811 369.189 869.943 369.189C864.136 369.189 859.34 366.192 858.49 362.282C858.227 362.314 857.961 362.34 857.685 362.34C857.234 362.34 856.804 362.282 856.389 362.202C855.461 364.318 852.654 365.857 849.334 365.857C848.174 365.857 847.082 365.664 846.104 365.33C844.994 369.015 840.338 371.782 834.758 371.782C830.195 371.782 826.258 369.926 824.364 367.236C822.604 368.443 820.202 369.189 817.548 369.189C813.696 369.189 810.377 367.619 808.79 365.344C807.823 365.669 806.746 365.857 805.603 365.857C802.259 365.857 799.437 364.295 798.53 362.154H881.423Z",
    fill: "#64AC65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1355.38 362.154C1354.11 364.543 1350.87 366.248 1347.04 366.248C1346.55 366.248 1346.07 366.213 1345.61 366.16C1343.7 369.484 1339.09 371.83 1333.69 371.83C1328.33 371.83 1323.74 369.506 1321.81 366.207C1319.75 366.045 1317.91 365.387 1316.53 364.405C1316.52 364.407 1316.5 364.409 1316.48 364.411C1316.48 364.439 1316.48 364.467 1316.48 364.495C1316.48 370.395 1309.72 375.179 1301.37 375.179C1294.62 375.179 1288.92 372.056 1286.96 367.746C1285.16 368.673 1282.95 369.225 1280.56 369.225C1276.93 369.225 1273.72 367.968 1271.74 366.042C1271.01 366.172 1270.24 366.248 1269.46 366.248C1265.54 366.248 1262.19 364.557 1260.78 362.154H1355.38Z",
    fill: "#57975A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1287.11 362.154C1285.85 364.543 1282.6 366.248 1278.78 366.248C1278.28 366.248 1277.81 366.213 1277.35 366.16C1275.43 369.484 1270.83 371.83 1265.43 371.83C1260.06 371.83 1255.48 369.506 1253.54 366.207C1251.49 366.045 1249.65 365.387 1248.27 364.405C1248.26 364.407 1248.24 364.409 1248.22 364.411C1248.22 364.439 1248.22 364.467 1248.22 364.495C1248.22 370.395 1241.45 375.179 1233.1 375.179C1226.36 375.179 1220.65 372.056 1218.7 367.746C1216.9 368.673 1214.69 369.225 1212.29 369.225C1208.66 369.225 1205.45 367.968 1203.48 366.042C1202.75 366.172 1201.98 366.248 1201.2 366.248C1197.28 366.248 1193.93 364.557 1192.52 362.154H1287.11Z",
    fill: "#64AC65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.998 472.619L942.828 475.308L946.083 483.658L947.249 475.449L944.998 472.619Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.582 472.006L947.248 470.071L961.76 466.344L950.665 472.006H945.582Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.234 467.288L943.579 470.165L945.04 472.005L941.494 472.383L928.234 467.288Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.249 472.006C947.249 471.833 947.188 471.668 947.078 471.519C946.74 471.07 945.955 470.755 945.041 470.755C943.818 470.755 942.828 471.315 942.828 472.006C942.828 472.696 943.818 473.256 945.041 473.256C946.26 473.256 947.249 472.696 947.249 472.006Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.533 470.929H944.633V451.052H945.533V470.929Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.289 352.111C424.289 352.111 412.808 351.502 410.606 351.502C408.404 351.502 405.678 352.111 403.477 352.111C401.275 352.111 332.233 352.111 329.402 352.111C326.571 352.111 312.626 352.994 309.166 353.237C305.707 353.481 302.142 353.481 301.251 354.485C300.359 355.49 299.888 359.082 300.412 359.965C300.936 360.848 301.67 360.665 302.404 362.218C303.138 363.77 304.92 367.393 305.549 367.606C306.178 367.819 312.679 368.062 319.18 369.402C325.68 370.742 333.701 373.116 345.601 373.756C357.501 374.395 368.196 374.03 376.898 372.173C385.6 370.316 397.291 366.358 400.541 365.962C403.791 365.567 414.223 364.654 419.833 362.979C425.442 361.305 426.386 359.996 427.067 358.23C427.748 356.464 427.5 354.478 427.657 354.204C427.815 353.93 427.893 353.656 427.657 353.382C427.421 353.108 426.551 352.229 424.289 352.111Z",
    fill: "#98C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.067 358.23C427.748 356.464 427.5 354.478 427.657 354.204C427.815 353.93 427.893 353.656 427.657 353.382C427.421 353.108 426.552 352.228 424.289 352.111C424.289 352.111 412.808 351.502 410.607 351.502C408.405 351.502 405.679 352.111 403.477 352.111C401.275 352.111 332.234 352.111 329.403 352.111C326.572 352.111 312.627 352.994 309.167 353.237C305.707 353.481 302.143 353.481 301.251 354.485C300.36 355.49 299.888 359.082 300.413 359.965C300.937 360.848 301.671 360.665 302.404 362.218C302.559 362.543 302.76 362.962 302.986 363.419L426.607 359.214C426.79 358.899 426.934 358.573 427.067 358.23Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.536 366.078C327.845 366.371 328.162 366.642 328.498 366.929C329.104 367.446 329.731 367.98 330.362 368.698L330.642 368.615C330.002 367.887 329.37 367.347 328.758 366.826C328.425 366.541 328.109 366.272 327.805 365.983C326.894 365.117 326.709 364.251 327.298 363.608C327.678 363.193 331.042 361.056 334.296 358.989C336.669 357.482 338.91 356.058 339.98 355.313C342.385 353.636 344.608 353.496 346.503 353.496H358.811C358.816 354.093 358.846 357.614 358.81 361.601C358.772 365.922 357.927 367.148 357.918 367.16L358.208 367.23C358.244 367.182 359.086 365.976 359.125 361.602C359.16 357.617 359.131 354.097 359.125 353.496H389.085C390.905 353.496 391.068 353.734 391.259 354.009C391.4 354.214 391.904 355.215 392.467 359.485C392.969 363.299 392.049 365.118 392.04 365.136L391.978 365.254H392.19C392.217 365.254 392.853 365.252 394.231 365.069C395.509 364.9 397.284 364.749 399.197 364.612C398.697 365.021 397.673 365.87 397.546 366.093C397.514 366.148 397.528 366.204 397.582 366.255C397.67 366.337 397.891 366.404 398.152 366.459C398.305 366.421 398.454 366.384 398.598 366.35C398.153 366.28 397.857 366.202 397.845 366.151C397.961 365.948 399.095 365.008 399.621 364.582C400.991 364.487 402.416 364.397 403.771 364.312C406.349 364.151 408.575 364.012 409.489 363.882C410.572 363.728 413.463 363.168 416.016 362.674C418.407 362.211 420.666 361.774 421.031 361.747C421.409 361.718 422.007 361.898 422.493 362.081C422.59 362.043 422.677 362.006 422.77 361.969C422.255 361.769 421.51 361.527 420.991 361.565C420.595 361.595 418.428 362.014 415.917 362.5C413.37 362.993 410.484 363.551 409.414 363.704C408.521 363.831 406.304 363.97 403.738 364.13C402.344 364.217 400.877 364.309 399.47 364.408L399.456 364.402C399.453 364.404 399.448 364.408 399.446 364.41C397.416 364.553 395.516 364.71 394.161 364.89C393.262 365.01 392.683 365.05 392.399 365.064C392.599 364.593 393.22 362.804 392.78 359.47C392.229 355.292 391.737 354.211 391.55 353.941C391.289 353.561 390.976 353.312 389.085 353.312H346.503C345.083 353.312 342.439 353.312 339.738 355.194C338.672 355.937 336.434 357.359 334.063 358.864C330.796 360.94 327.418 363.085 327.02 363.521C326.378 364.225 326.566 365.156 327.536 366.078Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.694 360.254C331.991 360.254 337.096 357.29 337.096 353.633C337.096 353.108 336.979 352.6 336.78 352.111C332.653 352.111 329.919 352.111 329.402 352.111C327.4 352.111 319.846 352.552 314.366 352.897C314.32 353.139 314.292 353.383 314.292 353.633C314.291 357.29 319.396 360.254 325.694 360.254Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.476 352.111C403.031 352.111 399.845 352.111 395.024 352.111C394.826 352.6 394.709 353.108 394.709 353.633C394.709 357.29 399.814 360.254 406.111 360.254C412.409 360.254 417.513 357.29 417.513 353.633C417.513 352.977 417.343 352.346 417.037 351.748C414.276 351.617 411.563 351.502 410.605 351.502C408.404 351.502 405.678 352.111 403.476 352.111Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.111 347.788C400.552 347.788 396.045 350.405 396.045 353.633C396.045 356.861 400.552 359.478 406.111 359.478C411.67 359.478 416.176 356.861 416.176 353.633C416.176 350.405 411.67 347.788 406.111 347.788Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.233 353.633C399.233 351.427 402.313 349.638 406.112 349.638C409.912 349.638 412.991 351.427 412.991 353.633C412.991 355.839 409.911 357.628 406.112 357.628C402.313 357.628 399.233 355.839 399.233 353.633Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.693 347.788C320.134 347.788 315.628 350.405 315.628 353.633C315.628 356.861 320.134 359.478 325.693 359.478C331.252 359.478 335.759 356.861 335.759 353.633C335.759 350.405 331.252 347.788 325.693 347.788Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.695 349.638C321.896 349.638 318.816 351.427 318.816 353.633C318.816 355.839 321.896 357.628 325.695 357.628C329.494 357.628 332.574 355.839 332.574 353.633C332.574 351.427 329.494 349.638 325.695 349.638Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.223 373.131C361.332 373.053 364.946 373.108 370.608 372.401C376.27 371.693 385.588 368.816 389.363 367.446C393.137 366.076 396.401 364.706 396.401 364.706C396.401 364.706 375.877 365.665 364.986 366.167C354.095 366.67 336.48 367.332 334.357 367.469C332.234 367.606 324.135 368.93 324.292 369.181C324.449 369.433 338.368 373.633 358.223 373.131Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.038 366.711C360.648 366.728 360.679 366.807 360.58 367.024C360.482 367.241 359.414 372.05 359.354 372.264C359.293 372.477 359.309 372.743 359.597 372.737V372.738C359.662 372.737 359.721 372.735 359.787 372.734C362.606 372.684 365.8 372.627 370.474 372.043C376.219 371.325 385.62 368.372 389.027 367.136C389.767 366.867 390.489 366.598 391.17 366.339C392.308 365.907 392.048 365.275 390.697 365.339C383.805 365.66 372.284 366.197 365.034 366.532C363.784 366.59 362.437 366.65 361.038 366.711Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.452 363.793C412.99 363.496 417.63 362.766 420.344 362.104C423.057 361.442 424.983 360.186 424.826 359.706C424.669 359.227 420.383 359.729 417.316 360.551C414.249 361.373 409.067 363.825 409.452 363.793Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.233 368.94C332.233 369.417 333.694 371.014 335.945 371.401C340.958 372.165 347.424 372.808 354.925 372.808C355.014 372.808 355.103 372.806 355.192 372.806C355.439 372.801 355.561 372.65 355.574 372.53C355.587 372.408 355.803 367.64 355.784 367.298C355.764 366.955 355.076 366.964 355.076 366.964C351.867 367.098 348.628 367.23 345.729 367.348C339.976 367.582 335.433 367.767 334.425 367.832C334.225 367.845 333.975 367.868 333.696 367.898C332.366 368.069 332.233 368.459 332.233 368.94Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.404 362.218C302.755 362.957 303.341 364.165 303.929 365.251C304.264 365.45 304.879 365.696 305.943 365.749C307.778 365.841 315.719 365.81 315.825 365.749C315.929 365.688 315.851 365.217 314.619 364.882C313.452 364.564 305.158 362.854 302.328 362.067C302.353 362.117 302.379 362.164 302.404 362.218Z",
    fill: "#F7A47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.697 354.067C424.657 354.067 423.611 354.484 423.35 355.029L422.826 356.141C422.506 356.803 423.256 357.378 424.509 357.378H427.325C427.677 355.875 427.524 354.434 427.656 354.205C427.683 354.159 427.702 354.113 427.722 354.068H425.697V354.067Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.317 364.172C362.245 363.82 363.218 363.464 364.49 363.376C365.762 363.288 366.852 363.503 366.924 363.855C366.995 364.206 366.022 364.563 364.751 364.651C363.478 364.738 362.389 364.523 362.317 364.172Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.56 364.224C361.523 364.045 362.863 363.804 364.552 363.688C366.242 363.572 367.64 363.623 367.677 363.803C367.714 363.982 366.374 364.222 364.685 364.338C362.995 364.454 361.596 364.403 361.56 364.224Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.137 365.086C331.065 364.735 332.038 364.378 333.31 364.29C334.582 364.203 335.672 364.417 335.743 364.768C335.815 365.12 334.842 365.476 333.571 365.565C332.297 365.652 331.208 365.438 331.137 365.086Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.38 365.138C330.342 364.959 331.682 364.719 333.372 364.603C335.061 364.486 336.46 364.538 336.497 364.717C336.534 364.896 335.194 365.136 333.505 365.252C331.816 365.369 330.416 365.318 330.38 365.138Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.161 379.977C867.161 379.977 872.712 379.792 873.163 379.748C873.613 379.704 873.738 379.341 873.313 379.152C872.887 378.963 871.461 378.309 871.461 378.309L867.161 379.977Z",
    fill: "#F26721"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.283 360.776C772.283 359.847 772.634 358.8 774.686 358.597C776.739 358.393 780.744 358.19 781.996 358.19C783.247 358.19 879.375 358.19 881.278 358.19C883.18 358.19 885.984 359.12 887.236 360.37C888.487 361.62 888.187 362.609 888.187 363.743C888.187 364.877 886.084 366.301 886.084 366.853C886.084 367.406 886.084 370.168 886.084 370.749C886.084 371.331 884.855 372.377 883.417 373.104C881.978 373.831 871.014 379.471 867.859 379.908C864.705 380.344 836.017 380.896 832.362 380.838C828.707 380.78 825.853 379.82 825.152 379.646C824.452 379.471 804.926 372.988 804.475 372.901C804.025 372.814 792.409 371.68 787.002 370.895C781.594 370.11 777.837 369.733 774.886 367.609C772.583 365.952 772.283 362.868 772.283 360.776Z",
    fill: "url(#paint124_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.948 368.278C775.583 368.076 775.228 367.856 774.887 367.609C772.583 365.952 772.283 362.868 772.283 360.776C772.283 359.847 772.634 358.8 774.686 358.597C776.739 358.393 780.744 358.19 781.996 358.19C783.247 358.19 879.375 358.19 881.278 358.19C883.18 358.19 885.984 359.12 887.236 360.37C888.487 361.62 888.187 362.609 888.187 363.743C888.187 364.877 886.084 366.301 886.084 366.853C886.084 367.072 886.084 367.639 886.084 368.278H775.948Z",
    fill: "url(#paint125_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.745 372.733C840.101 372.747 840.236 372.912 840.292 373.032C840.349 373.152 842.062 378.886 842.119 379.083C842.175 379.279 842.357 379.517 841.931 379.516V379.518C839.532 379.515 837.283 379.502 835.467 379.486C834.415 379.477 830.134 378.963 827.468 378.112C824.802 377.262 816.804 374.165 815.489 373.555C814.175 372.944 814.4 371.875 816.766 371.875C817.882 371.876 828.634 372.292 839.745 372.733Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.407 374.558C865.807 375.496 862.268 378.717 859.911 379.093C857.995 379.399 851.18 379.501 844.666 379.516C844.384 379.517 844.252 379.388 844.215 379.203C844.177 379.017 843.539 373.424 843.558 373.162C843.576 372.904 843.958 372.9 843.969 372.9C854.972 373.339 865.164 373.751 865.393 373.751C866.152 373.751 866.654 374.174 866.407 374.558Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.808 366.955C867.544 366.955 862.468 364.007 862.468 360.37C862.468 359.605 862.704 358.873 863.117 358.19C873.506 358.19 880.771 358.19 881.28 358.19C882.341 358.19 883.68 358.479 884.876 358.952C885.049 359.409 885.147 359.883 885.147 360.37C885.148 364.008 880.07 366.955 873.808 366.955Z",
    fill: "#F26721"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.391 358.19C803.804 358.873 804.041 359.605 804.041 360.37C804.041 364.007 798.963 366.955 792.701 366.955C786.437 366.955 781.361 364.007 781.361 360.37C781.361 359.605 781.597 358.873 782.01 358.19C782.482 358.19 791.245 358.19 803.391 358.19Z",
    fill: "#F26721"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.699 354.788C798.008 354.788 802.312 357.287 802.312 360.37C802.312 363.453 798.008 365.953 792.699 365.953C787.39 365.953 783.086 363.453 783.086 360.37C783.086 357.287 787.39 354.788 792.699 354.788Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.269 360.37C799.269 358.263 796.329 356.555 792.7 356.555C789.071 356.555 786.13 358.263 786.13 360.37C786.13 362.478 789.072 364.185 792.7 364.185C796.329 364.185 799.269 362.478 799.269 360.37Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.81 354.788C879.119 354.788 883.422 357.287 883.422 360.37C883.422 363.453 879.119 365.953 873.81 365.953C868.501 365.953 864.197 363.453 864.197 360.37C864.197 357.287 868.501 354.788 873.81 354.788Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.376 360.37C880.376 358.263 877.435 356.555 873.807 356.555C870.178 356.555 867.237 358.263 867.237 360.37C867.237 362.478 870.178 364.185 873.807 364.185C877.435 364.185 880.376 362.478 880.376 360.37Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.558 379.812C857.67 379.978 839.398 380.285 834.662 380.285C834.063 380.285 833.682 380.28 833.5 380.271C831.743 380.184 829.881 379.786 828.894 379.453C828.773 379.412 816.715 375.356 812.887 373.801C808.924 372.192 806.514 371.012 806.477 368.192C806.455 366.514 806.814 365.31 807.101 364.343C807.304 363.663 807.479 363.076 807.479 362.493V360.05C807.479 359.819 807.479 359.338 808.555 359.338H855.592C856.778 359.338 857.063 359.738 857.094 360.075C857.114 360.297 857.388 361.538 860.818 364.132C861.609 364.73 862.4 365.289 863.165 365.83C865.467 367.458 867.456 368.863 867.943 370.311C868.504 371.979 868.852 373.96 865.852 376.375C863.057 378.627 861.618 379.632 859.558 379.812ZM808.555 359.513C807.837 359.513 807.779 359.756 807.779 360.051V362.493C807.779 363.092 807.602 363.685 807.398 364.373C807.112 365.333 806.756 366.528 806.778 368.191C806.814 370.982 809.189 372.087 813.06 373.658C816.878 375.208 828.923 379.261 829.045 379.302C830.004 379.625 831.815 380.013 833.525 380.097C833.697 380.106 834.08 380.11 834.662 380.11C836.387 380.11 840.172 380.054 843.698 380C843.54 379.493 842.217 377.021 841.852 372.779C841.612 372.579 840.04 371.139 839.934 367.451C839.856 364.725 839.96 362.483 840.029 360.999C840.058 360.377 840.08 359.883 840.083 359.512L808.555 359.513ZM867.649 370.345C867.176 368.941 865.21 367.551 862.933 365.941C862.167 365.399 861.374 364.839 860.58 364.239C857.184 361.67 856.824 360.409 856.795 360.084C856.759 359.694 856.377 359.513 855.592 359.513H840.384C840.381 359.885 840.358 360.38 840.329 361.004C840.261 362.486 840.157 364.726 840.235 367.448C840.345 371.289 842.101 372.682 842.119 372.696L842.148 372.717L842.15 372.744C842.521 377.081 843.867 379.567 844.002 379.995C850.91 379.888 858.408 379.736 859.513 379.64C861.459 379.469 862.865 378.483 865.61 376.273C868.253 374.145 868.35 372.427 867.649 370.345Z",
    fill: "#F26721"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.741 370.081C783.975 370.076 784.117 370.046 784.297 370.009C784.637 369.937 785.06 369.849 786.275 369.849C787.489 369.849 794.235 370.51 796.274 370.713C804.925 371.574 804.968 371.658 804.995 371.715C805.074 371.876 804.265 372.394 803.183 372.754C803.039 372.739 802.884 372.722 802.72 372.705C803.814 372.397 804.526 371.932 804.677 371.794C803.238 371.57 788.062 370.023 786.275 370.023C785.113 370.023 784.717 370.106 784.399 370.173C784.202 370.215 784.034 370.25 783.752 370.256C783.49 370.261 782.9 370.231 782.257 370.19C781.74 370.104 781.24 370.013 780.759 369.914C781.742 369.987 783.29 370.094 783.741 370.081Z",
    fill: "#F26721"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.766 372.443C806.18 372.268 807.062 372.301 807.738 372.53C808.414 372.759 825.386 378.941 825.611 379.017C825.837 379.094 825.874 379.312 825.724 379.432C825.657 379.485 825.426 379.574 825.193 379.656C825.181 379.653 825.165 379.649 825.154 379.646C824.478 379.478 806.302 373.445 804.602 372.936C804.915 372.804 805.476 372.565 805.766 372.443Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.638 360.661V361.911C775.638 362.489 774.83 362.957 773.835 362.957H772.423C772.312 362.183 772.283 361.431 772.283 360.776C772.283 360.385 772.347 359.974 772.571 359.614H773.835C774.831 359.614 775.638 360.083 775.638 360.661Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.261 364.185C773.367 364.568 773.962 366.563 775.239 367.29C776.516 368.017 781.197 369.122 781.597 369.02C781.998 368.918 780.245 366.839 779.169 365.952C778.093 365.066 773.115 363.651 773.261 364.185Z",
    fill: "#E6EBEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.248 366.056C777.06 365.455 776.369 364.967 775.704 364.967C775.039 364.967 774.652 365.454 774.841 366.056C775.029 366.657 775.72 367.144 776.386 367.144C777.051 367.144 777.436 366.657 777.248 366.056Z",
    fill: "#F26721"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.332 367.242C779.212 366.858 778.77 366.547 778.346 366.547C777.921 366.547 777.675 366.858 777.795 367.242C777.915 367.626 778.357 367.936 778.781 367.936C779.206 367.936 779.452 367.625 779.332 367.242Z",
    fill: "#B0BABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.419 369.877V368.002C883.419 367.424 884.226 366.955 885.222 366.955H886.086C886.086 367.679 886.086 370.196 886.086 370.749C886.086 370.802 886.066 370.864 886.046 370.924H885.222C884.226 370.924 883.419 370.455 883.419 369.877Z",
    fill: "#F26721"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.418 373.104C882.41 373.614 876.728 376.533 872.33 378.387C872.21 378.223 872.095 377.987 872.291 377.829C872.616 377.567 883.181 372.436 883.631 372.29C883.902 372.203 884.362 372.222 884.704 372.327C884.318 372.602 883.881 372.87 883.418 373.104Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.681 371.148H833.174C832.656 371.148 832.236 370.904 832.236 370.603H838.619C838.619 370.904 838.199 371.148 837.681 371.148Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.174 370.058H837.681C838.199 370.058 838.619 370.302 838.619 370.603H832.236C832.236 370.302 832.656 370.058 833.174 370.058Z",
    fill: "#F26721"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.716 371.148H860.21C859.692 371.148 859.271 370.904 859.271 370.603H865.655C865.655 370.904 865.235 371.148 864.716 371.148Z",
    fill: "#BAD8DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.213 370.058H864.72C865.238 370.058 865.659 370.302 865.659 370.603H859.275C859.275 370.302 859.695 370.058 860.213 370.058Z",
    fill: "#F26721"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.84 358.941C1059.84 358.941 1069.23 358.444 1071.03 358.444C1072.83 358.444 1075.06 358.941 1076.86 358.941C1078.66 358.941 1135.11 358.941 1137.43 358.941C1139.74 358.941 1151.14 359.663 1153.97 359.863C1156.8 360.062 1159.72 360.062 1160.45 360.883C1161.17 361.704 1161.56 364.642 1161.13 365.364C1160.7 366.086 1160.1 365.936 1159.5 367.206C1158.9 368.475 1157.45 371.438 1156.93 371.612C1156.42 371.786 1151.1 371.985 1145.79 373.08C1140.47 374.176 1133.91 376.117 1124.18 376.64C1114.45 377.163 1105.71 376.864 1098.59 375.346C1091.47 373.828 1081.91 370.591 1079.26 370.268C1076.6 369.944 1068.07 369.198 1063.48 367.828C1058.9 366.459 1058.12 365.389 1057.57 363.945C1057.01 362.501 1057.21 360.877 1057.08 360.653C1056.96 360.429 1056.89 360.205 1057.08 359.981C1057.28 359.757 1057.99 359.038 1059.84 358.941Z",
    fill: "#E7EAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.57 363.945C1057.01 362.501 1057.21 360.877 1057.08 360.653C1056.96 360.429 1056.89 360.205 1057.08 359.981C1057.28 359.757 1057.99 359.038 1059.84 358.941C1059.84 358.941 1069.23 358.444 1071.03 358.444C1072.83 358.444 1075.06 358.941 1076.86 358.941C1078.66 358.941 1135.11 358.941 1137.43 358.941C1139.74 358.941 1151.14 359.663 1153.97 359.863C1156.8 360.062 1159.72 360.062 1160.45 360.883C1161.17 361.704 1161.56 364.642 1161.13 365.364C1160.7 366.086 1160.1 365.936 1159.5 367.206C1159.38 367.472 1159.21 367.814 1159.03 368.188L1057.94 364.749C1057.79 364.492 1057.68 364.226 1057.57 363.945Z",
    fill: "#B0BABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138.95 370.362C1138.7 370.602 1138.44 370.823 1138.17 371.058C1137.67 371.48 1137.16 371.917 1136.64 372.504L1136.41 372.436C1136.94 371.841 1137.45 371.4 1137.95 370.973C1138.23 370.741 1138.48 370.521 1138.73 370.284C1139.48 369.576 1139.63 368.868 1139.15 368.342C1138.84 368.003 1136.09 366.255 1133.43 364.565C1131.48 363.333 1129.65 362.169 1128.78 361.559C1126.81 360.189 1124.99 360.074 1123.44 360.074H1113.38C1113.37 360.562 1113.35 363.441 1113.38 366.701C1113.41 370.235 1114.1 371.237 1114.11 371.247L1113.87 371.304C1113.84 371.264 1113.15 370.279 1113.12 366.702C1113.09 363.443 1113.12 360.565 1113.12 360.074H1088.62C1087.14 360.074 1087 360.268 1086.85 360.494C1086.73 360.661 1086.32 361.48 1085.86 364.971C1085.45 368.09 1086.2 369.577 1086.21 369.592L1086.26 369.688H1086.09C1086.06 369.688 1085.54 369.687 1084.42 369.537C1083.37 369.399 1081.92 369.276 1080.36 369.164C1080.76 369.498 1081.6 370.192 1081.71 370.375C1081.73 370.419 1081.72 370.465 1081.68 370.507C1081.6 370.574 1081.42 370.628 1081.21 370.674C1081.09 370.643 1080.96 370.613 1080.85 370.584C1081.21 370.527 1081.45 370.464 1081.46 370.422C1081.37 370.256 1080.44 369.487 1080.01 369.139C1078.89 369.061 1077.72 368.988 1076.62 368.918C1074.51 368.787 1072.69 368.673 1071.94 368.566C1071.06 368.44 1068.69 367.983 1066.6 367.579C1064.65 367.2 1062.8 366.843 1062.5 366.821C1062.19 366.797 1061.7 366.944 1061.31 367.094C1061.23 367.063 1061.16 367.033 1061.08 367.002C1061.5 366.838 1062.11 366.641 1062.54 366.672C1062.86 366.696 1064.63 367.039 1066.68 367.436C1068.77 367.839 1071.13 368.296 1072 368.421C1072.73 368.525 1074.54 368.638 1076.64 368.769C1077.78 368.84 1078.98 368.916 1080.13 368.997L1080.14 368.992C1080.15 368.993 1080.15 368.996 1080.15 368.998C1081.81 369.115 1083.37 369.244 1084.47 369.391C1085.21 369.489 1085.68 369.522 1085.91 369.533C1085.75 369.148 1085.24 367.685 1085.6 364.959C1086.05 361.543 1086.46 360.659 1086.61 360.437C1086.82 360.127 1087.08 359.924 1088.62 359.924H1123.44C1124.6 359.924 1126.77 359.924 1128.98 361.463C1129.85 362.07 1131.68 363.232 1133.62 364.463C1136.29 366.16 1139.05 367.915 1139.37 368.271C1139.9 368.847 1139.75 369.608 1138.95 370.362Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140.46 365.6C1135.31 365.6 1131.14 363.176 1131.14 360.186C1131.14 359.757 1131.23 359.341 1131.39 358.941C1134.77 358.941 1137 358.941 1137.43 358.941C1139.06 358.941 1145.24 359.302 1149.72 359.584C1149.76 359.782 1149.78 359.982 1149.78 360.186C1149.78 363.176 1145.61 365.6 1140.46 365.6Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.86 358.941C1077.22 358.941 1079.82 358.941 1083.77 358.941C1083.93 359.341 1084.02 359.757 1084.02 360.186C1084.02 363.176 1079.85 365.6 1074.7 365.6C1069.55 365.6 1065.38 363.176 1065.38 360.186C1065.38 359.65 1065.52 359.133 1065.77 358.644C1068.02 358.538 1070.24 358.444 1071.03 358.444C1072.83 358.444 1075.05 358.941 1076.86 358.941Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.7 355.407C1079.25 355.407 1082.93 357.546 1082.93 360.186C1082.93 362.826 1079.25 364.965 1074.7 364.965C1070.16 364.965 1066.47 362.826 1066.47 360.186C1066.47 357.546 1070.16 355.407 1074.7 355.407Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080.33 360.186C1080.33 358.382 1077.81 356.92 1074.7 356.92C1071.59 356.92 1069.08 358.382 1069.08 360.186C1069.08 361.99 1071.6 363.452 1074.7 363.452C1077.81 363.452 1080.33 361.99 1080.33 360.186Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140.46 355.407C1145.01 355.407 1148.69 357.546 1148.69 360.186C1148.69 362.826 1145.01 364.965 1140.46 364.965C1135.91 364.965 1132.23 362.826 1132.23 360.186C1132.23 357.546 1135.91 355.407 1140.46 355.407Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140.46 356.92C1143.57 356.92 1146.09 358.382 1146.09 360.186C1146.09 361.99 1143.57 363.452 1140.46 363.452C1137.35 363.452 1134.84 361.99 1134.84 360.186C1134.84 358.382 1137.35 356.92 1140.46 356.92Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1113.86 376.129C1111.32 376.065 1108.36 376.111 1103.73 375.532C1099.1 374.953 1091.48 372.601 1088.4 371.481C1085.31 370.361 1082.64 369.24 1082.64 369.24C1082.64 369.24 1099.42 370.024 1108.33 370.435C1117.24 370.846 1131.64 371.387 1133.37 371.499C1135.11 371.611 1141.73 372.694 1141.61 372.9C1141.48 373.105 1130.1 376.54 1113.86 376.129Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1111.56 370.88C1111.88 370.894 1111.85 370.958 1111.93 371.136C1112.01 371.313 1112.89 375.246 1112.94 375.42C1112.98 375.595 1112.97 375.812 1112.74 375.808V375.808C1112.68 375.807 1112.64 375.806 1112.58 375.805C1110.28 375.764 1107.66 375.717 1103.84 375.24C1099.15 374.653 1091.46 372.238 1088.67 371.227C1088.07 371.008 1087.48 370.788 1086.92 370.576C1085.99 370.222 1086.2 369.706 1087.31 369.758C1092.94 370.02 1102.36 370.46 1108.29 370.733C1109.31 370.781 1110.41 370.83 1111.56 370.88Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.97 368.494C1069.08 368.251 1065.28 367.654 1063.07 367.113C1060.85 366.571 1059.27 365.544 1059.4 365.152C1059.53 364.76 1063.03 365.171 1065.54 365.843C1068.05 366.515 1072.29 368.52 1071.97 368.494Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.11 372.702C1135.11 373.092 1133.92 374.398 1132.08 374.715C1127.98 375.339 1122.69 375.865 1116.56 375.865C1116.48 375.865 1116.41 375.863 1116.34 375.863C1116.14 375.859 1116.04 375.736 1116.02 375.638C1116.01 375.538 1115.84 371.639 1115.85 371.359C1115.87 371.079 1116.43 371.086 1116.43 371.086C1119.06 371.196 1121.7 371.304 1124.08 371.4C1128.78 371.592 1132.49 371.743 1133.32 371.796C1133.48 371.807 1133.69 371.826 1133.91 371.85C1135 371.99 1135.11 372.309 1135.11 372.702Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.5 367.206C1159.22 367.81 1158.74 368.797 1158.26 369.686C1157.98 369.849 1157.48 370.05 1156.61 370.093C1155.11 370.168 1148.62 370.143 1148.53 370.093C1148.45 370.043 1148.51 369.658 1149.52 369.384C1150.47 369.124 1157.25 367.726 1159.57 367.082C1159.55 367.123 1159.53 367.161 1159.5 367.206Z",
    fill: "url(#paint126_linear_811_11692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.69 360.541C1059.54 360.541 1060.39 360.882 1060.61 361.328L1061.03 362.237C1061.3 362.778 1060.68 363.248 1059.66 363.248H1057.36C1057.07 362.02 1057.19 360.841 1057.09 360.653C1057.06 360.616 1057.05 360.579 1057.03 360.541H1058.69V360.541Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.51 368.804C1110.57 368.516 1109.78 368.224 1108.74 368.153C1107.7 368.081 1106.81 368.256 1106.75 368.544C1106.69 368.832 1107.48 369.123 1108.52 369.195C1109.56 369.266 1110.46 369.091 1110.51 368.804Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1111.13 368.846C1111.16 368.699 1110.07 368.503 1108.69 368.408C1107.31 368.313 1106.16 368.355 1106.13 368.501C1106.1 368.648 1107.2 368.844 1108.58 368.939C1109.96 369.034 1111.1 368.993 1111.13 368.846Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1136.01 369.551C1136.07 369.264 1135.27 368.972 1134.23 368.9C1133.19 368.829 1132.3 369.004 1132.24 369.291C1132.19 369.579 1132.98 369.87 1134.02 369.942C1135.06 370.014 1135.95 369.839 1136.01 369.551Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1136.63 369.594C1136.66 369.447 1135.56 369.251 1134.18 369.156C1132.8 369.061 1131.66 369.103 1131.63 369.249C1131.6 369.396 1132.69 369.592 1134.07 369.687C1135.46 369.782 1136.6 369.741 1136.63 369.594Z",
    fill: "#CCCCCC"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400.754 150.261V75.9535H390.314V56.0496H386.584V26.8564H366.035V5.4023H364.206V26.8564H360.18V0H358.353V26.8564H345.361V75.9535H338.651V150.261H332.898V285.607H404.799V150.261H400.754Z",
    fill: "url(#paint127_linear_811_11692)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M351.909 32.3728H349.057V41.4388H351.909V32.3728Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M358.945 32.3728H356.093V41.4388H358.945V32.3728Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M365.977 32.3728H363.126V41.4388H365.977V32.3728Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M373.017 32.3728H370.166V41.4388H373.017V32.3728Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M351.909 47.4715H349.057V56.5375H351.909V47.4715Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M358.945 47.4715H356.093V56.5375H358.945V47.4715Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M365.977 47.4715H363.126V56.5375H365.977V47.4715Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M373.017 47.4715H370.166V56.5375H373.017V47.4715Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M351.909 62.5703H349.057V71.6363H351.909V62.5703Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M358.945 62.5703H356.093V71.6363H358.945V62.5703Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M380.998 32.3728H378.146V41.4388H380.998V32.3728Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M364.208 142.804H304.35V298.066H364.208V142.804Z",
    fill: "#F7A47A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M358.329 137.467H310.231V163.328H358.329V137.467Z",
    fill: "#F7A47A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M368.848 146.052H299.71V147.868H368.848V146.052Z",
    fill: "#F7A47A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M309.058 153.083H307.607V162.652H309.058V153.083Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M314.059 153.083H312.609V162.652H314.059V153.083Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M319.057 153.083H317.607V162.652H319.057V153.083Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M324.055 153.083H322.605V162.652H324.055V153.083Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M329.057 153.083H327.606V162.652H329.057V153.083Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M334.054 153.083H332.604V162.652H334.054V153.083Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M339.057 153.083H337.606V162.652H339.057V153.083Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M344.055 153.083H342.604V162.652H344.055V153.083Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M349.056 153.083H347.606V162.652H349.056V153.083Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M354.055 153.083H352.604V162.652H354.055V153.083Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M359.052 153.083H357.602V162.652H359.052V153.083Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M309.058 166.405H307.607V175.974H309.058V166.405Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M314.059 166.405H312.609V175.974H314.059V166.405Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M319.057 166.405H317.607V175.974H319.057V166.405Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M324.055 166.405H322.605V175.974H324.055V166.405Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M329.057 166.405H327.606V175.974H329.057V166.405Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M334.054 166.405H332.604V175.974H334.054V166.405Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M339.057 166.405H337.606V175.974H339.057V166.405Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M344.055 166.405H342.604V175.974H344.055V166.405Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M349.056 166.405H347.606V175.974H349.056V166.405Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M354.055 166.405H352.604V175.974H354.055V166.405Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M359.052 166.405H357.602V175.974H359.052V166.405Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M309.058 179.727H307.607V189.296H309.058V179.727Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M314.059 179.727H312.609V189.296H314.059V179.727Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M319.057 179.727H317.607V189.296H319.057V179.727Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M324.055 179.727H322.605V189.296H324.055V179.727Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M329.057 179.727H327.606V189.296H329.057V179.727Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M334.054 179.727H332.604V189.296H334.054V179.727Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M339.057 179.727H337.606V189.296H339.057V179.727Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M344.055 179.727H342.604V189.296H344.055V179.727Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M349.056 179.727H347.606V189.296H349.056V179.727Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M354.055 179.727H352.604V189.296H354.055V179.727Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M359.052 179.727H357.602V189.296H359.052V179.727Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M324.055 193.05H322.605V202.619H324.055V193.05Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M329.057 193.05H327.606V202.619H329.057V193.05Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M334.054 193.05H332.604V202.619H334.054V193.05Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M339.057 193.05H337.606V202.619H339.057V193.05Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M344.055 193.05H342.604V202.619H344.055V193.05Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M349.056 193.05H347.606V202.619H349.056V193.05Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M354.055 193.05H352.604V202.619H354.055V193.05Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M359.052 193.05H357.602V202.619H359.052V193.05Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M329.057 207.11H327.606V216.679H329.057V207.11Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M334.054 207.11H332.604V216.679H334.054V207.11Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M339.057 207.11H337.606V216.679H339.057V207.11Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M344.055 207.11H342.604V216.679H344.055V207.11Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M349.056 207.11H347.606V216.679H349.056V207.11Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M354.055 207.11H352.604V216.679H354.055V207.11Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M359.052 207.11H357.602V216.679H359.052V207.11Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M777.288 193.95V126.494H787.908V108.425H791.702V81.9234H812.606V81.9536H814.467V81.9234H818.562V57.5432H820.421V81.9234H833.637V126.494H840.463V193.95H846.315V316.817H773.173V193.95H777.288Z",
    fill: "url(#paint128_linear_811_11692)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M826.976 86.9311H829.876V95.1611H826.976V86.9311Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M819.817 86.9311H822.718V95.1611H819.817V86.9311Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M812.667 86.9311H815.567V95.1611H812.667V86.9311Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M805.504 86.9311H808.404V95.1611H805.504V86.9311Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M826.976 100.638H829.876V108.868H826.976V100.638Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M819.817 100.638H822.718V108.868H819.817V100.638Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M812.667 100.638H815.567V108.868H812.667V100.638Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M805.504 100.638H808.404V108.868H805.504V100.638Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M826.976 114.344H829.876V122.575H826.976V114.344Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M819.817 114.344H822.718V122.575H819.817V114.344Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M797.385 86.9311H800.285V95.1611H797.385V86.9311Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M1449 334.531H-3.09912V362.815H1449V334.531Z",
    fill: "#69ABB9"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M1449 331.605H-4.07434V353.062H1449V331.605Z",
    fill: "#003940"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1449 333.556H-0.173462V351.111H1449V333.556Z",
    fill: "#003940"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M374.424 341.452H339.016V343.791H374.424V341.452Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M306.215 341.452H270.807V343.791H306.215V341.452Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M442.628 341.452H407.22V343.791H442.628V341.452Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M510.84 341.452H475.432V343.791H510.84V341.452Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M169.795 341.452H134.388V343.791H169.795V341.452Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M238.007 341.452H202.599V343.791H238.007V341.452Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M101.591 341.452H66.1832V343.791H101.591V341.452Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3821 341.452H-0.302979V343.791H33.3821V341.452Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M783.676 341.452H748.264V343.791H783.676V341.452Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M850.16 341.452H816.476V343.791H850.16V341.452Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M917.001 341.452H883.317V343.791H917.001V341.452Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M975.514 341.452H941.83V343.791H975.514V341.452Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M1034.03 341.452H1000.34V343.791H1034.03V341.452Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M1092.54 341.452H1058.86V343.791H1092.54V341.452Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M1151.05 341.452H1117.37V343.791H1151.05V341.452Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M1209.57 341.452H1175.88V343.791H1209.57V341.452Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M1268.08 341.452H1234.39V343.791H1268.08V341.452Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M1326.59 341.452H1292.91V343.791H1326.59V341.452Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M1385.11 341.452H1351.42V343.791H1385.11V341.452Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M1443.62 341.452H1409.93V343.791H1443.62V341.452Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M579.048 341.452H543.64V343.791H579.048V341.452Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M647.257 341.452H611.848V343.791H647.257V341.452Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M715.465 341.452H680.06V343.791H715.465V341.452Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M257.068 47.8766L253.44 40.1304L258.881 16.0764L260.834 39.7228L257.068 47.8766Z",
    fill: "#F7A47A"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M258.042 49.6436L260.832 55.2152L285.106 65.9514L266.552 49.6436H258.042Z",
    fill: "#F7A47A"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M229.029 63.233L254.696 54.9437L257.139 49.6437L251.21 48.5559L229.029 63.233Z",
    fill: "#F7A47A"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M257.975 51.1337H256.301V117.384H257.975V51.1337Z",
    fill: "#003940"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M260.834 49.644C260.834 50.1414 260.732 50.6151 260.544 51.0457C259.983 52.338 258.669 53.2455 257.138 53.2455C255.096 53.2455 253.44 51.6335 253.44 49.644C253.44 47.6553 255.095 46.0424 257.138 46.0424C259.179 46.0424 260.834 47.6545 260.834 49.644Z",
    fill: "#F7A47A"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M808.979 170.46L805.349 162.714L810.794 138.66L812.743 162.307L808.979 170.46Z",
    fill: "#F7A47A"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M809.954 172.227L812.741 177.799L837.014 188.536L818.461 172.227H809.954Z",
    fill: "#F7A47A"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M780.938 185.816L806.604 177.527L809.042 172.227L803.115 171.139L780.938 185.816Z",
    fill: "#F7A47A"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M809.88 173.717H808.206V239.968H809.88V173.717Z",
    fill: "#003940"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M812.743 172.227C812.743 172.725 812.643 173.198 812.455 173.629C811.893 174.921 810.58 175.829 809.046 175.829C807.003 175.829 805.349 174.217 805.349 172.227C805.349 170.238 807.003 168.626 809.046 168.626C811.089 168.626 812.743 170.238 812.743 172.227Z",
    fill: "#F7A47A"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M525.671 129.608L522.882 123.654L527.064 105.167L528.565 123.341L525.671 129.608Z",
    fill: "#F7A47A"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M526.421 130.966L528.566 135.249L547.222 143.5L532.961 130.966H526.421Z",
    fill: "#F7A47A"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M504.121 141.41L523.848 135.039L525.724 130.966L521.168 130.13L504.121 141.41Z",
    fill: "#F7A47A"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M526.367 132.111H525.08V183.03H526.367V132.111Z",
    fill: "#003940"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M528.565 130.966C528.565 131.349 528.486 131.713 528.342 132.044C527.911 133.037 526.901 133.735 525.724 133.735C524.155 133.735 522.882 132.495 522.882 130.966C522.882 129.438 524.154 128.198 525.724 128.198C527.293 128.198 528.565 129.438 528.565 130.966Z",
    fill: "#F7A47A"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M274.472 107.688H236.641V287.138H274.472V107.688Z",
    fill: "url(#paint129_linear_811_11692)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M268.288 94.8235H242.82V170.234H268.288V94.8235Z",
    fill: "url(#paint130_linear_811_11692)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M262.619 86.6625H248.492V128.492H262.619V86.6625Z",
    fill: "url(#paint131_linear_811_11692)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M260.367 108.157H250.739V79.651H254.212H257.654H260.367V108.157Z",
    fill: "url(#paint132_linear_811_11692)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M254.919 95.7429H253.875V67.2372H254.252H254.625H254.919V95.7429Z",
    fill: "url(#paint133_linear_811_11692)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M257.235 85.8888H256.191V57.3832H256.567H256.941H257.235V85.8888Z",
    fill: "url(#paint134_linear_811_11692)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M275.48 107.228H235.631V109.139H275.48V107.228Z",
    fill: "url(#paint135_linear_811_11692)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M269.218 93.9034H241.89V95.7435H269.218V93.9034Z",
    fill: "url(#paint136_linear_811_11692)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M263.211 85.8886H247.463V87.3007H263.211V85.8886Z",
    fill: "url(#paint137_linear_811_11692)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M246.347 97.8833H245.162V105.786H246.347V97.8833Z",
    fill: "url(#paint138_linear_811_11692)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M249.623 97.8833H248.438V105.786H249.623V97.8833Z",
    fill: "url(#paint139_linear_811_11692)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M252.899 97.8833H251.715V105.786H252.899V97.8833Z",
    fill: "url(#paint140_linear_811_11692)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M256.175 97.8833H254.991V105.786H256.175V97.8833Z",
    fill: "url(#paint141_linear_811_11692)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M259.452 97.8833H258.267V105.786H259.452V97.8833Z",
    fill: "url(#paint142_linear_811_11692)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M262.728 97.8833H261.543V105.786H262.728V97.8833Z",
    fill: "url(#paint143_linear_811_11692)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M266.003 97.8833H264.819V105.786H266.003V97.8833Z",
    fill: "url(#paint144_linear_811_11692)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M242.819 114.843H239.959V124.218H242.819V114.843Z",
    fill: "url(#paint145_linear_811_11692)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M248.484 114.843H245.623V124.218H248.484V114.843Z",
    fill: "url(#paint146_linear_811_11692)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M254.152 114.843H251.292V124.218H254.152V114.843Z",
    fill: "url(#paint147_linear_811_11692)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M259.817 114.843H256.956V124.218H259.817V114.843Z",
    fill: "url(#paint148_linear_811_11692)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M265.486 114.843H262.625V124.218H265.486V114.843Z",
    fill: "url(#paint149_linear_811_11692)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M271.15 114.843H268.289V124.218H271.15V114.843Z",
    fill: "url(#paint150_linear_811_11692)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M242.819 129.456H239.959V138.831H242.819V129.456Z",
    fill: "url(#paint151_linear_811_11692)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M248.484 129.456H245.623V138.831H248.484V129.456Z",
    fill: "url(#paint152_linear_811_11692)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M254.152 129.456H251.292V138.831H254.152V129.456Z",
    fill: "url(#paint153_linear_811_11692)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M259.817 129.456H256.956V138.831H259.817V129.456Z",
    fill: "url(#paint154_linear_811_11692)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M265.486 129.456H262.625V138.831H265.486V129.456Z",
    fill: "url(#paint155_linear_811_11692)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M271.15 129.456H268.289V138.831H271.15V129.456Z",
    fill: "url(#paint156_linear_811_11692)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M242.819 144.069H239.959V153.444H242.819V144.069Z",
    fill: "url(#paint157_linear_811_11692)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M248.484 144.069H245.623V153.444H248.484V144.069Z",
    fill: "url(#paint158_linear_811_11692)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M254.152 144.069H251.292V153.444H254.152V144.069Z",
    fill: "url(#paint159_linear_811_11692)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M259.817 144.069H256.956V153.444H259.817V144.069Z",
    fill: "url(#paint160_linear_811_11692)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M265.486 144.069H262.625V153.444H265.486V144.069Z",
    fill: "url(#paint161_linear_811_11692)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M271.15 144.069H268.289V153.444H271.15V144.069Z",
    fill: "url(#paint162_linear_811_11692)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M242.819 158.681H239.959V168.057H242.819V158.681Z",
    fill: "url(#paint163_linear_811_11692)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M248.484 158.681H245.623V168.057H248.484V158.681Z",
    fill: "url(#paint164_linear_811_11692)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M254.152 158.681H251.292V168.057H254.152V158.681Z",
    fill: "url(#paint165_linear_811_11692)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M259.817 158.681H256.956V168.057H259.817V158.681Z",
    fill: "url(#paint166_linear_811_11692)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M265.486 158.681H262.625V168.057H265.486V158.681Z",
    fill: "url(#paint167_linear_811_11692)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M271.15 158.681H268.289V168.057H271.15V158.681Z",
    fill: "url(#paint168_linear_811_11692)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M242.819 173.295H239.959V182.67H242.819V173.295Z",
    fill: "url(#paint169_linear_811_11692)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M248.484 173.295H245.623V182.67H248.484V173.295Z",
    fill: "url(#paint170_linear_811_11692)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M254.152 173.295H251.292V182.67H254.152V173.295Z",
    fill: "url(#paint171_linear_811_11692)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M259.817 173.295H256.956V182.67H259.817V173.295Z",
    fill: "url(#paint172_linear_811_11692)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M265.486 173.295H262.625V182.67H265.486V173.295Z",
    fill: "url(#paint173_linear_811_11692)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M271.15 173.295H268.289V182.67H271.15V173.295Z",
    fill: "url(#paint174_linear_811_11692)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M242.819 187.908H239.959V197.283H242.819V187.908Z",
    fill: "url(#paint175_linear_811_11692)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M248.484 187.908H245.623V197.283H248.484V187.908Z",
    fill: "url(#paint176_linear_811_11692)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M254.152 187.908H251.292V197.283H254.152V187.908Z",
    fill: "url(#paint177_linear_811_11692)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M259.817 187.908H256.956V197.283H259.817V187.908Z",
    fill: "url(#paint178_linear_811_11692)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M265.486 187.908H262.625V197.283H265.486V187.908Z",
    fill: "url(#paint179_linear_811_11692)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M271.15 187.908H268.289V197.283H271.15V187.908Z",
    fill: "url(#paint180_linear_811_11692)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M242.819 202.52H239.959V211.895H242.819V202.52Z",
    fill: "url(#paint181_linear_811_11692)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M248.484 202.52H245.623V211.895H248.484V202.52Z",
    fill: "url(#paint182_linear_811_11692)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M254.152 202.52H251.292V211.895H254.152V202.52Z",
    fill: "url(#paint183_linear_811_11692)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M259.817 202.52H256.956V211.895H259.817V202.52Z",
    fill: "url(#paint184_linear_811_11692)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M265.486 202.52H262.625V211.895H265.486V202.52Z",
    fill: "url(#paint185_linear_811_11692)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M271.15 202.52H268.289V211.895H271.15V202.52Z",
    fill: "url(#paint186_linear_811_11692)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M242.819 217.133H239.959V226.509H242.819V217.133Z",
    fill: "url(#paint187_linear_811_11692)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M248.484 217.133H245.623V226.509H248.484V217.133Z",
    fill: "url(#paint188_linear_811_11692)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M254.152 217.133H251.292V226.509H254.152V217.133Z",
    fill: "url(#paint189_linear_811_11692)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M259.817 217.133H256.956V226.509H259.817V217.133Z",
    fill: "url(#paint190_linear_811_11692)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M265.486 217.133H262.625V226.509H265.486V217.133Z",
    fill: "url(#paint191_linear_811_11692)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M271.15 217.133H268.289V226.509H271.15V217.133Z",
    fill: "url(#paint192_linear_811_11692)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M242.819 231.746H239.959V241.121H242.819V231.746Z",
    fill: "url(#paint193_linear_811_11692)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M248.484 231.746H245.623V241.121H248.484V231.746Z",
    fill: "url(#paint194_linear_811_11692)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M254.152 231.746H251.292V241.121H254.152V231.746Z",
    fill: "url(#paint195_linear_811_11692)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M259.817 231.746H256.956V241.121H259.817V231.746Z",
    fill: "url(#paint196_linear_811_11692)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M265.486 231.746H262.625V241.121H265.486V231.746Z",
    fill: "url(#paint197_linear_811_11692)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M271.15 231.746H268.289V241.121H271.15V231.746Z",
    fill: "url(#paint198_linear_811_11692)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M242.819 246.359H239.959V255.735H242.819V246.359Z",
    fill: "url(#paint199_linear_811_11692)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M248.484 246.359H245.623V255.735H248.484V246.359Z",
    fill: "url(#paint200_linear_811_11692)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M254.152 246.359H251.292V255.735H254.152V246.359Z",
    fill: "url(#paint201_linear_811_11692)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M259.817 246.359H256.956V255.735H259.817V246.359Z",
    fill: "url(#paint202_linear_811_11692)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M265.486 246.359H262.625V255.735H265.486V246.359Z",
    fill: "url(#paint203_linear_811_11692)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M271.15 246.359H268.289V255.735H271.15V246.359Z",
    fill: "url(#paint204_linear_811_11692)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M242.819 260.971H239.959V270.347H242.819V260.971Z",
    fill: "url(#paint205_linear_811_11692)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M248.484 260.971H245.623V270.347H248.484V260.971Z",
    fill: "url(#paint206_linear_811_11692)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M254.152 260.971H251.292V270.347H254.152V260.971Z",
    fill: "url(#paint207_linear_811_11692)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M259.817 260.971H256.956V270.347H259.817V260.971Z",
    fill: "url(#paint208_linear_811_11692)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M265.486 260.971H262.625V270.347H265.486V260.971Z",
    fill: "url(#paint209_linear_811_11692)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M271.15 260.971H268.289V270.347H271.15V260.971Z",
    fill: "url(#paint210_linear_811_11692)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M187.58 114.514H126.765V265.685H187.58V114.514Z",
    fill: "url(#paint211_linear_811_11692)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M189.31 111.914H125.039V116.187H189.31V111.914Z",
    fill: "url(#paint212_linear_811_11692)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M185.537 106.446H128.81V126.755H185.537V106.446Z",
    fill: "url(#paint213_linear_811_11692)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M155.617 98.1357H133.153V120.325H155.617V98.1357Z",
    fill: "url(#paint214_linear_811_11692)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M146.153 104.39H133.153V92.7086H142.476L146.153 104.39Z",
    fill: "url(#paint215_linear_811_11692)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M139.652 83.0132H138.391V109.032H139.652V83.0132Z",
    fill: "url(#paint216_linear_811_11692)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M140.153 81.6639C140.153 82.4081 139.646 83.0124 139.02 83.0124C138.396 83.0124 137.888 82.4081 137.888 81.6639C137.888 80.9197 138.395 80.3148 139.02 80.3148C139.646 80.3162 140.153 80.9197 140.153 81.6639Z",
    fill: "url(#paint217_linear_811_11692)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M691.188 277.192H624.62L616.313 54.9302L691.188 73.4527V277.192Z",
    fill: "url(#paint218_linear_811_11692)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M837.162 274.437H41.7723V296.981H837.162V274.437Z",
    fill: "url(#paint219_linear_811_11692)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M509.963 291.457H474.742L488.466 207.409H509.963V291.457Z",
    fill: "#F7A47A"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M848.361 294.731H13.2358V330.277H848.361V294.731Z",
    fill: "#F7A47A"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M481.1 135.927V98.6837H469.791V84.5042H463.741V72.5929H461.617V52.1752H461.069V72.5929H458.945V84.5042H452.895V98.6837H441.672V135.927H439.339V203.545H421.94V280.626H439.339H456.741H483.346V135.927H481.1Z",
    fill: "#F7A47A"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M546.094 178.709H491.355V179.895H493.832V290.197H543.617V179.895H546.094V178.709Z",
    fill: "#F7A47A"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M296.483 206.184H247.951V298.067H296.483V206.184Z",
    fill: "#F7A47A"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M240.642 253.259H157.176V298.066H240.642V253.259Z",
    fill: "#F7A47A"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M220.237 153.153H201.914V263.185H220.237V153.153Z",
    fill: "#F7A47A"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M206.911 123.801H205.959V183.638H206.911V123.801Z",
    fill: "#F7A47A"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M210.004 128.339H209.053V188.176H210.004V128.339Z",
    fill: "#F7A47A"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M214.527 146.347H203.327V161.093H214.527V146.347Z",
    fill: "#F7A47A"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M269.26 222.632H237.372V298.066H269.26V222.632Z",
    fill: "#F7A47A"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M321.708 219.655H293.504V298.067H321.708V219.655Z",
    fill: "#F7A47A"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M123.858 216.676H91.4932V298.066H123.858V216.676Z",
    fill: "#F7A47A"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M166.456 194.556H101.965V298.066H166.456V194.556Z",
    fill: "#F7A47A"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M168.121 190.587H98.2016V194.557H168.121V190.587Z",
    fill: "#F7A47A"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M133.16 179.81H104.819V200.795H133.16V179.81Z",
    fill: "#F7A47A"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M147.177 179.81H142.418V192.572H147.177V179.81Z",
    fill: "#F7A47A"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M157.173 179.81H151.938V192.572H157.173V179.81Z",
    fill: "#F7A47A"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M107.674 266.588H73.8821V298.067H107.674V266.588Z",
    fill: "#F7A47A"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1213 253.259H61.1205V298.066H77.1213V253.259Z",
    fill: "#F7A47A"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M69.12 282.327H41.7723V298.067H69.12V282.327Z",
    fill: "#F7A47A"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M695.307 263.185H358.329V298.065H695.307V263.185Z",
    fill: "#F7A47A"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M668.4 166.628C666.278 166.628 664.538 168.573 664.365 171.048L659.623 170.864C659.635 170.311 659.643 169.756 659.643 169.2C659.643 162.167 658.624 155.319 656.671 148.897L660.633 147.158C661.256 148.87 662.685 150.067 664.35 150.067C666.586 150.067 668.4 147.907 668.4 145.242C668.4 142.577 666.586 140.416 664.35 140.416C662.114 140.416 660.301 142.577 660.301 145.242C660.301 145.734 660.363 146.209 660.478 146.656L656.517 148.394C654.26 141.179 650.818 134.512 646.31 128.737L649.41 125.276C650.137 126.104 651.121 126.612 652.206 126.612C654.442 126.612 656.256 124.452 656.256 121.787C656.256 119.122 654.442 116.961 652.206 116.961C649.97 116.961 648.157 119.122 648.157 121.787C648.157 122.967 648.513 124.046 649.103 124.886L646.002 128.349C645.683 127.947 645.359 127.548 645.028 127.156C640.334 121.561 634.869 117.219 628.919 114.27L630.624 109.322C631.011 109.468 631.423 109.547 631.85 109.547C634.086 109.547 635.899 107.387 635.899 104.722C635.899 102.057 634.086 99.8962 631.85 99.8962C629.614 99.8962 627.801 102.057 627.801 104.722C627.801 106.688 628.787 108.379 630.203 109.131L628.502 114.068C623.179 111.497 617.473 110.034 611.59 109.781L611.775 103.016C611.818 103.018 611.86 103.02 611.903 103.02C614.14 103.02 615.953 100.859 615.953 98.1948C615.953 95.5294 614.14 93.3691 611.903 93.3691C609.667 93.3691 607.854 95.5294 607.854 98.1948C607.854 100.626 609.364 102.636 611.327 102.971L611.141 109.764C610.677 109.748 610.211 109.74 609.745 109.74C604.081 109.74 598.561 110.858 593.362 113.005L591.728 107.484C593.202 106.762 594.238 105.035 594.238 103.02C594.238 100.355 592.426 98.1948 590.189 98.1948C587.953 98.1948 586.139 100.355 586.139 103.02C586.139 105.685 587.952 107.845 590.189 107.845C590.576 107.845 590.949 107.78 591.304 107.659L592.937 113.181C586.631 115.862 580.809 120.063 575.789 125.628L572.83 121.865C573.493 121.006 573.897 119.861 573.897 118.602C573.897 115.937 572.084 113.777 569.848 113.777C567.611 113.777 565.797 115.937 565.797 118.602C565.797 121.267 567.61 123.428 569.848 123.428C570.866 123.428 571.797 122.977 572.508 122.238L575.462 125.995C575.126 126.376 574.791 126.762 574.462 127.155C570.286 132.131 566.943 137.833 564.513 144.024L560.749 141.953C560.885 141.47 560.96 140.954 560.96 140.416C560.96 137.75 559.147 135.59 556.911 135.59C554.674 135.59 552.862 137.75 552.862 140.416C552.862 143.08 554.674 145.241 556.911 145.241C558.536 145.241 559.938 144.098 560.582 142.451L564.321 144.508C561.637 151.509 560.116 159.12 559.877 167.001L555.05 166.813C554.99 164.21 553.203 162.122 551.004 162.122C548.767 162.122 546.954 164.282 546.954 166.947C546.954 169.612 548.767 171.772 551.004 171.772C553.126 171.772 554.866 169.825 555.038 167.349L559.863 167.536C559.85 168.09 559.844 168.645 559.844 169.2C559.844 176.234 560.862 183.081 562.815 189.504L558.853 191.242C558.23 189.531 556.801 188.333 555.136 188.333C552.9 188.333 551.087 190.493 551.087 193.159C551.087 195.823 552.9 197.984 555.136 197.984C557.372 197.984 559.187 195.823 559.187 193.159C559.187 192.666 559.124 192.192 559.009 191.745L562.97 190.006C565.227 197.221 568.669 203.887 573.178 209.663L570.077 213.124C569.351 212.297 568.366 211.787 567.281 211.787C565.045 211.787 563.231 213.948 563.231 216.612C563.231 219.277 565.045 221.438 567.281 221.438C569.517 221.438 571.331 219.277 571.331 216.612C571.331 215.433 570.975 214.353 570.385 213.514L573.486 210.052C573.805 210.454 574.129 210.852 574.458 211.245C577.62 215.012 581.132 218.211 584.906 220.8L560.488 274.434H556.105V275.968H553.959V279.013H665.524V275.968H663.378V274.434H658.996L634.578 220.8C637.831 218.569 640.888 215.884 643.696 212.773L647.652 217.804C646.803 218.689 646.266 219.988 646.266 221.439C646.266 224.104 648.079 226.264 650.314 226.264C652.551 226.264 654.365 224.104 654.365 221.439C654.365 218.774 652.552 216.614 650.314 216.614C649.457 216.614 648.663 216.932 648.008 217.474L644.024 212.406C644.361 212.026 644.695 211.64 645.024 211.247C649.201 206.271 652.544 200.569 654.974 194.379L659.381 196.802C659.302 197.181 659.259 197.576 659.259 197.984C659.259 200.649 661.071 202.809 663.308 202.809C665.544 202.809 667.357 200.649 667.357 197.984C667.357 195.319 665.544 193.159 663.308 193.159C661.572 193.159 660.093 194.459 659.517 196.286L655.164 193.892C657.848 186.89 659.369 179.279 659.608 171.399L664.352 171.583C664.41 174.187 666.199 176.278 668.398 176.278C670.635 176.278 672.446 174.117 672.446 171.452C672.446 168.787 670.635 166.628 668.4 166.628ZM658.292 169.201C658.292 169.739 658.286 170.277 658.274 170.813L644.302 170.272C644.31 169.915 644.314 169.558 644.314 169.201C644.314 164.295 643.589 159.586 642.262 155.219L655.402 149.453C657.302 155.7 658.292 162.359 658.292 169.201ZM643.627 170.246L612.462 169.039C612.451 168.796 612.418 168.561 612.366 168.335L641.628 155.496C642.928 159.777 643.638 164.392 643.638 169.201C643.639 169.55 643.635 169.899 643.627 170.246ZM575.859 168.157L607.024 169.364C607.035 169.607 607.068 169.842 607.12 170.068L577.858 182.907C576.558 178.626 575.848 174.011 575.848 169.201C575.848 168.852 575.851 168.504 575.859 168.157ZM611.876 167.186L634.617 141.792C637.567 145.591 639.913 150.064 641.472 154.994L612.211 167.832C612.121 167.601 612.008 167.385 611.876 167.186ZM611.569 166.795C611.393 166.604 611.195 166.442 610.982 166.312L622.827 131.94C627.193 134.125 631.097 137.369 634.31 141.4L611.569 166.795ZM610.566 166.108C610.402 166.046 610.232 166.003 610.057 165.979L611.07 128.842C615.065 129.026 618.884 130.037 622.412 131.736L610.566 166.108ZM609.607 165.961C609.416 165.972 609.231 166.006 609.053 166.062L598.688 131.016C602.154 129.586 605.874 128.807 609.743 128.807C610.036 128.807 610.329 128.812 610.62 128.821L609.607 165.961ZM608.629 166.241C608.422 166.351 608.228 166.493 608.052 166.659L586.743 139.56C590.044 135.919 593.952 133.05 598.264 131.195L608.629 166.241ZM607.724 167.025C607.59 167.202 607.473 167.395 607.375 167.603L579.068 152.032C580.875 147.465 583.377 143.364 586.416 139.925L607.724 167.025ZM607.185 168.089C607.113 168.323 607.064 168.571 607.038 168.828L575.876 167.62C576.05 162.254 577.105 157.15 578.877 152.515L607.185 168.089ZM607.275 170.569C607.348 170.756 607.435 170.934 607.536 171.098L607.351 171.506L584.869 196.609C581.919 192.81 579.574 188.338 578.014 183.408L607.275 170.569ZM606.669 173L592.556 204.002C589.829 202.083 587.344 199.723 585.175 197.002L606.669 173ZM608.205 171.877C608.3 171.956 608.4 172.026 608.504 172.089L596.659 206.462C595.519 205.891 594.41 205.246 593.336 204.536L608.205 171.877ZM608.92 172.295C609.084 172.356 609.254 172.4 609.43 172.424L608.417 209.561C604.422 209.377 600.602 208.366 597.076 206.666L608.92 172.295ZM609.743 209.594C609.45 209.594 609.158 209.59 608.866 209.581L609.88 172.441C610.07 172.43 610.255 172.395 610.433 172.34L620.799 207.386C617.332 208.815 613.613 209.594 609.743 209.594ZM610.858 172.161C611.006 172.08 611.149 171.987 611.282 171.877L626.15 204.536C624.579 205.576 622.933 206.472 621.222 207.207L610.858 172.161ZM613.359 174.192L632.743 198.844C630.97 200.8 629.022 202.531 626.931 204.003L613.359 174.192ZM612.511 172.33L611.951 171.098C612.009 171.003 612.064 170.903 612.112 170.8L640.419 186.371C638.612 190.938 636.109 195.039 633.072 198.477L612.511 172.33ZM612.302 170.314C612.373 170.078 612.422 169.831 612.448 169.575L643.61 170.783C643.436 176.15 642.381 181.253 640.609 185.888L612.302 170.314ZM596.404 207.206L591.083 222.645C589.46 221.841 587.876 220.93 586.334 219.917L593.014 205.243C594.109 205.968 595.239 206.625 596.404 207.206ZM596.819 207.409C600.419 209.145 604.317 210.177 608.395 210.364L607.941 227.017C602.221 226.77 596.676 225.347 591.499 222.847L596.819 207.409ZM608.845 210.384C609.144 210.393 609.442 210.397 609.743 210.397C613.691 210.397 617.486 209.603 621.022 208.143L625.677 223.881C620.621 225.968 615.252 227.054 609.744 227.054C609.292 227.054 608.842 227.047 608.391 227.032L608.845 210.384ZM621.447 207.966C623.191 207.216 624.87 206.302 626.472 205.243L633.152 219.917C630.889 221.405 628.533 222.672 626.102 223.705L621.447 207.966ZM655.248 148.95L642.105 154.716C640.515 149.685 638.12 145.12 635.11 141.244L645.323 129.839C649.707 135.454 653.053 141.936 655.248 148.95ZM644.072 128.292C644.391 128.673 644.706 129.058 645.015 129.448L634.803 140.852C631.523 136.736 627.539 133.426 623.084 131.197L628.404 115.758C634.191 118.627 639.506 122.85 644.072 128.292ZM627.987 115.554L622.666 130.994C619.067 129.258 615.168 128.226 611.091 128.038L611.545 111.385C617.265 111.632 622.81 113.055 627.987 115.554ZM609.743 111.346C610.195 111.346 610.646 111.354 611.095 111.368L610.641 128.017C610.343 128.008 610.044 128.004 609.743 128.004C605.795 128.004 602 128.798 598.464 130.258L593.809 114.521C598.865 112.433 604.234 111.346 609.743 111.346ZM593.384 114.697L598.039 130.436C593.639 132.328 589.651 135.257 586.282 138.972L576.712 126.8C581.592 121.39 587.254 117.305 593.384 114.697ZM575.414 128.292C575.733 127.912 576.057 127.537 576.384 127.168L585.953 139.337C582.854 142.846 580.298 147.032 578.454 151.693L565.736 144.697C568.1 138.677 571.353 133.13 575.414 128.292ZM565.548 145.184L578.264 152.18C576.456 156.91 575.379 162.117 575.201 167.596L561.227 167.055C561.46 159.392 562.939 151.991 565.548 145.184ZM561.194 169.201C561.194 168.664 561.201 168.126 561.213 167.59L575.184 168.131C575.176 168.487 575.172 168.843 575.172 169.201C575.172 174.108 575.897 178.816 577.224 183.184L564.084 188.949C562.185 182.702 561.194 176.042 561.194 169.201ZM564.238 189.452L577.38 183.686C578.972 188.718 581.366 193.283 584.377 197.159L574.163 208.564C569.78 202.949 566.434 196.467 564.238 189.452ZM575.414 210.111C575.095 209.73 574.781 209.344 574.471 208.956L584.683 197.552C586.901 200.335 589.443 202.749 592.233 204.711L585.551 219.39C581.889 216.874 578.483 213.768 575.414 210.111ZM657.974 274.438H561.513L585.69 221.332C587.274 222.373 588.903 223.308 590.57 224.135L588.864 229.083C588.477 228.937 588.065 228.858 587.637 228.858C585.401 228.858 583.588 231.018 583.588 233.683C583.588 236.348 585.401 238.509 587.637 238.509C589.874 238.509 591.688 236.348 591.688 233.683C591.688 231.717 590.7 230.026 589.284 229.274L590.986 224.337C596.31 226.908 602.014 228.371 607.897 228.624L607.76 233.686C605.566 233.745 603.804 235.881 603.804 238.509C603.804 241.173 605.617 243.334 607.854 243.334C610.091 243.334 611.903 241.173 611.903 238.509C611.903 235.987 610.28 233.917 608.21 233.702L608.348 228.641C608.812 228.657 609.278 228.664 609.744 228.664C615.409 228.664 620.928 227.546 626.127 225.401L627.582 230.321C626.205 231.091 625.249 232.758 625.249 234.692C625.249 237.357 627.063 239.517 629.299 239.517C631.535 239.517 633.348 237.357 633.348 234.692C633.348 232.027 631.535 229.867 629.299 229.867C628.845 229.867 628.408 229.957 628 230.122L626.552 225.224C629.049 224.162 631.471 222.861 633.797 221.333L657.974 274.438ZM633.936 219.389L627.254 204.71C629.396 203.205 631.39 201.431 633.205 199.43L642.775 211.602C640.053 214.618 637.088 217.223 633.936 219.389ZM644.072 210.111C643.753 210.491 643.429 210.865 643.102 211.235L633.533 199.066C636.632 195.557 639.187 191.371 641.03 186.709L653.748 193.705C651.386 199.725 648.134 205.271 644.072 210.111ZM653.939 193.219L641.222 186.223C643.03 181.493 644.107 176.284 644.285 170.807L658.258 171.348C658.026 179.011 656.548 186.411 653.939 193.219Z",
    fill: "#F7A47A"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M730.21 207.208H678.174V298.067H730.21V207.208Z",
    fill: "#F7A47A"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M774.628 242.532H722.592V297.554H774.628V242.532Z",
    fill: "#F7A47A"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M549.986 234.453H520.795V280.626H549.986V234.453Z",
    fill: "#F7A47A"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M741.002 120.802H704.197V298.065H741.002V120.802Z",
    fill: "#F7A47A"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M801.603 298.066H753.056V194.556H789.861L801.603 298.066Z",
    fill: "#F7A47A"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M822.862 274.437H780.344V298.067H822.862V274.437Z",
    fill: "#F7A47A"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M731.997 79.6726L728.943 73.1556L733.524 52.9186L735.165 72.8126L731.997 79.6726Z",
    fill: "#F7A47A"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M732.821 81.1587L735.165 85.8464L755.587 94.8787L739.974 81.1587H732.821Z",
    fill: "#F7A47A"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M708.406 92.592L730 85.6181L732.056 81.1589L727.066 80.2439L708.406 92.592Z",
    fill: "#F7A47A"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M732.761 82.4121H731.354V138.149H732.761V82.4121Z",
    fill: "#003940"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M735.165 81.1587C735.165 81.5774 735.078 81.9759 734.924 82.3383C734.448 83.4255 733.343 84.1891 732.057 84.1891C730.336 84.1891 728.943 82.8327 728.943 81.1587C728.943 79.4854 730.336 78.129 732.057 78.129C733.772 78.129 735.165 79.4848 735.165 81.1587Z",
    fill: "#F7A47A"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M732.75 83.7689H731.484V131.94H732.75V83.7689Z",
    fill: "#F7A47A"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M1300.82 70.7661H1299.24V130.691H1300.82V70.7661Z",
    fill: "url(#paint220_linear_811_11692)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M1299.88 65.6702L1296.08 57.563L1301.78 32.3881L1303.82 57.1363L1299.88 65.6702Z",
    fill: "#F7A47A"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M1300.91 67.5188L1303.82 73.3503L1329.23 84.5865L1309.81 67.5188H1300.91Z",
    fill: "#F7A47A"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M1270.54 81.7421L1297.4 73.0665L1299.96 67.5192L1293.75 66.381L1270.54 81.7421Z",
    fill: "#F7A47A"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M1303.82 67.5192C1303.82 68.0401 1303.71 68.5359 1303.52 68.9867C1302.93 70.3391 1301.55 71.2891 1299.95 71.2891C1297.81 71.2891 1296.08 69.6017 1296.08 67.5192C1296.08 65.4376 1297.81 63.7502 1299.95 63.7502C1302.09 63.7502 1303.82 65.4368 1303.82 67.5192Z",
    fill: "#F7A47A"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M737.034 94.1059H735.762V142.276H737.034V94.1059Z",
    fill: "#F7A47A"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M728.863 100.755H727.59V148.927H728.863V100.755Z",
    fill: "#F7A47A"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M772.332 186.19H754.957V202.496H772.332V186.19Z",
    fill: "#F7A47A"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M770.432 180.378H756.862V189.543H770.432V180.378Z",
    fill: "#F7A47A"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M782.567 190.967H779.231V197.551H782.567V190.967Z",
    fill: "#F7A47A"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M788.501 184.96H783.745V197.551H788.501V184.96Z",
    fill: "#F7A47A"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M564.774 160.788H520.65V330.277H564.774V160.788Z",
    fill: "#1F8297"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M568.069 161.793H517.351V163.51H568.069V161.793Z",
    fill: "#1F8297"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M566.696 185.6H518.722V187.312H566.696V185.6Z",
    fill: "#1F8297"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M566.696 208.657H518.722V210.368H566.696V208.657Z",
    fill: "#1F8297"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M566.696 231.713H518.722V233.425H566.696V231.713Z",
    fill: "#1F8297"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M566.696 254.77H518.722V256.482H566.696V254.77Z",
    fill: "#1F8297"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M566.696 277.827H518.722V279.538H566.696V277.827Z",
    fill: "#1F8297"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M566.696 300.883H518.722V302.595H566.696V300.883Z",
    fill: "#1F8297"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M569.747 157.11H515.675V161.793H569.747V157.11Z",
    fill: "#1F8297"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M529.204 169.077H524.619V182.617H529.204V169.077Z",
    fill: "#1F8297"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M539.459 169.077H534.874V182.617H539.459V169.077Z",
    fill: "#1F8297"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M549.714 169.077H545.129V182.617H549.714V169.077Z",
    fill: "#1F8297"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M559.969 169.077H555.384V182.617H559.969V169.077Z",
    fill: "#1F8297"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M529.204 191.215H524.619V204.755H529.204V191.215Z",
    fill: "#1F8297"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M539.459 191.215H534.874V204.755H539.459V191.215Z",
    fill: "#1F8297"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M549.714 191.215H545.129V204.755H549.714V191.215Z",
    fill: "#1F8297"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M559.969 191.215H555.384V204.755H559.969V191.215Z",
    fill: "#1F8297"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M529.204 214.271H524.619V227.811H529.204V214.271Z",
    fill: "#1F8297"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M539.459 214.271H534.874V227.811H539.459V214.271Z",
    fill: "#1F8297"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M549.714 214.271H545.129V227.811H549.714V214.271Z",
    fill: "#1F8297"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M559.969 214.271H555.384V227.811H559.969V214.271Z",
    fill: "#1F8297"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M529.204 237.328H524.619V250.867H529.204V237.328Z",
    fill: "#1F8297"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M539.459 237.328H534.874V250.867H539.459V237.328Z",
    fill: "#1F8297"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M549.714 237.328H545.129V250.867H549.714V237.328Z",
    fill: "#1F8297"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M559.969 237.328H555.384V250.867H559.969V237.328Z",
    fill: "#1F8297"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M529.204 260.385H524.619V273.924H529.204V260.385Z",
    fill: "#1F8297"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M539.459 260.385H534.874V273.924H539.459V260.385Z",
    fill: "#1F8297"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M549.714 260.385H545.129V273.924H549.714V260.385Z",
    fill: "#1F8297"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M559.969 260.385H555.384V273.924H559.969V260.385Z",
    fill: "#1F8297"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M529.204 283.441H524.619V296.981H529.204V283.441Z",
    fill: "#1F8297"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M539.459 283.441H534.874V296.981H539.459V283.441Z",
    fill: "#1F8297"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M549.714 283.441H545.129V296.981H549.714V283.441Z",
    fill: "#1F8297"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M559.969 283.441H555.384V296.981H559.969V283.441Z",
    fill: "#1F8297"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M529.204 306.497H524.619V320.037H529.204V306.497Z",
    fill: "#1F8297"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M539.459 306.497H534.874V320.037H539.459V306.497Z",
    fill: "#1F8297"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M549.714 306.497H545.129V320.037H549.714V306.497Z",
    fill: "#1F8297"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M559.969 306.497H555.384V320.037H559.969V306.497Z",
    fill: "#1F8297"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M538.442 150.648H523.435V159.452H538.442V150.648Z",
    fill: "#1F8297"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M539.457 150.398H522.414V151.902H539.457V150.398Z",
    fill: "#1F8297"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M457.407 330.277H398.63V169.239L457.407 152.106V330.277Z",
    fill: "#1F8297"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M401.212 166.405H396.047V330.278H401.212V166.405Z",
    fill: "#1F8297"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M415.905 161.787H410.74V330.277H415.905V161.787Z",
    fill: "#1F8297"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M430.598 156.99H425.433V330.277H430.598V156.99Z",
    fill: "#1F8297"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M445.294 153.083H440.13V330.277H445.294V153.083Z",
    fill: "#1F8297"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M459.988 148.927H454.823V330.277H459.988V148.927Z",
    fill: "#1F8297"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M409.4 180.157H402.546V192.601H409.4V180.157Z",
    fill: "#1F8297"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M424.097 180.157H417.243V192.601H424.097V180.157Z",
    fill: "#1F8297"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M438.79 180.157H431.936V192.601H438.79V180.157Z",
    fill: "#1F8297"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M453.487 180.157H446.632V192.601H453.487V180.157Z",
    fill: "#1F8297"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M409.4 201.827H402.546V214.273H409.4V201.827Z",
    fill: "#1F8297"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M424.097 201.827H417.243V214.273H424.097V201.827Z",
    fill: "#1F8297"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M438.79 201.827H431.936V214.273H438.79V201.827Z",
    fill: "#1F8297"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M453.487 201.827H446.632V214.273H453.487V201.827Z",
    fill: "#1F8297"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M409.4 223.498H402.546V235.943H409.4V223.498Z",
    fill: "#1F8297"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M424.097 223.498H417.243V235.943H424.097V223.498Z",
    fill: "#1F8297"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M438.79 223.498H431.936V235.943H438.79V223.498Z",
    fill: "#1F8297"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M453.487 223.498H446.632V235.943H453.487V223.498Z",
    fill: "#1F8297"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M409.4 245.169H402.546V257.613H409.4V245.169Z",
    fill: "#1F8297"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M424.097 245.169H417.243V257.613H424.097V245.169Z",
    fill: "#1F8297"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M438.79 245.169H431.936V257.613H438.79V245.169Z",
    fill: "#1F8297"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M453.487 245.169H446.632V257.613H453.487V245.169Z",
    fill: "#1F8297"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M409.4 266.838H402.546V279.283H409.4V266.838Z",
    fill: "#1F8297"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M424.097 266.838H417.243V279.283H424.097V266.838Z",
    fill: "#1F8297"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M438.79 266.838H431.936V279.283H438.79V266.838Z",
    fill: "#1F8297"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M453.487 266.838H446.632V279.283H453.487V266.838Z",
    fill: "#1F8297"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M409.4 288.508H402.546V300.954H409.4V288.508Z",
    fill: "#1F8297"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M424.097 288.508H417.243V300.954H424.097V288.508Z",
    fill: "#1F8297"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M438.79 288.508H431.936V300.954H438.79V288.508Z",
    fill: "#1F8297"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M453.487 288.508H446.632V300.954H453.487V288.508Z",
    fill: "#1F8297"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M409.4 310.178H402.546V322.623H409.4V310.178Z",
    fill: "#1F8297"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M424.097 310.178H417.243V322.623H424.097V310.178Z",
    fill: "#1F8297"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M438.79 310.178H431.936V322.623H438.79V310.178Z",
    fill: "#1F8297"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M453.487 310.178H446.632V322.623H453.487V310.178Z",
    fill: "#1F8297"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M230.956 176.954V178.626H229.558V183.391H254.152V330.277H213.793V191.054V183.391V178.626H212.329V176.954H230.956Z",
    fill: "#1F8297"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M334.279 243.674H299.71V330.277H334.279V243.674Z",
    fill: "#1F8297"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M177.14 223.821H149.039V330.277H177.14V223.821Z",
    fill: "#1F8297"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M202.194 246.002H171.572V330.277H202.194V246.002Z",
    fill: "#1F8297"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M171.574 219.548H159.149V232.288H171.574V219.548Z",
    fill: "#1F8297"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M206.318 244.613H173.674V247.73H206.318V244.613Z",
    fill: "#1F8297"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M233.241 282.149H198.908V330.277H233.241V282.149Z",
    fill: "#1F8297"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M115.87 243.001H87.9428V330.277H115.87V243.001Z",
    fill: "#1F8297"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M100.451 286.494H63.7109V330.277H100.451V286.494Z",
    fill: "#1F8297"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2359 279.339H23.2546V330.277H46.2359V279.339Z",
    fill: "#1F8297"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0892 314.321H41.7723V330.277H96.0892V314.321Z",
    fill: "#1F8297"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2861 309.165H2.44742V330.277H30.2861V309.165Z",
    fill: "#1F8297"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M159.15 298.066H115.874V330.277H159.15V298.066Z",
    fill: "#1F8297"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M310.231 316.401H242.82V330.277H310.231V316.401Z",
    fill: "#1F8297"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M429.753 316.401H362.341V330.277H429.753V316.401Z",
    fill: "#1F8297"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M307.609 275.663H281.986L271.15 323.34H307.609V275.663Z",
    fill: "#1F8297"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M320.164 206.293H319.45V259.182H320.164V206.293Z",
    fill: "#1F8297"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M323.972 224.19H323.02V255.397H323.972V224.19Z",
    fill: "#1F8297"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M330.882 229.721H317.919V245.168H330.882V229.721Z",
    fill: "#1F8297"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M332.897 228.52H315.729V229.904H332.897V228.52Z",
    fill: "#1F8297"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M369.881 285.607H327.995V330.277H369.881V285.607Z",
    fill: "#1F8297"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M388.779 236.434H361.868V322.624H388.779V236.434Z",
    fill: "#1F8297"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M509.961 252.638H466.967V330.277H509.961V252.638Z",
    fill: "#1F8297"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M502.505 301.669H453.486V330.277H502.505V301.669Z",
    fill: "#1F8297"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M539.46 320.038H507.583V330.277H539.46V320.038Z",
    fill: "#1F8297"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M608.506 301.669H556.68V330.277H608.506V301.669Z",
    fill: "#1F8297"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M577.327 330.278H641.817V226.768H577.327V330.278Z",
    fill: "#1F8297"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M575.662 226.768H645.581V222.798H575.662V226.768Z",
    fill: "#1F8297"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M610.621 233.007H638.963V212.021H610.621V233.007Z",
    fill: "#1F8297"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M596.603 224.782H601.362V212.021H596.603V224.782Z",
    fill: "#1F8297"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M586.607 224.782H591.842V212.021H586.607V224.782Z",
    fill: "#1F8297"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M686.151 330.278H737.196V179.106H686.151V330.278Z",
    fill: "#1F8297"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M684.696 180.78H738.648V176.507H684.696V180.78Z",
    fill: "#1F8297"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M687.865 191.347H735.481V171.038H687.865V191.347Z",
    fill: "#1F8297"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M712.981 184.918H731.836V162.728H712.981V184.918Z",
    fill: "#1F8297"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M720.928 168.983H731.839V157.301H724.015L720.928 168.983Z",
    fill: "#1F8297"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M726.379 173.624H727.437V147.606H726.379V173.624Z",
    fill: "#1F8297"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M725.964 146.258C725.964 147.002 726.386 147.606 726.908 147.606C727.437 147.606 727.859 147.002 727.859 146.258C727.859 145.512 727.437 144.909 726.908 144.909C726.386 144.909 725.964 145.512 725.964 146.258Z",
    fill: "#1F8297"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M753.058 267.87H730.211V330.277H753.058V267.87Z",
    fill: "#1F8297"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M691.186 237.444H665.135V330.277H691.186V237.444Z",
    fill: "#1F8297"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M678.174 330.277H641.474V280.626L672.447 296.981L678.174 330.277Z",
    fill: "#1F8297"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M801.604 303.311H745.556V330.277H801.604V303.311Z",
    fill: "#1F8297"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M813.458 222.632H780.9V330.278H813.458V222.632Z",
    fill: "#1F8297"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M859.782 310.178H805.844V330.276H859.782V310.178Z",
    fill: "#1F8297"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M814.945 220.661H779.231V224.19H814.945V220.661Z",
    fill: "#1F8297"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M809.091 205.472H808.381V227.165H809.091V205.472Z",
    fill: "#1F8297"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M804.336 208.218H803.619V225.621H804.336V208.218Z",
    fill: "#1F8297"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M825.516 263.185H811.002V312.504H831.705L825.516 263.185Z",
    fill: "#1F8297"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.064 229.212H151.938V231.746H154.064V229.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.338 229.212H156.212V231.746H158.338V229.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.064 235.166H151.938V237.701H154.064V235.166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.338 235.166H156.212V237.701H158.338V235.166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.064 240.924H151.938V243.458H154.064V240.924Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.088 229.212H160.961V231.746H163.088V229.212Z",
    fill: "white"
  }))), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M407.687 176.834H404.26V187.193H407.687V176.834Z",
    fill: "white"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M407.687 196.648H404.26V207.007H407.687V196.648Z",
    fill: "white"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M407.687 216.461H404.26V226.821H407.687V216.461Z",
    fill: "white"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M407.687 236.277H404.26V246.636H407.687V236.277Z",
    fill: "white"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M407.687 254.957H404.26V265.317H407.687V254.957Z",
    fill: "white"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M407.687 274.771H404.26V285.131H407.687V274.771Z",
    fill: "white"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M422.384 176.834H418.957V187.193H422.384V176.834Z",
    fill: "white"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M422.384 196.648H418.957V207.007H422.384V196.648Z",
    fill: "white"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M422.384 216.461H418.957V226.821H422.384V216.461Z",
    fill: "white"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M422.384 236.277H418.957V246.636H422.384V236.277Z",
    fill: "white"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M422.384 254.957H418.957V265.317H422.384V254.957Z",
    fill: "white"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M422.384 274.771H418.957V285.131H422.384V274.771Z",
    fill: "white"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M437.077 176.834H433.65V187.193H437.077V176.834Z",
    fill: "white"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M437.077 196.648H433.65V207.007H437.077V196.648Z",
    fill: "white"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M437.077 216.461H433.65V226.821H437.077V216.461Z",
    fill: "white"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M437.077 236.277H433.65V246.636H437.077V236.277Z",
    fill: "white"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M437.077 254.957H433.65V265.317H437.077V254.957Z",
    fill: "white"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M437.077 274.771H433.65V285.131H437.077V274.771Z",
    fill: "white"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M451.774 176.834H448.347V187.193H451.774V176.834Z",
    fill: "white"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M451.774 196.648H448.347V207.007H451.774V196.648Z",
    fill: "white"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M451.774 216.461H448.347V226.821H451.774V216.461Z",
    fill: "white"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M451.774 236.277H448.347V246.636H451.774V236.277Z",
    fill: "white"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M451.774 254.957H448.347V265.317H451.774V254.957Z",
    fill: "white"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M451.774 274.771H448.347V285.131H451.774V274.771Z",
    fill: "white"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M160.962 124.217H159.149V132.528H160.962V124.217Z",
    fill: "white"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M167.362 124.217H165.549V132.528H167.362V124.217Z",
    fill: "white"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M174.847 124.217H173.034V132.528H174.847V124.217Z",
    fill: "white"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M181.244 124.217H179.43V132.528H181.244V124.217Z",
    fill: "white"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M146.745 124.217H144.932V132.528H146.745V124.217Z",
    fill: "white"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M153.145 124.217H151.332V132.528H153.145V124.217Z",
    fill: "white"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M160.962 138.649H159.149V146.959H160.962V138.649Z",
    fill: "white"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M167.362 138.649H165.549V146.959H167.362V138.649Z",
    fill: "white"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M174.847 138.649H173.034V146.959H174.847V138.649Z",
    fill: "white"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M181.244 138.649H179.43V146.959H181.244V138.649Z",
    fill: "white"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M146.745 138.649H144.932V146.959H146.745V138.649Z",
    fill: "white"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M153.145 138.649H151.332V146.959H153.145V138.649Z",
    fill: "white"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M160.962 153.079H159.149V161.389H160.962V153.079Z",
    fill: "white"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M167.362 153.079H165.549V161.389H167.362V153.079Z",
    fill: "white"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M174.847 153.079H173.034V161.389H174.847V153.079Z",
    fill: "white"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M181.244 153.079H179.43V161.389H181.244V153.079Z",
    fill: "white"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M146.745 153.079H144.932V161.389H146.745V153.079Z",
    fill: "white"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M153.145 153.079H151.332V161.389H153.145V153.079Z",
    fill: "white"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M500.39 187.908H497.58V200.796H500.39V187.908Z",
    fill: "white"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M508.988 187.908H506.178V200.796H508.988V187.908Z",
    fill: "white"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M517.078 187.908H514.269V200.796H517.078V187.908Z",
    fill: "white"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M693.324 190.587H691.187V197.834H693.324V190.587Z",
    fill: "white"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M700.009 190.587H697.873V197.834H700.009V190.587Z",
    fill: "white"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M693.324 190.587H691.187V197.834H693.324V190.587Z",
    fill: "white"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M700.009 190.587H697.873V197.834H700.009V190.587Z",
    fill: "white"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M706.327 190.587H704.197V197.834H706.327V190.587Z",
    fill: "white"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M713.008 190.587H710.878V197.834H713.008V190.587Z",
    fill: "white"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M693.324 203.584H691.187V210.832H693.324V203.584Z",
    fill: "white"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M700.009 203.584H697.873V210.832H700.009V203.584Z",
    fill: "white"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M693.324 203.584H691.187V210.832H693.324V203.584Z",
    fill: "white"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M700.009 203.584H697.873V210.832H700.009V203.584Z",
    fill: "white"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M706.327 203.584H704.197V210.832H706.327V203.584Z",
    fill: "white"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M713.008 203.584H710.878V210.832H713.008V203.584Z",
    fill: "white"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M693.324 217.417H691.187V224.665H693.324V217.417Z",
    fill: "white"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M700.009 217.417H697.873V224.665H700.009V217.417Z",
    fill: "white"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M693.324 217.417H691.187V224.665H693.324V217.417Z",
    fill: "white"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M700.009 217.417H697.873V224.665H700.009V217.417Z",
    fill: "white"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M706.327 217.417H704.197V224.665H706.327V217.417Z",
    fill: "white"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M713.008 217.417H710.878V224.665H713.008V217.417Z",
    fill: "white"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M720.319 190.587H718.189V197.834H720.319V190.587Z",
    fill: "white"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M720.319 203.584H718.189V210.832H720.319V203.584Z",
    fill: "white"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M727.007 190.587H724.87V197.834H727.007V190.587Z",
    fill: "white"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M526.911 169.077H524.619V180.378H526.911V169.077Z",
    fill: "white"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M538.313 169.077H536.021V180.378H538.313V169.077Z",
    fill: "white"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M549.712 169.077H547.419V180.378H549.712V169.077Z",
    fill: "white"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M561.113 169.077H558.821V180.378H561.113V169.077Z",
    fill: "white"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M526.911 192.335H524.619V203.635H526.911V192.335Z",
    fill: "white"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M538.313 192.335H536.021V203.635H538.313V192.335Z",
    fill: "white"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M549.712 192.335H547.419V203.635H549.712V192.335Z",
    fill: "white"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M561.113 192.335H558.821V203.635H561.113V192.335Z",
    fill: "white"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M526.911 216.171H524.619V227.471H526.911V216.171Z",
    fill: "white"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M538.313 216.171H536.021V227.471H538.313V216.171Z",
    fill: "white"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M549.712 216.171H547.419V227.471H549.712V216.171Z",
    fill: "white"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M561.113 216.171H558.821V227.471H561.113V216.171Z",
    fill: "white"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M526.911 240.007H524.619V251.307H526.911V240.007Z",
    fill: "white"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M538.313 240.007H536.021V251.307H538.313V240.007Z",
    fill: "white"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M549.712 240.007H547.419V251.307H549.712V240.007Z",
    fill: "white"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M561.113 240.007H558.821V251.307H561.113V240.007Z",
    fill: "white"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M526.911 261.658H524.619V272.958H526.911V261.658Z",
    fill: "white"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M538.313 261.658H536.021V272.958H538.313V261.658Z",
    fill: "white"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M549.712 261.658H547.419V272.958H549.712V261.658Z",
    fill: "white"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M526.911 285.807H524.619V297.107H526.911V285.807Z",
    fill: "white"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M538.313 285.807H536.021V297.107H538.313V285.807Z",
    fill: "white"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M549.712 285.807H547.419V297.107H549.712V285.807Z",
    fill: "white"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M561.113 261.658H558.821V272.958H561.113V261.658Z",
    fill: "white"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M786.124 228.818H783.78V235.305H786.124V228.818Z",
    fill: "white"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M786.124 239.29H783.78V245.776H786.124V239.29Z",
    fill: "white"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M792.131 228.818H789.787V235.305H792.131V228.818Z",
    fill: "white"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M242.932 313.664C242.932 314.033 242.632 314.333 242.263 314.333H237.291C236.922 314.333 236.622 314.033 236.622 313.664C236.622 313.294 236.922 312.994 237.291 312.994H238.716V295.91H240.838V312.994H242.263C242.632 312.994 242.932 313.293 242.932 313.664Z",
    fill: "white"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M242.931 313.664C242.931 314.034 242.631 314.334 242.261 314.334H239.776V295.91H240.837V312.994H242.261C242.631 312.994 242.931 313.293 242.931 313.664Z",
    fill: "#07453F"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M274.679 313.664C274.679 314.033 274.384 314.333 274.009 314.333H269.039C268.671 314.333 268.37 314.033 268.37 313.664C268.37 313.294 268.671 312.994 269.039 312.994H270.466V295.91H272.589V312.994H274.009C274.384 312.994 274.679 313.293 274.679 313.664Z",
    fill: "white"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M274.678 313.664C274.678 314.034 274.384 314.334 274.009 314.334H271.524V295.91H272.589V312.994H274.009C274.384 312.994 274.678 313.293 274.678 313.664Z",
    fill: "#07453F"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M242.827 295.91H236.618V297.934H242.827V295.91Z",
    fill: "#F7A47A"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M274.632 295.91H268.423V297.934H274.632V295.91Z",
    fill: "#F7A47A"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M284.188 295.137H229.715L238.688 269.185H293.156L284.188 295.137Z",
    fill: "white"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M282.496 295.137H228.027L236.999 269.185H291.471L282.496 295.137Z",
    fill: "#F7A47A"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M253.654 271.107L250.329 280.721H235.041L238.367 271.107H253.654Z",
    fill: "url(#paint221_linear_811_11692)"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M248.141 293.218L251.466 283.603H266.756L263.433 293.218H248.141Z",
    fill: "url(#paint222_linear_811_11692)"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M249.334 283.603L246.012 293.217H230.721L234.047 283.603H249.334Z",
    fill: "url(#paint223_linear_811_11692)"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M252.461 280.722L255.783 271.107H271.075L267.746 280.722H252.461Z",
    fill: "url(#paint224_linear_811_11692)"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M265.375 293.218L268.697 283.603H283.989L280.667 293.218H265.375Z",
    fill: "url(#paint225_linear_811_11692)"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M269.695 280.722L273.017 271.107H288.309L284.98 280.722H269.695Z",
    fill: "url(#paint226_linear_811_11692)"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M283.701 296.682H228.027V295.138H284.177L283.701 296.682Z",
    fill: "white"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9436 304.296H65.1666V328.679H73.9436V304.296Z",
    fill: "#C38425"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1089 277.609H94.6313L78.2224 254.009H86.8581L69.5846 218.469L52.311 254.009H60.9491L44.5404 277.609H57.0625L36.7672 305.048H69.5846H102.404L82.1089 277.609Z",
    fill: "#57975A"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4463 313.074H85.6445V328.679H93.4463V313.074Z",
    fill: "#C38425"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8975 293.028H108.171L96.0194 275.55H102.414L89.6221 249.23L76.8289 275.55H83.2263L71.0743 293.028H80.3482L65.3174 313.35H89.6221H113.928L98.8975 293.028Z",
    fill: "#64AC65"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1079 309.173H20.3061V328.679H28.1079V309.173Z",
    fill: "#C38425"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4069 289.277H42.6807L30.5284 271.799H36.9239L24.1311 245.478L11.3383 271.799H17.7356L5.58343 289.277H14.8573L-0.173462 309.599H24.1311H48.4376L33.4069 289.277Z",
    fill: "#64AC65"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M464.569 311.923H453.828V329.024H464.569V311.923Z",
    fill: "#C38425"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M473.357 282H487.513L468.963 255.32H478.725L459.197 215.141L439.669 255.32H449.435L430.884 282H445.04L422.096 313.022H459.197H496.301L473.357 282Z",
    fill: "#57975A"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M500.716 315.623H492.299V329.024H500.716V315.623Z",
    fill: "#C38425"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M507.603 292.175H518.696L504.159 271.268H511.81L496.507 239.783L481.204 271.268H488.857L474.32 292.175H485.413L467.434 316.484H496.507H525.582L507.603 292.175Z",
    fill: "#64AC65"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M1376.83 204.313V267.235H798.53V232.519H837.246V142.687H852.763V128.859H866.78V92.5458H868.389V128.859H871.608V92.5458H873.217V128.859H876.716V202.672H898.957V169.063L908.37 163.212V146.513H918.465V156.942H936.256V192.677H943.446V166.727H949.602V155.872H957.475V109.498H975.291V54.6124H984.793V32.1852H991.555V54.6124H997.992V32.1852H1004.75V54.6124H1014.26V109.498H1032.08V155.872H1039.95V166.727H1046.11V192.677H1053.29V156.942H1071.09V146.513H1081.18V163.212L1090.59 169.063V202.672H1112.83V128.859H1116.33V92.5458H1117.94V128.859H1121.17V92.5458H1122.77V128.859H1136.79V142.687H1155.61L1160.74 145.877V153.536H1184.35L1188.8 156.298V182.255H1198.73V142.261H1217.21V149.283H1246.46V166.192L1251.76 169.49V186.095H1260.59V145.103L1272.56 142.123V131.065H1294.4V107.857H1295.37V131.065H1299.55V84.4491H1300.52V131.065H1304.73V177.865H1305.55V219.501H1343.23V204.313H1376.83Z",
    fill: "url(#paint227_linear_811_11692)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M987.91 128.832H978.842V139.455H987.91V128.832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.91 149.152H978.842V159.774H987.91V149.152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.91 169.471H978.842V180.094H987.91V169.471Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.91 189.791H978.842V200.414H987.91V189.791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.91 208.948H978.842V219.571H987.91V208.948Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.91 229.268H978.842V239.891H987.91V229.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.29 128.832H1004.22V139.455H1013.29V128.832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.29 149.152H1004.22V159.774H1013.29V149.152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.29 169.471H1004.22V180.094H1013.29V169.471Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.29 189.791H1004.22V200.414H1013.29V189.791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.29 208.948H1004.22V219.571H1013.29V208.948Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.29 229.268H1004.22V239.891H1013.29V229.268Z",
    fill: "white"
  }))), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M1402.19 198.545V316H770.249V207.322H770.782V198.545H775.309V207.322H779.841V198.545H784.813V207.322H795.225V210.557H793.64V258.359H827.35V176.84H828.693V171.297H831.196V152.927H832.105V171.297H834.144V156.626H835.037V171.297H839.342V176.84H844.773V258.359H861.065V233.425H871.127V220.027H917.264V230.994H924.743V172.532H920.339V171.051H924.743V168.403H930.337V164.062H976.064V168.403H981.653V171.051H986.076V172.532H981.653V266.444H1017.37V243.045H1023.42V198.618H1021.07V197.651H1053.09V162.811H1055.3V132.479H1065.98V120.931H1071.73V111.232H1073.75V94.6049H1074.27V111.232H1076.29V120.931H1082.04V132.479H1093.61V120.931H1099.37V111.232H1101.39V94.6049H1101.9V111.232H1103.93V120.931H1109.68V132.479H1120.36V162.811H1122.57V197.651H1154.59V198.618H1152.24V243.045H1158.29V266.444H1194V172.532H1189.59V171.051H1194V168.403H1199.59V164.062H1245.33V168.403H1250.92V171.051H1255.32V172.532H1250.92V230.994H1258.4V220.027H1304.53V233.425H1314.6V258.359H1330.89V176.84H1336.32V171.297H1340.62V156.626H1341.52V171.297H1343.56V152.927H1344.47V171.297H1346.97V176.84H1348.31V258.359H1382.02V210.557H1380.44V207.322H1390.85V198.545H1395.82V207.322H1400.35V198.545H1402.19Z",
    fill: "#F7A47A"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M930.857 171.109C930.872 169.591 929.252 169.591 929.266 171.109C929.252 172.627 930.872 172.627 930.857 171.109Z",
    fill: "url(#paint228_linear_811_11692)"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M1398.71 292.672V330.63H770.249V286.474H784.315V316.798H798.947V292.672H819.234V254.969H842.61V302.711H843.857L846.793 278.476L847.519 272.466H857.614V238.665H856.362V235.605H861.262V222.44H861.861V235.605H865.249V224.821H865.848V235.605H878.839V234.642H889.243V238.344H893.903V256.369H918.329V259.07H914.882V276.532H921.452V201.04H920.234V197.332H922.89V192.588H925.934V180.683H929.622V172.28H930.505V180.683H932.489L933.687 185.385H941.724V192.588H962.743V197.332H965.4V201.04H964.182V250.152H981.774V283.287H996.513V255.557H1001.3V240.901H998.153V237.459H1003.69V228.117H1013.03V223.148H1013.63V228.117H1027.42V237.459H1035.17V228.117H1039.15V237.459H1043.13V228.117H1047.52V237.459H1056.68V240.901H1055.29V249.286H1065.8V246.675H1064.18V245.19H1065.8V226.687H1064.18V225.202H1065.8V206.699H1064.18V205.215H1065.8V186.063H1063.03V184.573H1061.63V180.514H1084.42V173.419H1088.74V174.698H1101.25V176.006H1100.4V177.03H1101.04V180.514H1101.77V180.411H1106.08V180.514H1106.9V182.313L1107.55 182.507L1108.2 182.313V180.514H1109.02V180.411H1113.34V180.514H1114.06V177.03H1114.7V176.006H1113.85V174.698H1126.36V173.419H1130.69V180.514H1153.47V184.573H1152.07V186.063H1149.31V205.215H1150.92V206.699H1149.31V225.202H1150.92V226.687H1149.31V245.19H1150.92V246.675H1149.31V249.286H1159.82V240.901H1158.42V237.459H1167.59V228.117H1171.98V237.459H1175.95V228.117H1179.94V237.459H1187.69V228.117H1201.47V223.148H1202.07V228.117H1211.42V237.459H1216.95V240.901H1213.81V255.557H1218.59V283.287H1233.32V250.152H1250.92V201.04H1249.7V197.332H1252.35V192.588H1273.38V185.385H1281.41L1282.61 180.683H1284.6V172.28H1285.49V180.683H1289.16V192.588H1292.22V197.332H1294.87V201.04H1293.66V276.532H1300.23V259.07H1296.77V256.369H1321.2V238.344H1325.86V234.642H1336.26V235.605H1349.26V224.821H1349.85V235.605H1353.25V222.44H1353.84V235.605H1358.74V238.665H1357.49V272.466H1367.58L1368.31 278.476L1371.25 302.711H1372.49V254.969H1395.87V292.672H1398.71Z",
    fill: "#1F8297"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M938.888 212.103H934.009V315.997H938.888V212.103Z",
    fill: "url(#paint229_linear_811_11692)"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M952.45 212.103H947.571V315.997H952.45V212.103Z",
    fill: "url(#paint230_linear_811_11692)"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1268.34 212.103H1263.46V315.997H1268.34V212.103Z",
    fill: "url(#paint231_linear_811_11692)"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1281.9 212.103H1277.02V315.997H1281.9V212.103Z",
    fill: "url(#paint232_linear_811_11692)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1094.07 199.77H1081.61V208.444H1094.07V199.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.07 216.362H1081.61V225.036H1094.07V216.362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.07 232.954H1081.61V241.628H1094.07V232.954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.07 249.546H1081.61V258.22H1094.07V249.546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.07 265.189H1081.61V273.863H1094.07V265.189Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.07 281.781H1081.61V290.455H1094.07V281.781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.34 199.77H1120.88V208.444H1133.34V199.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.34 216.362H1120.88V225.036H1133.34V216.362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.34 232.954H1120.88V241.628H1133.34V232.954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.34 249.546H1120.88V258.22H1133.34V249.546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.34 265.189H1120.88V273.863H1133.34V265.189Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.34 281.781H1120.88V290.455H1133.34V281.781Z",
    fill: "white"
  }))), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.36 322.441C1052.36 322.811 1052.06 323.111 1051.69 323.111H1046.72C1046.35 323.111 1046.05 322.811 1046.05 322.441C1046.05 322.072 1046.35 321.772 1046.72 321.772H1048.15V304.688H1050.27V321.772H1051.69C1052.06 321.772 1052.36 322.071 1052.36 322.441Z",
    fill: "white"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M1052.36 322.442C1052.36 322.811 1052.06 323.111 1051.69 323.111H1049.21V304.688H1050.27V321.772H1051.69C1052.06 321.772 1052.36 322.071 1052.36 322.442Z",
    fill: "#07453F"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M1084.11 322.441C1084.11 322.811 1083.81 323.111 1083.44 323.111H1078.47C1078.1 323.111 1077.8 322.811 1077.8 322.441C1077.8 322.072 1078.1 321.772 1078.47 321.772H1079.9V304.688H1082.02V321.772H1083.44C1083.81 321.772 1084.11 322.071 1084.11 322.441Z",
    fill: "white"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M1084.11 322.442C1084.11 322.811 1083.81 323.111 1083.44 323.111H1080.95V304.688H1082.02V321.772H1083.44C1083.81 321.772 1084.11 322.071 1084.11 322.442Z",
    fill: "#07453F"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.26 304.688H1046.05V306.712H1052.26V304.688Z",
    fill: "#F7A47A"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M1084.06 304.688H1077.85V306.712H1084.06V304.688Z",
    fill: "#F7A47A"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M1093.62 303.915H1039.15L1048.12 277.963H1102.59L1093.62 303.915Z",
    fill: "white"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M1091.93 303.915H1037.46L1046.43 277.963H1100.9L1091.93 303.915Z",
    fill: "#F7A47A"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M1063.08 279.885L1059.76 289.499H1044.47L1047.8 279.885H1063.08Z",
    fill: "url(#paint233_linear_811_11692)"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M1057.57 301.996L1060.9 292.381H1076.19L1072.86 301.996H1057.57Z",
    fill: "url(#paint234_linear_811_11692)"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.76 292.381L1055.44 301.995H1040.15L1043.48 292.381H1058.76Z",
    fill: "url(#paint235_linear_811_11692)"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.89 289.5L1065.21 279.885H1080.51L1077.18 289.5H1061.89Z",
    fill: "url(#paint236_linear_811_11692)"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M1074.81 301.996L1078.13 292.381H1093.42L1090.1 301.996H1074.81Z",
    fill: "url(#paint237_linear_811_11692)"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M1079.13 289.5L1082.45 279.885H1097.74L1094.41 289.5H1079.13Z",
    fill: "url(#paint238_linear_811_11692)"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M1093.13 305.459H1037.46V303.915H1093.61L1093.13 305.459Z",
    fill: "white"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M989.913 317.974H981.467V331.421H989.913V317.974Z",
    fill: "#C38425"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M996.823 294.447H1007.95L993.367 273.468H1001.04L985.685 241.877L970.333 273.468H978.009L963.427 294.447H974.559L956.515 318.839H985.685H1014.86L996.823 294.447Z",
    fill: "#57975A"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M764.638 317.974H756.192V331.421H764.638V317.974Z",
    fill: "#C38425"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M771.548 294.447H782.673L768.092 273.468H775.768L760.409 241.877L745.058 273.468H752.733L738.152 294.447H749.284L731.24 318.839H760.409H789.585L771.548 294.447Z",
    fill: "#57975A"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M1040.57 320.726H1034.85V329.833H1040.57V320.726Z",
    fill: "#C38425"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M1045.25 304.791H1052.79L1042.91 290.582H1048.11L1037.71 269.185L1027.31 290.582H1032.52L1022.64 304.791H1030.17L1017.95 321.311H1037.71H1057.47L1045.25 304.791Z",
    fill: "#57975A"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M958.466 307.222H949.689V331.605H958.466V307.222Z",
    fill: "#C38425"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M966.631 280.535H979.154L962.745 256.935H971.38L954.107 221.395L936.833 256.935H945.471L929.063 280.535H941.585L921.29 307.974H954.107H986.927L966.631 280.535Z",
    fill: "#57975A"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M977.969 316H970.167V331.605H977.969V316Z",
    fill: "#C38425"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M983.42 295.954H992.694L980.542 278.476H986.937L974.144 252.156L961.351 278.476H967.749L955.597 295.954H964.871L949.84 316.276H974.144H998.451L983.42 295.954Z",
    fill: "#64AC65"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M912.63 312.099H904.828V331.605H912.63V312.099Z",
    fill: "#C38425"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M917.929 292.203H927.203L915.051 274.725H921.446L908.653 248.404L895.861 274.725H902.258L890.106 292.203H899.38L884.349 312.525H908.653H932.96L917.929 292.203Z",
    fill: "#64AC65"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M1356.35 305.272H1365.13V329.654H1356.35V305.272Z",
    fill: "#C38425"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M1348.19 278.584H1335.67L1352.08 254.984H1343.44L1360.71 219.444L1377.99 254.984H1369.35L1385.76 278.584H1373.23L1393.53 306.023H1360.71H1327.89L1348.19 278.584Z",
    fill: "#57975A"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M1336.85 314.049H1344.65V329.654H1336.85V314.049Z",
    fill: "#C38425"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M1331.4 294.004H1322.13L1334.28 276.525H1327.88L1340.68 250.205L1353.47 276.525H1347.07L1359.22 294.004H1349.95L1364.98 314.325H1340.68H1316.37L1331.4 294.004Z",
    fill: "#64AC65"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M1402.19 310.148H1409.99V329.654H1402.19V310.148Z",
    fill: "#C38425"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M1396.89 290.252H1387.62L1399.77 272.774H1393.37L1406.17 246.453L1418.96 272.774H1412.56L1424.71 290.252H1415.44L1430.47 310.574H1406.17H1381.86L1396.89 290.252Z",
    fill: "#64AC65"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M662.357 322.905C662.357 323.352 661.957 323.714 661.464 323.714H654.84C654.347 323.714 653.947 323.352 653.947 322.905C653.947 322.459 654.347 322.096 654.84 322.096H656.738V301.463H659.566V322.096H661.464C661.957 322.096 662.357 322.458 662.357 322.905Z",
    fill: "white"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M662.355 322.905C662.355 323.351 661.955 323.714 661.463 323.714H658.15V301.462H659.564V322.096H661.463C661.955 322.096 662.355 322.457 662.355 322.905Z",
    fill: "#07453F"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M704.668 322.905C704.668 323.352 704.268 323.714 703.775 323.714H697.151C696.658 323.714 696.258 323.352 696.258 322.905C696.258 322.459 696.658 322.096 697.151 322.096H699.049V301.463H701.877V322.096H703.775C704.268 322.096 704.668 322.458 704.668 322.905Z",
    fill: "white"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M704.666 322.905C704.666 323.351 704.266 323.714 703.774 323.714H700.461V301.462H701.875V322.096H703.774C704.266 322.096 704.666 322.457 704.666 322.905Z",
    fill: "#07453F"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M662.221 301.462H653.947V303.907H662.221V301.462Z",
    fill: "#F7A47A"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M704.598 301.462H696.324V303.907H704.598V301.462Z",
    fill: "#F7A47A"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M717.335 300.53H644.749L656.705 269.185H729.292L717.335 300.53Z",
    fill: "white"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M715.082 300.53H642.495L654.451 269.185H727.038L715.082 300.53Z",
    fill: "#F7A47A"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M676.649 271.506L672.217 283.117H651.846L656.278 271.506H676.649Z",
    fill: "url(#paint239_linear_811_11692)"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M669.298 298.211L673.728 286.598H694.102L689.671 298.211H669.298Z",
    fill: "url(#paint240_linear_811_11692)"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M670.894 286.599L666.467 298.21H646.089L650.521 286.599H670.894Z",
    fill: "url(#paint241_linear_811_11692)"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M675.054 283.118L679.485 271.505H699.856L695.426 283.118H675.054Z",
    fill: "url(#paint242_linear_811_11692)"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M692.263 298.211L696.694 286.598H717.067L712.636 298.211H692.263Z",
    fill: "url(#paint243_linear_811_11692)"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M698.02 283.118L702.45 271.505H722.822L718.391 283.118H698.02Z",
    fill: "url(#paint244_linear_811_11692)"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M716.685 302.394H642.495V300.529H717.316L716.685 302.394Z",
    fill: "white"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M704.79 325.299C704.79 325.619 704.505 325.878 704.151 325.878H699.41C699.057 325.878 698.771 325.619 698.771 325.299C698.771 324.979 699.056 324.72 699.41 324.72H700.768V309.954H702.792V324.72H704.15C704.504 324.72 704.79 324.979 704.79 325.299Z",
    fill: "white"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M704.791 325.299C704.791 325.619 704.505 325.878 704.152 325.878H701.781V309.954H702.793V324.72H704.152C704.504 324.72 704.791 324.979 704.791 325.299Z",
    fill: "#07453F"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M735.07 325.299C735.07 325.619 734.784 325.878 734.431 325.878H729.69C729.338 325.878 729.051 325.619 729.051 325.299C729.051 324.979 729.337 324.72 729.69 324.72H731.049V309.954H733.072V324.72H734.431C734.785 324.72 735.07 324.979 735.07 325.299Z",
    fill: "white"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M735.071 325.299C735.071 325.619 734.785 325.878 734.432 325.878H732.061V309.954H733.074V324.72H734.432C734.785 324.72 735.071 324.979 735.071 325.299Z",
    fill: "#07453F"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M704.692 309.954H698.771V311.703H704.692V309.954Z",
    fill: "#F7A47A"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M735.023 309.954H729.102V311.703H735.023V309.954Z",
    fill: "#F7A47A"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M744.138 309.287H692.192L700.748 286.855H752.695L744.138 309.287Z",
    fill: "white"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M742.524 309.287H690.578L699.135 286.855H751.081L742.524 309.287Z",
    fill: "#F7A47A"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M715.019 288.516L711.847 296.825H697.268L700.44 288.516H715.019Z",
    fill: "url(#paint245_linear_811_11692)"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M709.761 307.627L712.931 299.316H727.512L724.342 307.627H709.761Z",
    fill: "url(#paint246_linear_811_11692)"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M710.902 299.317L707.735 307.626H693.151L696.324 299.317H710.902Z",
    fill: "url(#paint247_linear_811_11692)"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M713.883 296.826L717.053 288.516H731.632L728.461 296.826H713.883Z",
    fill: "url(#paint248_linear_811_11692)"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M726.193 307.627L729.364 299.316H743.944L740.774 307.627H726.193Z",
    fill: "url(#paint249_linear_811_11692)"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M730.315 296.826L733.486 288.516H748.064L744.894 296.826H730.315Z",
    fill: "url(#paint250_linear_811_11692)"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M743.671 310.621H690.578V309.286H744.123L743.671 310.621Z",
    fill: "white"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M333.351 328.679C333.021 322.833 329.065 318.212 324.221 318.212C323.157 318.212 322.141 318.446 321.191 318.855C318.743 313.777 314.25 310.362 309.096 310.362C303.708 310.362 299.032 314.088 296.672 319.552C294.872 317.43 292.433 316.118 289.741 316.118C284.836 316.118 280.763 320.451 279.901 326.167C279.603 326.1 279.298 326.061 278.985 326.061C278.135 326.061 277.335 326.32 276.631 326.769C276.043 322.333 273.134 318.861 269.477 318.3C267.584 311.845 262.567 307.222 256.659 307.222C250.513 307.222 245.32 312.217 243.616 319.08C242.529 318.522 241.336 318.211 240.083 318.211C235.239 318.211 231.283 322.831 230.953 328.678H333.351V328.679Z",
    fill: "#64AC65"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.75 328.679C1104.42 322.833 1100.51 318.212 1095.7 318.212C1094.65 318.212 1093.64 318.446 1092.7 318.855C1090.28 313.777 1085.83 310.362 1080.72 310.362C1075.39 310.362 1070.76 314.088 1068.42 319.552C1066.64 317.43 1064.22 316.118 1061.56 316.118C1056.7 316.118 1052.66 320.451 1051.8 326.167C1051.52 326.1 1051.21 326.061 1050.9 326.061C1050.06 326.061 1049.26 326.32 1048.57 326.769C1047.98 322.333 1045.1 318.861 1041.49 318.3C1039.6 311.845 1034.64 307.222 1028.78 307.222C1022.7 307.222 1017.56 312.217 1015.87 319.08C1014.79 318.522 1013.61 318.211 1012.37 318.211C1007.57 318.211 1003.65 322.831 1003.33 328.678H1104.75V328.679Z",
    fill: "#64AC65"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M770.248 328.679C769.825 322.833 764.737 318.212 758.51 318.212C757.142 318.212 755.835 318.446 754.616 318.855C751.467 313.777 745.69 310.362 739.064 310.362C732.137 310.362 726.124 314.088 723.09 319.552C720.776 317.43 717.64 316.118 714.179 316.118C707.873 316.118 702.636 320.451 701.527 326.167C701.144 326.1 700.752 326.061 700.349 326.061C699.256 326.061 698.228 326.32 697.322 326.769C696.567 322.333 692.825 318.861 688.125 318.3C685.69 311.845 679.241 307.222 671.646 307.222C663.743 307.222 657.066 312.217 654.875 319.08C653.477 318.522 651.943 318.211 650.333 318.211C644.105 318.211 639.018 322.831 638.594 328.678H770.248V328.679Z",
    fill: "#64AC65"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M472.807 328.679C471.541 324.565 468.288 321.629 464.465 321.629C463.979 321.629 463.505 321.689 463.041 321.78C461.128 316.056 456.517 312.015 451.125 312.015C445.759 312.015 441.164 316.017 439.235 321.7C437.182 321.978 435.343 323.111 433.966 324.802C433.947 324.799 433.927 324.796 433.908 324.792C433.908 324.744 433.914 324.696 433.914 324.647C433.914 314.486 427.144 306.247 418.794 306.247C412.048 306.247 406.338 311.626 404.392 319.049C402.591 317.453 400.381 316.501 397.985 316.501C394.356 316.501 391.151 318.666 389.169 321.983C388.437 321.76 387.675 321.629 386.886 321.629C382.974 321.629 379.624 324.54 378.211 328.679H472.807Z",
    fill: "#64AC65"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M111.977 328.679C111.149 323.447 105.969 319.414 99.6854 319.414C93.4691 319.414 88.3353 323.362 87.4241 328.51C87.1429 328.469 86.8584 328.435 86.5625 328.435C86.0793 328.435 85.6197 328.51 85.1759 328.617C84.1812 325.829 81.1766 323.802 77.6222 323.802C76.3802 323.802 75.2104 324.057 74.1649 324.497C72.9759 319.643 67.9909 316 62.0179 316C57.1322 316 52.9172 318.443 50.8894 321.986C49.006 320.397 46.4339 319.414 43.5919 319.414C39.4683 319.414 35.915 321.482 34.2158 324.478C33.1815 324.049 32.0275 323.802 30.8035 323.802C27.2243 323.802 24.2039 325.859 23.2318 328.679H111.977Z",
    fill: "#64AC65"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M884.349 328.679C883.576 321.838 878.737 316.563 872.868 316.563C867.061 316.563 862.266 321.726 861.415 328.458C861.152 328.404 860.887 328.36 860.61 328.36C860.16 328.36 859.73 328.458 859.315 328.597C858.387 324.953 855.58 322.302 852.26 322.302C851.099 322.302 850.007 322.634 849.03 323.21C847.919 316.862 843.264 312.099 837.684 312.099C833.121 312.099 829.183 315.294 827.289 319.927C825.53 317.848 823.128 316.563 820.473 316.563C816.622 316.563 813.303 319.268 811.716 323.186C810.749 322.625 809.671 322.302 808.528 322.302C805.185 322.302 802.363 324.992 801.455 328.679H884.349Z",
    fill: "#64AC65"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M1358.3 328.679C1357.04 324.565 1353.79 321.629 1349.97 321.629C1349.47 321.629 1349 321.689 1348.54 321.78C1346.62 316.056 1342.02 312.015 1336.62 312.015C1331.25 312.015 1326.67 316.017 1324.73 321.7C1322.68 321.978 1320.84 323.111 1319.46 324.802C1319.45 324.799 1319.43 324.796 1319.41 324.792C1319.41 324.744 1319.41 324.696 1319.41 324.647C1319.41 314.486 1312.64 306.247 1304.29 306.247C1297.55 306.247 1291.84 311.626 1289.89 319.049C1288.09 317.453 1285.88 316.501 1283.48 316.501C1279.85 316.501 1276.64 318.666 1274.67 321.983C1273.94 321.76 1273.17 321.629 1272.39 321.629C1268.47 321.629 1265.12 324.54 1263.71 328.679H1358.3Z",
    fill: "#57975A"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M1290.04 328.679C1288.78 324.565 1285.53 321.629 1281.7 321.629C1281.21 321.629 1280.73 321.689 1280.27 321.78C1278.36 316.056 1273.75 312.015 1268.35 312.015C1262.99 312.015 1258.4 316.017 1256.47 321.7C1254.41 321.978 1252.57 323.111 1251.19 324.802C1251.18 324.799 1251.16 324.796 1251.14 324.792C1251.14 324.744 1251.14 324.696 1251.14 324.647C1251.14 314.486 1244.38 306.247 1236.03 306.247C1229.28 306.247 1223.58 311.626 1221.62 319.049C1219.82 317.453 1217.61 316.501 1215.22 316.501C1211.59 316.501 1208.38 318.666 1206.4 321.983C1205.67 321.76 1204.9 321.629 1204.12 321.629C1200.2 321.629 1196.85 324.54 1195.44 328.679H1290.04Z",
    fill: "#64AC65"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M947.924 138.434L945.753 133.803L949.009 119.422L950.175 133.56L947.924 138.434Z",
    fill: "#F7A47A"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M948.509 139.491L950.175 142.822L964.687 149.24L953.593 139.491H948.509Z",
    fill: "#F7A47A"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M931.159 147.615L946.505 142.66L947.966 139.491L944.42 138.84L931.159 147.615Z",
    fill: "#F7A47A"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M950.175 139.491C950.175 139.788 950.113 140.071 950.004 140.329C949.666 141.101 948.88 141.644 947.967 141.644C946.743 141.644 945.753 140.68 945.753 139.491C945.753 138.301 946.743 137.338 947.967 137.338C949.185 137.338 950.175 138.301 950.175 139.491Z",
    fill: "#F7A47A"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M948.459 141.345H947.559V175.577H948.459V141.345Z",
    fill: "#F7A47A"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M427.214 345.976C427.214 345.976 415.733 347.024 413.532 347.024C411.33 347.024 408.604 345.976 406.402 345.976C404.2 345.976 335.159 345.976 332.328 345.976C329.497 345.976 315.552 344.455 312.092 344.036C308.632 343.617 305.068 343.617 304.176 341.887C303.285 340.156 302.813 333.97 303.338 332.449C303.862 330.929 304.596 331.243 305.33 328.569C306.064 325.896 307.846 319.656 308.475 319.29C309.104 318.923 315.605 318.504 322.105 316.196C328.606 313.889 336.626 309.8 348.527 308.699C360.427 307.598 371.121 308.227 379.824 311.425C388.526 314.623 400.216 321.439 403.466 322.12C406.717 322.802 417.149 324.374 422.758 327.258C428.368 330.142 429.312 332.396 429.993 335.437C430.674 338.478 430.426 341.899 430.583 342.371C430.74 342.843 430.819 343.315 430.583 343.787C430.347 344.258 429.477 345.773 427.214 345.976Z",
    fill: "#98C6CF"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M429.993 335.438C430.674 338.479 430.426 341.9 430.583 342.372C430.74 342.844 430.819 343.315 430.583 343.787C430.347 344.259 429.478 345.773 427.215 345.976C427.215 345.976 415.734 347.024 413.532 347.024C411.33 347.024 408.605 345.976 406.403 345.976C404.201 345.976 335.159 345.976 332.328 345.976C329.498 345.976 315.553 344.455 312.093 344.036C308.633 343.617 305.068 343.617 304.177 341.887C303.286 340.156 302.814 333.97 303.338 332.45C303.863 330.929 304.597 331.243 305.33 328.57C305.484 328.009 305.686 327.288 305.911 326.501L429.533 333.744C429.716 334.285 429.86 334.846 429.993 335.438Z",
    fill: "#BAD8DF"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M330.463 321.921C330.771 321.417 331.089 320.951 331.425 320.456C332.031 319.566 332.657 318.645 333.288 317.409L333.568 317.553C332.928 318.806 332.296 319.735 331.685 320.634C331.351 321.124 331.036 321.587 330.732 322.085C329.82 323.576 329.636 325.067 330.225 326.176C330.605 326.89 333.969 330.571 337.223 334.13C339.595 336.726 341.836 339.177 342.906 340.462C345.311 343.349 347.535 343.59 349.43 343.59H361.737C361.743 342.562 361.773 336.499 361.737 329.632C361.698 322.189 360.853 320.079 360.845 320.058L361.135 319.936C361.17 320.021 362.013 322.097 362.051 329.63C362.087 336.494 362.057 342.555 362.052 343.59H392.011C393.831 343.59 393.995 343.181 394.185 342.706C394.326 342.353 394.83 340.629 395.393 333.277C395.896 326.707 394.976 323.574 394.967 323.543L394.905 323.34H395.117C395.143 323.34 395.78 323.344 397.157 323.658C398.436 323.95 400.211 324.21 402.124 324.445C401.624 323.742 400.6 322.279 400.472 321.895C400.441 321.801 400.454 321.705 400.509 321.617C400.597 321.476 400.818 321.36 401.079 321.265C401.232 321.33 401.381 321.394 401.525 321.453C401.079 321.573 400.784 321.707 400.771 321.796C400.888 322.145 402.022 323.764 402.548 324.497C403.918 324.662 405.343 324.816 406.698 324.962C409.275 325.239 411.501 325.48 412.416 325.704C413.498 325.969 416.39 326.933 418.943 327.784C421.334 328.581 423.593 329.333 423.958 329.38C424.336 329.43 424.934 329.119 425.42 328.805C425.517 328.87 425.604 328.934 425.697 328.999C425.182 329.343 424.437 329.759 423.918 329.693C423.522 329.642 421.355 328.92 418.843 328.083C416.297 327.234 413.411 326.273 412.341 326.01C411.447 325.791 409.231 325.552 406.664 325.276C405.271 325.126 403.803 324.968 402.396 324.797L402.382 324.807C402.38 324.804 402.375 324.798 402.372 324.795C400.342 324.548 398.443 324.277 397.088 323.967C396.188 323.761 395.61 323.691 395.326 323.668C395.526 324.478 396.146 327.56 395.706 333.301C395.156 340.497 394.663 342.358 394.477 342.825C394.216 343.478 393.903 343.907 392.011 343.907H349.43C348.009 343.907 345.365 343.907 342.664 340.665C341.599 339.387 339.36 336.938 336.99 334.345C333.723 330.771 330.345 327.075 329.947 326.325C329.305 325.113 329.493 323.509 330.463 321.921Z",
    fill: "#999999"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M328.619 331.951C334.917 331.951 340.021 337.056 340.021 343.354C340.021 344.258 339.905 345.133 339.706 345.976C335.579 345.976 332.845 345.976 332.327 345.976C330.326 345.976 322.771 345.216 317.292 344.622C317.246 344.205 317.218 343.784 317.218 343.354C317.217 337.056 322.321 331.951 328.619 331.951Z",
    fill: "#666666"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M406.401 345.976C405.956 345.976 402.77 345.976 397.949 345.976C397.751 345.133 397.634 344.258 397.634 343.354C397.634 337.056 402.739 331.951 409.036 331.951C415.334 331.951 420.438 337.056 420.438 343.354C420.438 344.483 420.268 345.571 419.962 346.601C417.201 346.826 414.488 347.024 413.53 347.024C411.329 347.024 408.603 345.976 406.401 345.976Z",
    fill: "#666666"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M409.036 353.42C403.477 353.42 398.971 348.914 398.971 343.354C398.971 337.795 403.477 333.288 409.036 333.288C414.595 333.288 419.101 337.795 419.101 343.354C419.101 348.914 414.595 353.42 409.036 353.42Z",
    fill: "#404040"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M402.158 343.354C402.158 347.154 405.238 350.234 409.037 350.234C412.837 350.234 415.916 347.154 415.916 343.354C415.916 339.554 412.836 336.475 409.037 336.475C405.238 336.475 402.158 339.554 402.158 343.354Z",
    fill: "#EFEFEF"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M328.619 353.42C323.06 353.42 318.554 348.914 318.554 343.354C318.554 337.795 323.06 333.288 328.619 333.288C334.178 333.288 338.684 337.795 338.684 343.354C338.684 348.914 334.178 353.42 328.619 353.42Z",
    fill: "#404040"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M328.621 350.234C324.821 350.234 321.742 347.154 321.742 343.354C321.742 339.555 324.821 336.475 328.621 336.475C332.42 336.475 335.5 339.555 335.5 343.354C335.5 347.154 332.42 350.234 328.621 350.234Z",
    fill: "#EFEFEF"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M361.148 309.774C364.257 309.909 367.872 309.814 373.534 311.032C379.196 312.251 388.514 317.206 392.289 319.565C396.063 321.925 399.327 324.284 399.327 324.284C399.327 324.284 378.803 322.632 367.912 321.767C357.02 320.902 339.406 319.762 337.283 319.526C335.16 319.29 327.06 317.009 327.218 316.576C327.375 316.143 341.293 308.909 361.148 309.774Z",
    fill: "#4F4F4F"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M363.964 320.832C363.573 320.802 363.605 320.666 363.506 320.292C363.408 319.919 362.34 311.635 362.279 311.268C362.219 310.901 362.235 310.443 362.523 310.452V310.451C362.588 310.453 362.647 310.456 362.713 310.458C365.532 310.545 368.726 310.642 373.4 311.648C379.144 312.885 388.546 317.97 391.953 320.099C392.693 320.562 393.415 321.025 394.096 321.471C395.234 322.216 394.973 323.304 393.623 323.195C386.731 322.641 375.21 321.716 367.959 321.14C366.71 321.04 365.363 320.937 363.964 320.832Z",
    fill: "#404040"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M412.378 325.856C415.916 326.368 420.556 327.626 423.27 328.766C425.983 329.906 427.909 332.069 427.752 332.895C427.595 333.721 423.309 332.855 420.242 331.44C417.175 330.024 411.993 325.801 412.378 325.856Z",
    fill: "#E0E0E0"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M335.16 316.993C335.16 316.17 336.621 313.421 338.872 312.754C343.885 311.439 350.351 310.331 357.852 310.331C357.94 310.331 358.03 310.334 358.119 310.334C358.366 310.343 358.488 310.603 358.501 310.809C358.514 311.019 358.73 319.231 358.71 319.821C358.691 320.411 358.003 320.395 358.003 320.395C354.794 320.164 351.555 319.938 348.656 319.734C342.903 319.331 338.36 319.013 337.352 318.901C337.152 318.878 336.902 318.838 336.623 318.786C335.293 318.492 335.16 317.821 335.16 316.993Z",
    fill: "#404040"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M305.328 328.569C305.679 327.296 306.266 325.217 306.853 323.345C307.189 323.003 307.803 322.579 308.867 322.488C310.702 322.33 318.643 322.382 318.749 322.488C318.854 322.593 318.775 323.405 317.543 323.982C316.376 324.528 308.082 327.474 305.252 328.83C305.277 328.744 305.303 328.663 305.328 328.569Z",
    fill: "#F7A47A"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M428.623 342.607C427.583 342.607 426.537 341.889 426.276 340.95L425.752 339.036C425.432 337.895 426.182 336.905 427.435 336.905H430.251C430.603 339.492 430.45 341.974 430.582 342.37C430.609 342.449 430.627 342.527 430.648 342.606H428.623V342.607Z",
    fill: "#4F4F4F"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M365.24 325.204C365.168 325.81 366.141 326.424 367.413 326.575C368.685 326.726 369.775 326.357 369.846 325.751C369.918 325.145 368.945 324.532 367.674 324.38C366.401 324.23 365.311 324.599 365.24 325.204Z",
    fill: "#626262"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M364.484 325.115C364.447 325.424 365.787 325.837 367.477 326.037C369.166 326.238 370.564 326.149 370.601 325.84C370.639 325.531 369.299 325.118 367.61 324.918C365.92 324.718 364.521 324.806 364.484 325.115Z",
    fill: "#CCCCCC"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M334.062 323.629C333.991 324.235 334.964 324.849 336.236 325C337.508 325.151 338.597 324.782 338.669 324.177C338.741 323.571 337.768 322.957 336.496 322.806C335.223 322.655 334.134 323.024 334.062 323.629Z",
    fill: "#626262"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M333.307 323.54C333.27 323.849 334.61 324.262 336.299 324.462C337.988 324.663 339.387 324.574 339.424 324.265C339.461 323.956 338.121 323.543 336.432 323.343C334.743 323.143 333.343 323.231 333.307 323.54Z",
    fill: "#CCCCCC"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M870.088 297.984C870.088 297.984 875.64 298.303 876.09 298.378C876.541 298.454 876.666 299.08 876.24 299.405C875.815 299.73 874.388 300.857 874.388 300.857L870.088 297.984Z",
    fill: "#F26721"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M775.208 331.052C775.208 332.653 775.559 334.455 777.612 334.806C779.664 335.156 783.67 335.507 784.921 335.507C786.173 335.507 882.301 335.507 884.203 335.507C886.106 335.507 888.91 333.904 890.161 331.751C891.413 329.599 891.112 327.896 891.112 325.943C891.112 323.99 889.01 321.537 889.01 320.586C889.01 319.634 889.01 314.878 889.01 313.876C889.01 312.874 887.781 311.072 886.343 309.82C884.904 308.569 873.939 298.855 870.785 298.104C867.631 297.353 838.943 296.401 835.288 296.501C831.633 296.601 828.779 298.254 828.078 298.554C827.377 298.855 807.852 310.02 807.401 310.171C806.95 310.321 795.334 312.274 789.927 313.625C784.52 314.977 780.763 315.626 777.812 319.284C775.509 322.138 775.208 327.449 775.208 331.052Z",
    fill: "url(#paint251_linear_811_11692)"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M778.873 318.132C778.509 318.48 778.154 318.86 777.812 319.284C775.509 322.138 775.208 327.449 775.208 331.052C775.208 332.653 775.559 334.455 777.612 334.806C779.664 335.156 783.67 335.507 784.921 335.507C786.173 335.507 882.301 335.507 884.203 335.507C886.106 335.507 888.91 333.904 890.161 331.752C891.413 329.599 891.112 327.896 891.112 325.943C891.112 323.99 889.01 321.537 889.01 320.586C889.01 320.209 889.01 319.233 889.01 318.132H778.873Z",
    fill: "url(#paint252_linear_811_11692)"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M842.67 310.461C843.027 310.436 843.161 310.152 843.218 309.946C843.274 309.739 844.988 299.863 845.044 299.524C845.101 299.186 845.283 298.776 844.856 298.778V298.775C842.458 298.78 840.208 298.802 838.392 298.83C837.341 298.846 833.06 299.731 830.394 301.196C827.727 302.661 819.729 307.993 818.415 309.045C817.1 310.096 817.326 311.937 819.692 311.937C820.808 311.936 831.559 311.219 842.67 310.461Z",
    fill: "#4F4F4F"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M869.333 307.317C868.732 305.702 865.193 300.153 862.837 299.506C860.921 298.979 854.106 298.804 847.591 298.778C847.31 298.777 847.178 298.999 847.141 299.318C847.103 299.637 846.465 309.27 846.483 309.72C846.501 310.165 846.884 310.171 846.894 310.171C857.897 309.417 868.089 308.707 868.318 308.707C869.078 308.707 869.579 307.979 869.333 307.317Z",
    fill: "#4F4F4F"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M876.733 320.41C870.47 320.41 865.393 325.487 865.393 331.751C865.393 333.07 865.629 334.33 866.043 335.507C876.432 335.507 883.697 335.507 884.206 335.507C885.266 335.507 886.606 335.008 887.802 334.194C887.975 333.407 888.073 332.591 888.073 331.751C888.073 325.487 882.996 320.41 876.733 320.41Z",
    fill: "#F26721"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M806.314 335.507C806.728 334.33 806.965 333.07 806.965 331.751C806.965 325.487 801.887 320.41 795.624 320.41C789.361 320.41 784.284 325.487 784.284 331.751C784.284 333.07 784.521 334.33 784.934 335.507C785.406 335.507 794.169 335.507 806.314 335.507Z",
    fill: "#F26721"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M795.623 341.365C800.932 341.365 805.236 337.061 805.236 331.751C805.236 326.442 800.932 322.138 795.623 322.138C790.314 322.138 786.01 326.442 786.01 331.751C786.01 337.061 790.314 341.365 795.623 341.365Z",
    fill: "#404040"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M802.192 331.751C802.192 335.38 799.251 338.322 795.622 338.322C791.993 338.322 789.052 335.38 789.052 331.751C789.052 328.122 791.994 325.181 795.622 325.181C799.251 325.181 802.192 328.122 802.192 331.751Z",
    fill: "#E6EBEC"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M876.732 341.365C882.041 341.365 886.345 337.061 886.345 331.751C886.345 326.442 882.041 322.138 876.732 322.138C871.423 322.138 867.119 326.442 867.119 331.751C867.119 337.061 871.423 341.365 876.732 341.365Z",
    fill: "#404040"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M883.3 331.751C883.3 335.38 880.359 338.322 876.731 338.322C873.102 338.322 870.161 335.38 870.161 331.751C870.161 328.122 873.102 325.181 876.731 325.181C880.36 325.181 883.3 328.122 883.3 331.751Z",
    fill: "#E6EBEC"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M862.484 298.267C860.596 297.982 842.325 297.454 837.589 297.454C836.989 297.454 836.609 297.462 836.427 297.478C834.669 297.628 832.807 298.313 831.82 298.887C831.699 298.957 819.642 305.943 815.813 308.62C811.85 311.391 809.44 313.424 809.404 318.281C809.381 321.171 809.74 323.244 810.028 324.91C810.23 326.08 810.405 327.091 810.405 328.096V332.302C810.405 332.701 810.405 333.529 811.481 333.529H858.519C859.705 333.529 859.99 332.839 860.02 332.26C860.041 331.877 860.315 329.74 863.744 325.273C864.535 324.242 865.326 323.28 866.091 322.348C868.393 319.545 870.383 317.125 870.869 314.631C871.43 311.759 871.778 308.347 868.779 304.188C865.984 300.31 864.544 298.579 862.484 298.267ZM811.481 333.228C810.764 333.228 810.705 332.809 810.705 332.302V328.096C810.705 327.065 810.528 326.042 810.324 324.858C810.038 323.205 809.682 321.146 809.704 318.283C809.741 313.475 812.115 311.573 815.986 308.866C819.804 306.197 831.849 299.217 831.971 299.147C832.93 298.589 834.742 297.923 836.451 297.777C836.623 297.763 837.006 297.755 837.589 297.755C839.314 297.755 843.098 297.852 846.625 297.945C846.467 298.817 845.143 303.075 844.778 310.381C844.538 310.724 842.967 313.206 842.861 319.556C842.783 324.251 842.887 328.113 842.955 330.669C842.985 331.74 843.007 332.591 843.01 333.229L811.481 333.228ZM870.576 314.573C870.103 316.991 868.136 319.385 865.859 322.157C865.093 323.09 864.301 324.055 863.507 325.089C860.111 329.512 859.75 331.684 859.721 332.244C859.685 332.916 859.303 333.228 858.519 333.228H843.31C843.307 332.587 843.284 331.734 843.255 330.661C843.187 328.108 843.083 324.249 843.161 319.561C843.272 312.946 845.028 310.547 845.046 310.524L845.074 310.487L845.076 310.441C845.448 302.972 846.794 298.691 846.929 297.953C853.836 298.138 861.335 298.398 862.44 298.565C864.386 298.859 865.791 300.557 868.536 304.362C871.179 308.028 871.276 310.987 870.576 314.573Z",
    fill: "#F26721"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M786.668 315.027C786.902 315.036 787.044 315.087 787.224 315.152C787.564 315.275 787.987 315.428 789.202 315.428C790.416 315.428 797.161 314.288 799.201 313.939C807.852 312.456 807.895 312.311 807.922 312.214C808.001 311.935 807.192 311.044 806.11 310.424C805.966 310.45 805.81 310.479 805.646 310.509C806.741 311.038 807.453 311.839 807.604 312.077C806.164 312.462 790.989 315.127 789.202 315.127C788.04 315.127 787.644 314.984 787.326 314.868C787.129 314.797 786.96 314.736 786.679 314.726C786.417 314.718 785.827 314.77 785.184 314.839C784.667 314.988 784.167 315.145 783.686 315.314C784.669 315.19 786.217 315.005 786.668 315.027Z",
    fill: "#F26721"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M808.693 310.96C809.106 311.26 809.988 311.204 810.664 310.809C811.34 310.415 828.312 299.769 828.537 299.637C828.763 299.506 828.801 299.13 828.65 298.923C828.583 298.831 828.352 298.678 828.119 298.537C828.107 298.542 828.091 298.55 828.08 298.554C827.404 298.844 809.228 309.235 807.528 310.11C807.841 310.338 808.402 310.749 808.693 310.96Z",
    fill: "#4F4F4F"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M778.563 331.251V329.098C778.563 328.103 777.756 327.296 776.761 327.296H775.349C775.238 328.63 775.208 329.925 775.208 331.053C775.208 331.726 775.273 332.433 775.497 333.054H776.76C777.756 333.054 778.563 332.246 778.563 331.251Z",
    fill: "#4F4F4F"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M776.187 325.181C776.293 324.522 776.888 321.087 778.165 319.835C779.441 318.582 784.123 316.679 784.523 316.855C784.924 317.03 783.171 320.61 782.095 322.138C781.019 323.665 776.04 326.101 776.187 325.181Z",
    fill: "#E6EBEC"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M780.173 321.959C779.984 322.994 779.294 323.834 778.628 323.834C777.963 323.834 777.577 322.995 777.766 321.959C777.954 320.924 778.645 320.085 779.31 320.085C779.975 320.085 780.361 320.924 780.173 321.959Z",
    fill: "#F26721"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M782.258 319.917C782.137 320.577 781.696 321.113 781.272 321.113C780.847 321.113 780.601 320.577 780.721 319.917C780.841 319.256 781.282 318.721 781.707 318.721C782.131 318.721 782.378 319.257 782.258 319.917Z",
    fill: "#B0BABA"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M886.346 315.378V318.608C886.346 319.604 887.153 320.41 888.148 320.41H889.013C889.013 319.165 889.013 314.829 889.013 313.876C889.013 313.785 888.992 313.68 888.972 313.576H888.149C887.153 313.576 886.346 314.383 886.346 315.378Z",
    fill: "#F26721"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M886.343 309.82C885.335 308.943 879.653 303.915 875.256 300.723C875.135 301.004 875.02 301.411 875.217 301.683C875.542 302.134 886.106 310.972 886.557 311.222C886.828 311.373 887.288 311.339 887.629 311.159C887.243 310.686 886.807 310.224 886.343 309.82Z",
    fill: "#4F4F4F"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M840.608 313.189H836.101C835.583 313.189 835.163 313.609 835.163 314.128H841.546C841.546 313.609 841.126 313.189 840.608 313.189Z",
    fill: "#BAD8DF"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M836.101 315.066H840.609C841.126 315.066 841.546 314.646 841.546 314.128H835.163C835.163 314.646 835.583 315.066 836.101 315.066Z",
    fill: "#F26721"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M867.641 313.189H863.134C862.616 313.189 862.196 313.609 862.196 314.128H868.579C868.579 313.609 868.159 313.189 867.641 313.189Z",
    fill: "#BAD8DF"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M863.137 315.066H867.644C868.162 315.066 868.583 314.646 868.583 314.128H862.199C862.199 314.646 862.619 315.066 863.137 315.066Z",
    fill: "#F26721"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M1062.76 334.212C1062.76 334.212 1072.15 335.069 1073.95 335.069C1075.75 335.069 1077.98 334.212 1079.78 334.212C1081.58 334.212 1138.04 334.212 1140.35 334.212C1142.67 334.212 1154.07 332.969 1156.9 332.626C1159.73 332.283 1162.64 332.283 1163.37 330.868C1164.1 329.453 1164.49 324.395 1164.06 323.152C1163.63 321.908 1163.03 322.165 1162.43 319.979C1161.83 317.793 1160.37 312.691 1159.86 312.391C1159.34 312.091 1154.03 311.748 1148.71 309.861C1143.4 307.975 1136.84 304.631 1127.11 303.731C1117.38 302.831 1108.63 303.345 1101.52 305.96C1094.4 308.575 1084.84 314.148 1082.18 314.705C1079.53 315.263 1070.99 316.549 1066.41 318.907C1061.82 321.265 1061.05 323.108 1060.49 325.595C1059.94 328.081 1060.14 330.879 1060.01 331.264C1059.88 331.65 1059.82 332.036 1060.01 332.422C1060.2 332.808 1060.91 334.046 1062.76 334.212Z",
    fill: "#E7EAEA"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M1060.49 325.595C1059.94 328.081 1060.14 330.879 1060.01 331.265C1059.88 331.65 1059.82 332.036 1060.01 332.422C1060.2 332.808 1060.91 334.046 1062.76 334.212C1062.76 334.212 1072.15 335.069 1073.95 335.069C1075.75 335.069 1077.98 334.212 1079.78 334.212C1081.58 334.212 1138.04 334.212 1140.35 334.212C1142.67 334.212 1154.07 332.968 1156.9 332.625C1159.73 332.283 1162.64 332.283 1163.37 330.868C1164.1 329.453 1164.49 324.395 1164.06 323.151C1163.63 321.908 1163.03 322.165 1162.43 319.979C1162.3 319.52 1162.14 318.931 1161.95 318.287L1060.87 324.209C1060.72 324.652 1060.6 325.111 1060.49 325.595Z",
    fill: "#B0BABA"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M1141.88 314.543C1141.63 314.13 1141.37 313.749 1141.09 313.345C1140.6 312.617 1140.09 311.864 1139.57 310.853L1139.34 310.971C1139.86 311.996 1140.38 312.755 1140.88 313.49C1141.15 313.891 1141.41 314.27 1141.66 314.677C1142.41 315.896 1142.56 317.115 1142.07 318.022C1141.76 318.606 1139.01 321.616 1136.35 324.526C1134.41 326.649 1132.58 328.653 1131.7 329.703C1129.74 332.064 1127.92 332.262 1126.37 332.262H1116.31C1116.3 331.42 1116.28 326.463 1116.31 320.848C1116.34 314.762 1117.03 313.036 1117.04 313.02L1116.8 312.92C1116.77 312.989 1116.08 314.687 1116.05 320.847C1116.02 326.459 1116.04 331.415 1116.05 332.262H1091.55C1090.06 332.262 1089.93 331.927 1089.77 331.539C1089.66 331.25 1089.25 329.841 1088.79 323.828C1088.38 318.456 1089.13 315.895 1089.14 315.869L1089.19 315.703H1089.01C1088.99 315.703 1088.47 315.706 1087.34 315.963C1086.3 316.202 1084.85 316.414 1083.28 316.607C1083.69 316.032 1084.53 314.835 1084.63 314.521C1084.66 314.445 1084.65 314.366 1084.6 314.294C1084.53 314.179 1084.35 314.084 1084.14 314.006C1084.01 314.059 1083.89 314.111 1083.77 314.16C1084.14 314.259 1084.38 314.368 1084.39 314.44C1084.29 314.726 1083.37 316.05 1082.94 316.649C1081.82 316.784 1080.65 316.91 1079.54 317.029C1077.44 317.256 1075.61 317.453 1074.87 317.636C1073.98 317.853 1071.62 318.641 1069.53 319.337C1067.57 319.988 1065.73 320.604 1065.43 320.642C1065.12 320.682 1064.63 320.429 1064.23 320.172C1064.15 320.225 1064.08 320.277 1064.01 320.33C1064.43 320.611 1065.04 320.952 1065.46 320.898C1065.79 320.856 1067.56 320.266 1069.61 319.582C1071.69 318.888 1074.05 318.101 1074.93 317.886C1075.66 317.707 1077.47 317.512 1079.57 317.286C1080.71 317.164 1081.91 317.034 1083.06 316.894L1083.07 316.903C1083.07 316.9 1083.08 316.895 1083.08 316.893C1084.74 316.691 1086.29 316.469 1087.4 316.216C1088.14 316.047 1088.61 315.99 1088.84 315.971C1088.68 316.634 1088.17 319.154 1088.53 323.848C1088.98 329.732 1089.38 331.254 1089.54 331.635C1089.75 332.17 1090.01 332.52 1091.55 332.52H1126.37C1127.53 332.52 1129.69 332.52 1131.9 329.87C1132.77 328.825 1134.6 326.822 1136.54 324.702C1139.21 321.779 1141.98 318.757 1142.3 318.144C1142.83 317.153 1142.67 315.841 1141.88 314.543Z",
    fill: "#999999"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M1143.39 322.744C1138.24 322.744 1134.06 326.918 1134.06 332.069C1134.06 332.807 1134.16 333.523 1134.32 334.212C1137.7 334.212 1139.93 334.212 1140.35 334.212C1141.99 334.212 1148.17 333.591 1152.65 333.106C1152.69 332.765 1152.71 332.42 1152.71 332.069C1152.71 326.918 1148.54 322.744 1143.39 322.744Z",
    fill: "#666666"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M1079.78 334.212C1080.15 334.212 1082.75 334.212 1086.69 334.212C1086.85 333.523 1086.95 332.808 1086.95 332.069C1086.95 326.918 1082.78 322.744 1077.63 322.744C1072.48 322.744 1068.3 326.918 1068.3 332.069C1068.3 332.992 1068.44 333.881 1068.69 334.724C1070.95 334.907 1073.17 335.069 1073.95 335.069C1075.75 335.069 1077.98 334.212 1079.78 334.212Z",
    fill: "#666666"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M1077.63 340.3C1082.17 340.3 1085.86 336.614 1085.86 332.068C1085.86 327.523 1082.17 323.837 1077.63 323.837C1073.08 323.837 1069.4 327.523 1069.4 332.068C1069.4 336.614 1073.08 340.3 1077.63 340.3Z",
    fill: "#404040"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M1083.25 332.069C1083.25 335.175 1080.73 337.694 1077.63 337.694C1074.52 337.694 1072 335.175 1072 332.069C1072 328.962 1074.52 326.443 1077.63 326.443C1080.73 326.443 1083.25 328.962 1083.25 332.069Z",
    fill: "#EFEFEF"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M1143.39 340.3C1147.93 340.3 1151.62 336.614 1151.62 332.068C1151.62 327.523 1147.93 323.837 1143.39 323.837C1138.84 323.837 1135.16 327.523 1135.16 332.068C1135.16 336.614 1138.84 340.3 1143.39 340.3Z",
    fill: "#404040"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M1143.38 337.694C1146.49 337.694 1149.01 335.176 1149.01 332.069C1149.01 328.962 1146.49 326.443 1143.38 326.443C1140.28 326.443 1137.76 328.962 1137.76 332.069C1137.76 335.176 1140.28 337.694 1143.38 337.694Z",
    fill: "#EFEFEF"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M1116.79 304.61C1114.24 304.721 1111.29 304.643 1106.66 305.639C1102.03 306.636 1094.41 310.687 1091.32 312.617C1088.24 314.546 1085.57 316.475 1085.57 316.475C1085.57 316.475 1102.35 315.124 1111.26 314.417C1120.16 313.71 1134.56 312.777 1136.3 312.584C1138.04 312.391 1144.66 310.526 1144.53 310.172C1144.4 309.819 1133.02 303.903 1116.79 304.61Z",
    fill: "#4F4F4F"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M1114.48 313.652C1114.8 313.628 1114.78 313.516 1114.86 313.211C1114.94 312.905 1115.81 306.132 1115.86 305.832C1115.91 305.531 1115.9 305.157 1115.66 305.164V305.164C1115.61 305.166 1115.56 305.168 1115.51 305.17C1113.2 305.24 1110.59 305.32 1106.77 306.142C1102.07 307.154 1094.38 311.312 1091.6 313.053C1090.99 313.431 1090.4 313.81 1089.84 314.174C1088.91 314.784 1089.13 315.673 1090.23 315.584C1095.87 315.131 1105.29 314.375 1111.22 313.904C1112.24 313.822 1113.34 313.738 1114.48 313.652Z",
    fill: "#404040"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M1074.9 317.76C1072 318.178 1068.21 319.207 1065.99 320.139C1063.77 321.072 1062.2 322.84 1062.33 323.516C1062.46 324.191 1065.96 323.483 1068.47 322.326C1070.98 321.168 1075.21 317.715 1074.9 317.76Z",
    fill: "#E0E0E0"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M1138.04 310.513C1138.04 309.841 1136.84 307.593 1135 307.047C1130.9 305.972 1125.62 305.066 1119.48 305.066C1119.41 305.066 1119.34 305.068 1119.26 305.069C1119.06 305.075 1118.96 305.288 1118.95 305.457C1118.94 305.628 1118.76 312.343 1118.78 312.825C1118.8 313.308 1119.36 313.295 1119.36 313.295C1121.98 313.106 1124.63 312.921 1127 312.755C1131.71 312.425 1135.42 312.165 1136.24 312.073C1136.41 312.055 1136.61 312.022 1136.84 311.98C1137.93 311.739 1138.04 311.19 1138.04 310.513Z",
    fill: "#404040"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M1162.43 319.979C1162.14 318.938 1161.66 317.237 1161.18 315.707C1160.91 315.427 1160.4 315.08 1159.54 315.006C1158.03 314.877 1151.54 314.92 1151.45 315.006C1151.37 315.092 1151.43 315.756 1152.44 316.228C1153.39 316.675 1160.18 319.083 1162.49 320.192C1162.47 320.121 1162.45 320.055 1162.43 319.979Z",
    fill: "url(#paint253_linear_811_11692)"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.61 331.457C1062.46 331.457 1063.32 330.87 1063.53 330.102L1063.96 328.537C1064.22 327.604 1063.61 326.795 1062.58 326.795H1060.28C1059.99 328.91 1060.12 330.94 1060.01 331.264C1059.99 331.328 1059.97 331.392 1059.96 331.456H1061.61V331.457Z",
    fill: "#4F4F4F"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M1113.44 317.227C1113.5 317.723 1112.7 318.225 1111.66 318.348C1110.62 318.472 1109.73 318.17 1109.67 317.674C1109.61 317.179 1110.41 316.677 1111.45 316.553C1112.49 316.43 1113.38 316.732 1113.44 317.227Z",
    fill: "#626262"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M1114.06 317.154C1114.09 317.407 1112.99 317.745 1111.61 317.908C1110.23 318.073 1109.09 318 1109.06 317.747C1109.03 317.495 1110.12 317.157 1111.5 316.993C1112.88 316.83 1114.03 316.902 1114.06 317.154Z",
    fill: "#CCCCCC"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M1138.94 315.939C1138.99 316.434 1138.2 316.936 1137.16 317.06C1136.12 317.183 1135.23 316.881 1135.17 316.387C1135.11 315.891 1135.91 315.39 1136.95 315.266C1137.99 315.142 1138.88 315.444 1138.94 315.939Z",
    fill: "#626262"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M1139.55 315.866C1139.58 316.118 1138.49 316.456 1137.11 316.62C1135.73 316.784 1134.58 316.712 1134.55 316.459C1134.52 316.206 1135.62 315.868 1137 315.705C1138.38 315.541 1139.52 315.613 1139.55 315.866Z",
    fill: "#CCCCCC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_811_11692",
    x: -9,
    y: 340.333,
    width: 1457.07,
    height: 214.667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_811_11692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_811_11692",
    x1: 419.895,
    y1: 553,
    x2: 282.605,
    y2: 519.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_811_11692",
    x1: 751.915,
    y1: 519.588,
    x2: 889.6,
    y2: 481.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_811_11692",
    x1: 281.028,
    y1: 490.472,
    x2: 207.561,
    y2: 475.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_811_11692",
    x1: 271.746,
    y1: 497.941,
    x2: 225.204,
    y2: 482.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_811_11692",
    x1: 263.234,
    y1: 502.68,
    x2: 237.418,
    y2: 494.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_811_11692",
    x1: 259.855,
    y1: 506.751,
    x2: 242.261,
    y2: 500.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_811_11692",
    x1: 252.255,
    y1: 513.959,
    x2: 250.145,
    y2: 513.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_811_11692",
    x1: 254.571,
    y1: 519.681,
    x2: 252.462,
    y2: 519.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_811_11692",
    x1: 282.543,
    y1: 490.738,
    x2: 282.346,
    y2: 486.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_811_11692",
    x1: 273.141,
    y1: 498.475,
    x2: 272.875,
    y2: 494.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_811_11692",
    x1: 264.233,
    y1: 503.129,
    x2: 263.962,
    y2: 500.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_811_11692",
    x1: 243.718,
    y1: 496.165,
    x2: 241.372,
    y2: 495.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_811_11692",
    x1: 246.994,
    y1: 496.165,
    x2: 244.647,
    y2: 495.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_811_11692",
    x1: 250.271,
    y1: 496.165,
    x2: 247.923,
    y2: 495.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_811_11692",
    x1: 253.546,
    y1: 496.165,
    x2: 251.2,
    y2: 495.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_811_11692",
    x1: 256.823,
    y1: 496.165,
    x2: 254.476,
    y2: 495.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_811_11692",
    x1: 260.099,
    y1: 496.165,
    x2: 257.752,
    y2: 495.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_811_11692",
    x1: 263.375,
    y1: 496.165,
    x2: 261.028,
    y2: 495.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_811_11692",
    x1: 240.61,
    y1: 486.317,
    x2: 235.288,
    y2: 484.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_811_11692",
    x1: 246.276,
    y1: 486.317,
    x2: 240.953,
    y2: 484.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_811_11692",
    x1: 251.944,
    y1: 486.317,
    x2: 246.622,
    y2: 484.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_811_11692",
    x1: 257.609,
    y1: 486.317,
    x2: 252.286,
    y2: 484.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_811_11692",
    x1: 263.277,
    y1: 486.317,
    x2: 257.955,
    y2: 484.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_811_11692",
    x1: 268.942,
    y1: 486.317,
    x2: 263.619,
    y2: 484.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_811_11692",
    x1: 240.61,
    y1: 477.832,
    x2: 235.288,
    y2: 476.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_811_11692",
    x1: 246.276,
    y1: 477.832,
    x2: 240.954,
    y2: 476.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_811_11692",
    x1: 251.944,
    y1: 477.832,
    x2: 246.622,
    y2: 476.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_811_11692",
    x1: 257.609,
    y1: 477.832,
    x2: 252.287,
    y2: 476.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_811_11692",
    x1: 263.277,
    y1: 477.832,
    x2: 257.955,
    y2: 476.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_811_11692",
    x1: 268.942,
    y1: 477.832,
    x2: 263.62,
    y2: 476.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_811_11692",
    x1: 240.61,
    y1: 469.347,
    x2: 235.288,
    y2: 467.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_811_11692",
    x1: 246.276,
    y1: 469.347,
    x2: 240.953,
    y2: 467.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_811_11692",
    x1: 251.944,
    y1: 469.347,
    x2: 246.622,
    y2: 467.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_811_11692",
    x1: 257.609,
    y1: 469.347,
    x2: 252.286,
    y2: 467.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_811_11692",
    x1: 263.277,
    y1: 469.347,
    x2: 257.955,
    y2: 467.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_811_11692",
    x1: 268.942,
    y1: 469.347,
    x2: 263.619,
    y2: 467.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_811_11692",
    x1: 240.61,
    y1: 460.862,
    x2: 235.288,
    y2: 459.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_811_11692",
    x1: 246.276,
    y1: 460.862,
    x2: 240.953,
    y2: 459.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_811_11692",
    x1: 251.944,
    y1: 460.862,
    x2: 246.622,
    y2: 459.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_811_11692",
    x1: 257.609,
    y1: 460.862,
    x2: 252.286,
    y2: 459.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_811_11692",
    x1: 263.277,
    y1: 460.862,
    x2: 257.955,
    y2: 459.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_811_11692",
    x1: 268.942,
    y1: 460.862,
    x2: 263.619,
    y2: 459.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_811_11692",
    x1: 240.61,
    y1: 452.377,
    x2: 235.288,
    y2: 450.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_811_11692",
    x1: 246.276,
    y1: 452.377,
    x2: 240.953,
    y2: 450.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_811_11692",
    x1: 251.944,
    y1: 452.377,
    x2: 246.622,
    y2: 450.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_811_11692",
    x1: 257.609,
    y1: 452.377,
    x2: 252.286,
    y2: 450.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_811_11692",
    x1: 263.277,
    y1: 452.377,
    x2: 257.955,
    y2: 450.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_811_11692",
    x1: 268.942,
    y1: 452.377,
    x2: 263.619,
    y2: 450.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_811_11692",
    x1: 240.61,
    y1: 443.892,
    x2: 235.288,
    y2: 442.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_811_11692",
    x1: 246.276,
    y1: 443.892,
    x2: 240.953,
    y2: 442.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_811_11692",
    x1: 251.944,
    y1: 443.892,
    x2: 246.622,
    y2: 442.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_811_11692",
    x1: 257.609,
    y1: 443.892,
    x2: 252.286,
    y2: 442.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_811_11692",
    x1: 263.277,
    y1: 443.892,
    x2: 257.955,
    y2: 442.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_811_11692",
    x1: 268.942,
    y1: 443.892,
    x2: 263.619,
    y2: 442.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_811_11692",
    x1: 240.61,
    y1: 435.408,
    x2: 235.288,
    y2: 433.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_811_11692",
    x1: 246.276,
    y1: 435.408,
    x2: 240.953,
    y2: 433.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_811_11692",
    x1: 251.944,
    y1: 435.408,
    x2: 246.622,
    y2: 433.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_811_11692",
    x1: 257.609,
    y1: 435.408,
    x2: 252.286,
    y2: 433.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_811_11692",
    x1: 263.277,
    y1: 435.408,
    x2: 257.955,
    y2: 433.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_811_11692",
    x1: 268.942,
    y1: 435.408,
    x2: 263.619,
    y2: 433.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_811_11692",
    x1: 240.61,
    y1: 426.923,
    x2: 235.288,
    y2: 425.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_811_11692",
    x1: 246.276,
    y1: 426.923,
    x2: 240.954,
    y2: 425.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_811_11692",
    x1: 251.944,
    y1: 426.923,
    x2: 246.622,
    y2: 425.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_811_11692",
    x1: 257.609,
    y1: 426.923,
    x2: 252.287,
    y2: 425.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_811_11692",
    x1: 263.277,
    y1: 426.923,
    x2: 257.955,
    y2: 425.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_811_11692",
    x1: 268.942,
    y1: 426.923,
    x2: 263.62,
    y2: 425.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_811_11692",
    x1: 240.61,
    y1: 418.438,
    x2: 235.288,
    y2: 416.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_811_11692",
    x1: 246.276,
    y1: 418.438,
    x2: 240.953,
    y2: 416.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_811_11692",
    x1: 251.944,
    y1: 418.438,
    x2: 246.622,
    y2: 416.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_811_11692",
    x1: 257.609,
    y1: 418.438,
    x2: 252.286,
    y2: 416.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_811_11692",
    x1: 263.277,
    y1: 418.438,
    x2: 257.955,
    y2: 416.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_811_11692",
    x1: 268.942,
    y1: 418.438,
    x2: 263.619,
    y2: 416.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_811_11692",
    x1: 240.61,
    y1: 409.953,
    x2: 235.288,
    y2: 408.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_811_11692",
    x1: 246.276,
    y1: 409.953,
    x2: 240.953,
    y2: 408.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_811_11692",
    x1: 251.944,
    y1: 409.953,
    x2: 246.622,
    y2: 408.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_811_11692",
    x1: 257.609,
    y1: 409.953,
    x2: 252.286,
    y2: 408.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_811_11692",
    x1: 263.277,
    y1: 409.953,
    x2: 257.955,
    y2: 408.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_811_11692",
    x1: 268.942,
    y1: 409.953,
    x2: 263.619,
    y2: 408.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_811_11692",
    x1: 240.61,
    y1: 401.468,
    x2: 235.288,
    y2: 399.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_811_11692",
    x1: 246.276,
    y1: 401.468,
    x2: 240.953,
    y2: 399.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_811_11692",
    x1: 251.944,
    y1: 401.468,
    x2: 246.622,
    y2: 399.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_811_11692",
    x1: 257.609,
    y1: 401.468,
    x2: 252.286,
    y2: 399.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_811_11692",
    x1: 263.277,
    y1: 401.468,
    x2: 257.955,
    y2: 399.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_811_11692",
    x1: 268.942,
    y1: 401.468,
    x2: 263.619,
    y2: 399.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_811_11692",
    x1: 199.897,
    y1: 486.508,
    x2: 93.0849,
    y2: 444.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_811_11692",
    x1: 202.494,
    y1: 488.018,
    x2: 201.884,
    y2: 479.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_811_11692",
    x1: 196.829,
    y1: 491.193,
    x2: 183.03,
    y2: 453.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_811_11692",
    x1: 158.321,
    y1: 496.018,
    x2: 135.149,
    y2: 473.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_811_11692",
    x1: 146.485,
    y1: 499.169,
    x2: 134.319,
    y2: 486.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_811_11692",
    x1: 137.042,
    y1: 504.799,
    x2: 134.498,
    y2: 504.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_811_11692",
    x1: 137.795,
    y1: 506.366,
    x2: 135.037,
    y2: 504.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_811_11692",
    x1: 707.03,
    y1: 521.105,
    x2: 570.132,
    y2: 476.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_811_11692",
    x1: 1033.6,
    y1: 393.649,
    x2: 1032.22,
    y2: 346.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_811_11692",
    x1: 1298.29,
    y1: 511.91,
    x2: 1295.1,
    y2: 511.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_811_11692",
    x1: 255.396,
    y1: 395.583,
    x2: 247.057,
    y2: 379.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_811_11692",
    x1: 268.498,
    y1: 388.328,
    x2: 260.156,
    y2: 372.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_811_11692",
    x1: 251.076,
    y1: 388.327,
    x2: 242.736,
    y2: 372.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_811_11692",
    x1: 272.811,
    y1: 395.583,
    x2: 264.469,
    y2: 379.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_811_11692",
    x1: 285.731,
    y1: 388.328,
    x2: 277.39,
    y2: 372.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_811_11692",
    x1: 290.045,
    y1: 395.583,
    x2: 281.703,
    y2: 379.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_811_11692",
    x1: 1518.86,
    y1: 534.312,
    x2: 1343.64,
    y2: 116.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_811_11692",
    x1: 927.136,
    y1: 343.715,
    x2: 927.136,
    y2: 447.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00012425,
    stopColor: "#032642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4952,
    stopColor: "#0D3D5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155278"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_811_11692",
    x1: 937.186,
    y1: 429.843,
    x2: 927.335,
    y2: 429.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_811_11692",
    x1: 950.747,
    y1: 429.843,
    x2: 940.897,
    y2: 429.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_811_11692",
    x1: 1266.64,
    y1: 429.843,
    x2: 1256.79,
    y2: 429.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_811_11692",
    x1: 1280.2,
    y1: 429.843,
    x2: 1270.35,
    y2: 429.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_811_11692",
    x1: 1064.83,
    y1: 390.486,
    x2: 1056.49,
    y2: 374.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_811_11692",
    x1: 1077.93,
    y1: 383.231,
    x2: 1069.59,
    y2: 367.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_811_11692",
    x1: 1060.51,
    y1: 383.23,
    x2: 1052.17,
    y2: 367.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_811_11692",
    x1: 1082.24,
    y1: 390.486,
    x2: 1073.9,
    y2: 374.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_811_11692",
    x1: 1095.16,
    y1: 383.231,
    x2: 1086.82,
    y2: 367.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_811_11692",
    x1: 1099.48,
    y1: 390.486,
    x2: 1091.13,
    y2: 374.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_811_11692",
    x1: 679.942,
    y1: 395.352,
    x2: 670.438,
    y2: 375.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_811_11692",
    x1: 697.393,
    y1: 386.589,
    x2: 687.886,
    y2: 366.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_811_11692",
    x1: 674.184,
    y1: 386.588,
    x2: 664.679,
    y2: 366.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_811_11692",
    x1: 703.147,
    y1: 395.352,
    x2: 693.64,
    y2: 375.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_811_11692",
    x1: 720.356,
    y1: 386.589,
    x2: 710.85,
    y2: 366.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_811_11692",
    x1: 726.114,
    y1: 395.352,
    x2: 716.607,
    y2: 375.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_811_11692",
    x1: 716.542,
    y1: 385.474,
    x2: 709.741,
    y2: 371.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_811_11692",
    x1: 729.037,
    y1: 379.203,
    x2: 722.234,
    y2: 365.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_811_11692",
    x1: 712.427,
    y1: 379.203,
    x2: 705.626,
    y2: 365.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_811_11692",
    x1: 733.156,
    y1: 385.475,
    x2: 726.353,
    y2: 371.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_811_11692",
    x1: 745.467,
    y1: 379.203,
    x2: 738.664,
    y2: 365.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_811_11692",
    x1: 749.586,
    y1: 385.475,
    x2: 742.783,
    y2: 371.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_811_11692",
    x1: 888.218,
    y1: 380.842,
    x2: 879.099,
    y2: 336.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_811_11692",
    x1: 888.218,
    y1: 368.278,
    x2: 886.349,
    y2: 347.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_811_11692",
    x1: 1159.57,
    y1: 370.14,
    x2: 1157.89,
    y2: 364.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_811_11692",
    x1: 422.821,
    y1: 0.0000112192,
    x2: 280.228,
    y2: 20.1849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_811_11692",
    x1: 754.841,
    y1: 57.5432,
    x2: 899.169,
    y2: 80.4373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_811_11692",
    x1: 283.954,
    y1: 107.688,
    x2: 208.485,
    y2: 116.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_811_11692",
    x1: 274.672,
    y1: 94.8235,
    x2: 224.945,
    y2: 104.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_811_11692",
    x1: 266.16,
    y1: 86.6625,
    x2: 238.577,
    y2: 91.9005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_811_11692",
    x1: 262.78,
    y1: 79.651,
    x2: 243.982,
    y2: 83.2207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_811_11692",
    x1: 255.181,
    y1: 67.2372,
    x2: 253.069,
    y2: 67.2808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_811_11692",
    x1: 257.497,
    y1: 57.3832,
    x2: 255.386,
    y2: 57.4267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_811_11692",
    x1: 285.468,
    y1: 107.228,
    x2: 284.887,
    y2: 114.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_811_11692",
    x1: 276.067,
    y1: 93.9034,
    x2: 275.285,
    y2: 100.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_811_11692",
    x1: 267.158,
    y1: 85.8886,
    x2: 266.369,
    y2: 90.8415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_811_11692",
    x1: 246.643,
    y1: 97.8833,
    x2: 244.265,
    y2: 98.0835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_811_11692",
    x1: 249.92,
    y1: 97.8833,
    x2: 247.54,
    y2: 98.0842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_811_11692",
    x1: 253.196,
    y1: 97.8833,
    x2: 250.816,
    y2: 98.0842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_811_11692",
    x1: 256.472,
    y1: 97.8833,
    x2: 254.093,
    y2: 98.0842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_811_11692",
    x1: 259.748,
    y1: 97.8833,
    x2: 257.369,
    y2: 98.0842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_811_11692",
    x1: 263.025,
    y1: 97.8833,
    x2: 260.645,
    y2: 98.0842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_811_11692",
    x1: 266.301,
    y1: 97.8833,
    x2: 263.921,
    y2: 98.0842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_811_11692",
    x1: 243.536,
    y1: 114.843,
    x2: 237.914,
    y2: 115.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_811_11692",
    x1: 249.201,
    y1: 114.843,
    x2: 243.58,
    y2: 115.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_811_11692",
    x1: 254.87,
    y1: 114.843,
    x2: 249.248,
    y2: 115.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_811_11692",
    x1: 260.534,
    y1: 114.843,
    x2: 254.913,
    y2: 115.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_811_11692",
    x1: 266.203,
    y1: 114.843,
    x2: 260.581,
    y2: 115.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_811_11692",
    x1: 271.868,
    y1: 114.843,
    x2: 266.246,
    y2: 115.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_811_11692",
    x1: 243.536,
    y1: 129.456,
    x2: 237.914,
    y2: 130.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_811_11692",
    x1: 249.201,
    y1: 129.456,
    x2: 243.58,
    y2: 130.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_811_11692",
    x1: 254.87,
    y1: 129.456,
    x2: 249.248,
    y2: 130.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_811_11692",
    x1: 260.534,
    y1: 129.456,
    x2: 254.913,
    y2: 130.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_811_11692",
    x1: 266.203,
    y1: 129.456,
    x2: 260.581,
    y2: 130.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_811_11692",
    x1: 271.868,
    y1: 129.456,
    x2: 266.246,
    y2: 130.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_811_11692",
    x1: 243.536,
    y1: 144.069,
    x2: 237.914,
    y2: 145.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_811_11692",
    x1: 249.201,
    y1: 144.069,
    x2: 243.58,
    y2: 145.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_811_11692",
    x1: 254.87,
    y1: 144.069,
    x2: 249.248,
    y2: 145.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_811_11692",
    x1: 260.534,
    y1: 144.069,
    x2: 254.913,
    y2: 145.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_811_11692",
    x1: 266.203,
    y1: 144.069,
    x2: 260.581,
    y2: 145.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_811_11692",
    x1: 271.868,
    y1: 144.069,
    x2: 266.246,
    y2: 145.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_811_11692",
    x1: 243.536,
    y1: 158.681,
    x2: 237.914,
    y2: 159.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_811_11692",
    x1: 249.201,
    y1: 158.681,
    x2: 243.58,
    y2: 159.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_811_11692",
    x1: 254.87,
    y1: 158.681,
    x2: 249.248,
    y2: 159.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_811_11692",
    x1: 260.534,
    y1: 158.681,
    x2: 254.913,
    y2: 159.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_811_11692",
    x1: 266.203,
    y1: 158.681,
    x2: 260.581,
    y2: 159.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_811_11692",
    x1: 271.868,
    y1: 158.681,
    x2: 266.246,
    y2: 159.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_811_11692",
    x1: 243.536,
    y1: 173.295,
    x2: 237.914,
    y2: 174.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_811_11692",
    x1: 249.201,
    y1: 173.295,
    x2: 243.58,
    y2: 174.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_811_11692",
    x1: 254.87,
    y1: 173.295,
    x2: 249.248,
    y2: 174.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_811_11692",
    x1: 260.534,
    y1: 173.295,
    x2: 254.913,
    y2: 174.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_811_11692",
    x1: 266.203,
    y1: 173.295,
    x2: 260.581,
    y2: 174.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_811_11692",
    x1: 271.868,
    y1: 173.295,
    x2: 266.246,
    y2: 174.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_811_11692",
    x1: 243.536,
    y1: 187.908,
    x2: 237.914,
    y2: 188.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_811_11692",
    x1: 249.201,
    y1: 187.908,
    x2: 243.58,
    y2: 188.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_811_11692",
    x1: 254.87,
    y1: 187.908,
    x2: 249.248,
    y2: 188.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_811_11692",
    x1: 260.534,
    y1: 187.908,
    x2: 254.913,
    y2: 188.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_811_11692",
    x1: 266.203,
    y1: 187.908,
    x2: 260.581,
    y2: 188.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_811_11692",
    x1: 271.868,
    y1: 187.908,
    x2: 266.246,
    y2: 188.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_811_11692",
    x1: 243.536,
    y1: 202.52,
    x2: 237.914,
    y2: 203.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_811_11692",
    x1: 249.201,
    y1: 202.52,
    x2: 243.58,
    y2: 203.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_811_11692",
    x1: 254.87,
    y1: 202.52,
    x2: 249.248,
    y2: 203.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_811_11692",
    x1: 260.534,
    y1: 202.52,
    x2: 254.913,
    y2: 203.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_811_11692",
    x1: 266.203,
    y1: 202.52,
    x2: 260.581,
    y2: 203.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_811_11692",
    x1: 271.868,
    y1: 202.52,
    x2: 266.246,
    y2: 203.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_811_11692",
    x1: 243.536,
    y1: 217.133,
    x2: 237.914,
    y2: 218.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_811_11692",
    x1: 249.201,
    y1: 217.133,
    x2: 243.58,
    y2: 218.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_811_11692",
    x1: 254.87,
    y1: 217.133,
    x2: 249.248,
    y2: 218.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_811_11692",
    x1: 260.534,
    y1: 217.133,
    x2: 254.913,
    y2: 218.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_811_11692",
    x1: 266.203,
    y1: 217.133,
    x2: 260.581,
    y2: 218.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_811_11692",
    x1: 271.868,
    y1: 217.133,
    x2: 266.246,
    y2: 218.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_811_11692",
    x1: 243.536,
    y1: 231.746,
    x2: 237.914,
    y2: 232.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_811_11692",
    x1: 249.201,
    y1: 231.746,
    x2: 243.58,
    y2: 232.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_811_11692",
    x1: 254.87,
    y1: 231.746,
    x2: 249.248,
    y2: 232.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_811_11692",
    x1: 260.534,
    y1: 231.746,
    x2: 254.913,
    y2: 232.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_811_11692",
    x1: 266.203,
    y1: 231.746,
    x2: 260.581,
    y2: 232.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_811_11692",
    x1: 271.868,
    y1: 231.746,
    x2: 266.246,
    y2: 232.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_811_11692",
    x1: 243.536,
    y1: 246.359,
    x2: 237.914,
    y2: 247.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_811_11692",
    x1: 249.201,
    y1: 246.359,
    x2: 243.58,
    y2: 247.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_811_11692",
    x1: 254.87,
    y1: 246.359,
    x2: 249.248,
    y2: 247.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_811_11692",
    x1: 260.534,
    y1: 246.359,
    x2: 254.913,
    y2: 247.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_811_11692",
    x1: 266.203,
    y1: 246.359,
    x2: 260.581,
    y2: 247.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_811_11692",
    x1: 271.868,
    y1: 246.359,
    x2: 266.246,
    y2: 247.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_811_11692",
    x1: 243.536,
    y1: 260.971,
    x2: 237.914,
    y2: 261.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_811_11692",
    x1: 249.201,
    y1: 260.971,
    x2: 243.58,
    y2: 261.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_811_11692",
    x1: 254.87,
    y1: 260.971,
    x2: 249.248,
    y2: 261.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_811_11692",
    x1: 260.534,
    y1: 260.971,
    x2: 254.913,
    y2: 261.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_811_11692",
    x1: 266.203,
    y1: 260.971,
    x2: 260.581,
    y2: 261.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_811_11692",
    x1: 271.868,
    y1: 260.971,
    x2: 266.246,
    y2: 261.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_811_11692",
    x1: 202.822,
    y1: 114.514,
    x2: 85.7885,
    y2: 140.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_811_11692",
    x1: 205.42,
    y1: 111.914,
    x2: 203.627,
    y2: 127.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_811_11692",
    x1: 199.755,
    y1: 106.446,
    x2: 166.653,
    y2: 158.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_811_11692",
    x1: 161.247,
    y1: 98.1357,
    x2: 126.926,
    y2: 117.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_811_11692",
    x1: 149.411,
    y1: 92.7086,
    x2: 130.514,
    y2: 104.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_811_11692",
    x1: 139.968,
    y1: 83.0132,
    x2: 137.42,
    y2: 83.0828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_811_11692",
    x1: 140.72,
    y1: 80.3148,
    x2: 136.975,
    y2: 82.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_811_11692",
    x1: 709.956,
    y1: 54.9302,
    x2: 563.734,
    y2: 82.6295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_811_11692",
    x1: 1036.53,
    y1: 274.437,
    x2: 1032.45,
    y2: 355.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_811_11692",
    x1: 1301.21,
    y1: 70.7661,
    x2: 1298.03,
    y2: 70.8132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_811_11692",
    x1: 258.322,
    y1: 271.107,
    x2: 241.09,
    y2: 289.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_811_11692",
    x1: 271.424,
    y1: 283.603,
    x2: 254.189,
    y2: 302.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_811_11692",
    x1: 254.001,
    y1: 283.603,
    x2: 236.769,
    y2: 302.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_811_11692",
    x1: 275.737,
    y1: 271.107,
    x2: 258.501,
    y2: 289.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_811_11692",
    x1: 288.657,
    y1: 283.603,
    x2: 271.422,
    y2: 302.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_811_11692",
    x1: 292.971,
    y1: 271.107,
    x2: 275.735,
    y2: 289.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_811_11692",
    x1: 1521.78,
    y1: 32.1852,
    x2: 1120.31,
    y2: 587.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_811_11692",
    x1: 930.062,
    y1: 360.435,
    x2: 930.062,
    y2: 182.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00012425,
    stopColor: "#032642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4952,
    stopColor: "#0D3D5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155278"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_811_11692",
    x1: 940.111,
    y1: 212.103,
    x2: 930.248,
    y2: 212.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_811_11692",
    x1: 953.673,
    y1: 212.103,
    x2: 943.81,
    y2: 212.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_811_11692",
    x1: 1269.56,
    y1: 212.103,
    x2: 1259.7,
    y2: 212.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_811_11692",
    x1: 1283.13,
    y1: 212.103,
    x2: 1273.26,
    y2: 212.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_811_11692",
    x1: 1067.75,
    y1: 279.885,
    x2: 1050.52,
    y2: 298.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_811_11692",
    x1: 1080.85,
    y1: 292.381,
    x2: 1063.62,
    y2: 311.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_811_11692",
    x1: 1063.43,
    y1: 292.381,
    x2: 1046.2,
    y2: 311.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_811_11692",
    x1: 1085.17,
    y1: 279.885,
    x2: 1067.93,
    y2: 298.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_811_11692",
    x1: 1098.09,
    y1: 292.381,
    x2: 1080.85,
    y2: 311.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_811_11692",
    x1: 1102.4,
    y1: 279.885,
    x2: 1085.17,
    y2: 298.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_811_11692",
    x1: 682.866,
    y1: 271.506,
    x2: 662.326,
    y2: 296.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_811_11692",
    x1: 700.318,
    y1: 286.598,
    x2: 679.774,
    y2: 311.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_811_11692",
    x1: 677.111,
    y1: 286.599,
    x2: 656.57,
    y2: 311.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_811_11692",
    x1: 706.073,
    y1: 271.505,
    x2: 685.528,
    y2: 296.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_811_11692",
    x1: 723.283,
    y1: 286.598,
    x2: 702.74,
    y2: 311.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_811_11692",
    x1: 729.038,
    y1: 271.505,
    x2: 708.493,
    y2: 296.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_811_11692",
    x1: 719.468,
    y1: 288.516,
    x2: 704.77,
    y2: 306.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_811_11692",
    x1: 731.961,
    y1: 299.316,
    x2: 717.26,
    y2: 316.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_811_11692",
    x1: 715.352,
    y1: 299.317,
    x2: 700.652,
    y2: 316.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_811_11692",
    x1: 736.08,
    y1: 288.516,
    x2: 721.379,
    y2: 306.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_811_11692",
    x1: 748.393,
    y1: 299.316,
    x2: 733.692,
    y2: 316.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_811_11692",
    x1: 752.513,
    y1: 288.516,
    x2: 737.811,
    y2: 306.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F8297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448113,
    stopColor: "#166C7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_811_11692",
    x1: 891.144,
    y1: 296.494,
    x2: 866.078,
    y2: 367.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_811_11692",
    x1: 891.144,
    y1: 318.132,
    x2: 885.688,
    y2: 352.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_811_11692",
    x1: 1162.49,
    y1: 314.925,
    x2: 1158.18,
    y2: 323.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A47A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F26721"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingPagerevisedillustration1);
export default __webpack_public_path__ + "static/media/Landing Page revised illustration 1.4947ce7a6fefba0f311dae4a24291ee6.svg";
export { ForwardRef as ReactComponent };